function numeralFemaleEnding(condition) {
    var m10 = condition % 10;
    var m100 = condition % 100;
    if (m10 === 1 && m100 !== 11) {
        return condition + "-st";
    }
    if (m10 === 2 && m100 !== 12) {
        return condition + "-nd";
    }
    if (m10 === 3 && m100 !== 13) {
        return condition + "-d";
    }
    return condition + "-th";
}
function numeralMaleEnding(condition) {
    var m10 = condition % 10;
    var m100 = condition % 100;
    if (m10 === 1 && m100 !== 11) {
        return condition + "-st";
    }
    if (m10 === 2 && m100 !== 12) {
        return condition + "-nd";
    }
    if (m10 === 3 && m100 !== 13) {
        return condition + "-d";
    }
    return condition + "-th";
}
function numeralNeuterEnding(condition) {
    var m10 = condition % 10;
    var m100 = condition % 100;
    if (m10 === 1 && m100 !== 11) {
        return condition + "-st";
    }
    if (m10 === 2 && m100 !== 12) {
        return condition + "-nd";
    }
    if (m10 === 3 && m100 !== 13) {
        return condition + "-d";
    }
    return condition + "-th";
}
function plural(count, parameters) {
    return count === 1 ? parameters[0] : parameters[1];
}
function signed(condition) {
    if (condition === 0) {
        return '0';
    }
    var num = Number.parseFloat(condition.toFixed(2));
    if (condition > 0) {
        return '+' + num.toString();
    }
    return num.toString();
}
function europeanHandicapCondition(condition) {
    if (condition < 0) {
        return "0:" + Math.abs(condition);
    }
    else {
        return Math.abs(condition) + ":0";
    }
}
var bo_b1 = function (match, outcome) { return 'Handicap'; };
var bo_c1 = function (match, outcome) { return 'Game Total'; };
var bo_d1 = function (match, outcome) { return "".concat(match.homeTeam, " Total"); };
var bo_e1 = function (match, outcome) { return "".concat(match.awayTeam, " Total"); };
var bo_f1 = function (match, outcome) { return 'Game Total Even/Odd'; };
var bo_g1 = function (match, outcome) { return "".concat(match.homeTeam, " - ").concat(match.awayTeam); };
var bo_h1 = function (match, outcome) { return "".concat(outcome.teamOne, " - ").concat(outcome.teamTwo); };
var bo_i1 = function (match, outcome) { return "".concat(outcome.teamOne); };
var bo_j1 = function (match, outcome) { return 'Match Total'; };
var bo_k1 = function (match, outcome) { return 'First Game Handicap'; };
var bo_l1 = function (match, outcome) { return 'Second Game Handicap'; };
var bo_m1 = function (match, outcome) { return 'Third Game Handicap'; };
var bo_n1 = function (match, outcome) { return 'First Game Total'; };
var bo_o1 = function (match, outcome) { return 'Second Game Total'; };
var bo_p1 = function (match, outcome) { return 'Third Game Total'; };
var bo_q1 = function (match, outcome) { return 'Total Games In Match'; };
var bo_r1 = function (match, outcome) { return 'Match Score'; };
var bo_s1 = function (match, outcome) { return 'Match Total Even/Odd'; };
var bo_t1 = function (match, outcome) { return 'First Game Winner'; };
var bo_u1 = function (match, outcome) { return 'Second Game Winner'; };
var bo_v1 = function (match, outcome) { return 'Third Game Winner'; };
var bo_w1 = function (match, outcome) { return "".concat(match.homeTeam, " First Game Total"); };
var bo_x1 = function (match, outcome) { return "".concat(match.homeTeam, " Second Game Total"); };
var bo_y1 = function (match, outcome) { return "".concat(match.homeTeam, " Third Game Total"); };
var bo_z1 = function (match, outcome) { return "".concat(match.awayTeam, " First Game Total"); };
var bo_a2 = function (match, outcome) { return "".concat(match.awayTeam, " Second Game Total"); };
var bo_b2 = function (match, outcome) { return "".concat(match.awayTeam, " Third Game Total"); };
var bo_c2 = function (match, outcome) { return "".concat(match.homeTeam, " First Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_d2 = function (match, outcome) { return "".concat(match.homeTeam, " Second Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_e2 = function (match, outcome) { return "".concat(match.homeTeam, " Third Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_f2 = function (match, outcome) { return "".concat(match.awayTeam, " First Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_g2 = function (match, outcome) { return "".concat(match.awayTeam, " Second Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_h2 = function (match, outcome) { return "".concat(match.awayTeam, " Third Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_i2 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " - First Game"); };
var bo_j2 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " - Second Game"); };
var bo_k2 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " - Third Game"); };
var bo_l2 = function (match, outcome) { return "To Score ".concat(numeralNeuterEnding(outcome.condition), " Point - First Game"); };
var bo_m2 = function (match, outcome) { return "To Score ".concat(numeralNeuterEnding(outcome.condition), " Point - Second Game"); };
var bo_n2 = function (match, outcome) { return "To Score ".concat(numeralNeuterEnding(outcome.condition), " Point - Third Game"); };
var bo_o2 = function (match, outcome) { return "".concat(match.homeTeam, " Match Total"); };
var bo_p2 = function (match, outcome) { return "".concat(match.awayTeam, " Match Total"); };
var bo_q2 = function (match, outcome) { return '10 Points Miniset Winner - First Set'; };
var bo_r2 = function (match, outcome) { return '10 Points Miniset Winner - Second Set'; };
var bo_s2 = function (match, outcome) { return '10 Points Miniset Winner - Third Set'; };
var bo_t2 = function (match, outcome) { return '10 Points Miniset Handicap - First Set'; };
var bo_u2 = function (match, outcome) { return '10 Points Miniset Handicap - Second Set'; };
var bo_v2 = function (match, outcome) { return '10 Points Miniset Handicap - Third Set'; };
var bo_w2 = function (match, outcome) { return '10 Points Miniset Total - First Set'; };
var bo_x2 = function (match, outcome) { return '10 Points Miniset Total - Second Set'; };
var bo_y2 = function (match, outcome) { return '10 Points Miniset Total - Third Set'; };
var bo_z2 = function (match, outcome) { return '15 Points Miniset Winner - First Set'; };
var bo_a3 = function (match, outcome) { return '15 Points Miniset Winner - Second Set'; };
var bo_b3 = function (match, outcome) { return '15 Points Miniset Winner - Third Set'; };
var bo_c3 = function (match, outcome) { return '15 Points Miniset Handicap - First Set'; };
var bo_d3 = function (match, outcome) { return '15 Points Miniset Handicap - Second Set'; };
var bo_e3 = function (match, outcome) { return '15 Points Miniset Handicap - Third Set'; };
var bo_f3 = function (match, outcome) { return '15 Points Miniset Total - First Set'; };
var bo_g3 = function (match, outcome) { return '15 Points Miniset Total - Second Set'; };
var bo_h3 = function (match, outcome) { return '15 Points Miniset Total - Third Set'; };
var bo_i3 = function (match, outcome) { return "".concat(match.homeTeam, " First Half Total"); };
var bo_j3 = function (match, outcome) { return 'First Half Handicap'; };
var bo_k3 = function (match, outcome) { return 'First Half Result'; };
var bo_l3 = function (match, outcome) { return "".concat(match.awayTeam, " First Half Total"); };
var bo_m3 = function (match, outcome) { return "Team To Score The ".concat(numeralMaleEnding(outcome.condition), " Goal"); };
var bo_n3 = function (match, outcome) { return 'Double Chance'; };
var bo_o3 = function (match, outcome) { return 'First Half Total'; };
var bo_p3 = function (match, outcome) { return "Match Result / Total ".concat(outcome.condition); };
var bo_q3 = function (match, outcome) { return "".concat(match.homeTeam, " Winning Margin - Exactly ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Goal', 'Goals', 'Goals'])); };
var bo_r3 = function (match, outcome) { return "".concat(match.awayTeam, " Winning Margin - Exactly ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Goal', 'Goals', 'Goals'])); };
var bo_s3 = function (match, outcome) { return 'Full Time Exact Total'; };
var bo_t3 = function (match, outcome) { return 'Teams To Score'; };
var bo_u3 = function (match, outcome) { return 'Full Time Correct Score'; };
var bo_v3 = function (match, outcome) { return 'Asian Handicap'; };
var bo_w3 = function (match, outcome) { return 'First Quarter Handicap'; };
var bo_x3 = function (match, outcome) { return 'Second Quarter Handicap'; };
var bo_y3 = function (match, outcome) { return 'Third Quarter Handicap'; };
var bo_z3 = function (match, outcome) { return 'Fourth Quarter Handicap'; };
var bo_a4 = function (match, outcome) { return 'First Quarter Total'; };
var bo_b4 = function (match, outcome) { return 'Second Quarter Total'; };
var bo_c4 = function (match, outcome) { return 'Third Quarter Total'; };
var bo_d4 = function (match, outcome) { return 'Fourth Quarter Total'; };
var bo_e4 = function (match, outcome) { return 'First Quarter Result'; };
var bo_f4 = function (match, outcome) { return 'Second Quarter Result'; };
var bo_g4 = function (match, outcome) { return 'Third Quarter Result'; };
var bo_h4 = function (match, outcome) { return 'Fourth Quarter Result'; };
var bo_i4 = function (match, outcome) { return 'Game Total Odd/Even'; };
var bo_j4 = function (match, outcome) { return "".concat(match.homeTeam, " First Quarter Total"); };
var bo_k4 = function (match, outcome) { return "".concat(match.homeTeam, " Second Quarter Total"); };
var bo_l4 = function (match, outcome) { return "".concat(match.homeTeam, " Third Quarter Total"); };
var bo_m4 = function (match, outcome) { return "".concat(match.homeTeam, " Fourth Quarter Total"); };
var bo_n4 = function (match, outcome) { return "".concat(match.awayTeam, " First Quarter Total"); };
var bo_o4 = function (match, outcome) { return "".concat(match.awayTeam, " Second Quarter Total"); };
var bo_p4 = function (match, outcome) { return "".concat(match.awayTeam, " Third Quarter Total"); };
var bo_q4 = function (match, outcome) { return "".concat(match.awayTeam, " Fourth Quarter Total"); };
var bo_r4 = function (match, outcome) { return 'Second Half Result'; };
var bo_s4 = function (match, outcome) { return 'Second Half Total'; };
var bo_t4 = function (match, outcome) { return 'Second Half Handicap'; };
var bo_u4 = function (match, outcome) { return "".concat(match.homeTeam, " Second Half Total"); };
var bo_v4 = function (match, outcome) { return "".concat(match.awayTeam, " Second Half Total"); };
var bo_w4 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['points', 'points', 'points']), "  In The 1st Quarter"); };
var bo_x4 = function (match, outcome) { return "Race To Score ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['points', 'points', 'points']), "  In The 2nd Quarter"); };
var bo_y4 = function (match, outcome) { return "Race To Score ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['points', 'points', 'points']), "  In The 3rd Quarter"); };
var bo_z4 = function (match, outcome) { return "Race To Score ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['points', 'points', 'points']), "  In The 4th Quarter"); };
var bo_a5 = function (match, outcome) { return 'Game Exact Total'; };
var bo_b5 = function (match, outcome) { return 'First Quarter Exact Total'; };
var bo_c5 = function (match, outcome) { return 'Second Quarter Exact Total'; };
var bo_d5 = function (match, outcome) { return 'Third Quarter Exact Total'; };
var bo_e5 = function (match, outcome) { return 'Fourth Quarter Exact Total'; };
var bo_f5 = function (match, outcome) { return "".concat(match.homeTeam, " Winning Margin"); };
var bo_g5 = function (match, outcome) { return "".concat(match.awayTeam, " Winning Margin"); };
var bo_h5 = function (match, outcome) { return 'To Qualify Next Round'; };
var bo_i5 = function (match, outcome) { return "".concat(match.homeTeam, " To Win All Quarters"); };
var bo_j5 = function (match, outcome) { return "".concat(match.awayTeam, " To Win All Quarters"); };
var bo_k5 = function (match, outcome) { return "".concat(match.homeTeam, " To Win Both Halves"); };
var bo_l5 = function (match, outcome) { return "".concat(match.awayTeam, " To Win Both Halves"); };
var bo_m5 = function (match, outcome) { return 'Highest Scoring Half'; };
var bo_n5 = function (match, outcome) { return 'Highest Scoring Quarter'; };
var bo_o5 = function (match, outcome) { return 'Highest Scoring Quarter Total'; };
var bo_p5 = function (match, outcome) { return 'Lowest Scoring Quarter Total'; };
var bo_q5 = function (match, outcome) { return "".concat(match.homeTeam, " To Win First Quarter & Game"); };
var bo_r5 = function (match, outcome) { return "".concat(match.awayTeam, " To Win First Quarter & Game"); };
var bo_s5 = function (match, outcome) { return "".concat(match.homeTeam, " To Win First Half & Game"); };
var bo_t5 = function (match, outcome) { return "".concat(match.awayTeam, " To Win First Half & Game"); };
var bo_u5 = function (match, outcome) { return 'Will There Be Overtime?'; };
var bo_v5 = function (match, outcome) { return 'Winning Margin'; };
var bo_w5 = function (match, outcome) { return "".concat(match.homeTeam, " First Quarter Winning Margin"); };
var bo_x5 = function (match, outcome) { return "".concat(match.homeTeam, " Second Quarter Winning Margin"); };
var bo_y5 = function (match, outcome) { return "".concat(match.homeTeam, " Third Quarter Winning Margin"); };
var bo_z5 = function (match, outcome) { return "".concat(match.homeTeam, " Fourth Quarter Winning Margin"); };
var bo_a6 = function (match, outcome) { return "".concat(match.awayTeam, " First Quarter Winning Margin"); };
var bo_b6 = function (match, outcome) { return "".concat(match.awayTeam, " Second Quarter Winning Margin"); };
var bo_c6 = function (match, outcome) { return "".concat(match.awayTeam, " Third Quarter Winning Margin"); };
var bo_d6 = function (match, outcome) { return "".concat(match.awayTeam, " Fourth Quarter Winning Margin"); };
var bo_e6 = function (match, outcome) { return "".concat(outcome.playerName, " (").concat(match.homeTeam, ") Total"); };
var bo_f6 = function (match, outcome) { return "".concat(outcome.playerName, " (").concat(match.awayTeam, ") Total"); };
var bo_g6 = function (match, outcome) { return '3-Pointers Total'; };
var bo_h6 = function (match, outcome) { return '2-Pointers Total'; };
var bo_i6 = function (match, outcome) { return "".concat(match.homeTeam, " 3-Pointers Total"); };
var bo_j6 = function (match, outcome) { return "".concat(match.awayTeam, " 3-Pointers Total"); };
var bo_k6 = function (match, outcome) { return "".concat(match.homeTeam, " 2-Pointers Total"); };
var bo_l6 = function (match, outcome) { return "".concat(match.awayTeam, " 2-Pointers Total"); };
var bo_m6 = function (match, outcome) { return '3-Pointers Handicap'; };
var bo_n6 = function (match, outcome) { return '2-Pointers Handicap'; };
var bo_o6 = function (match, outcome) { return '3-Pointers Result'; };
var bo_p6 = function (match, outcome) { return '2-Pointers Result'; };
var bo_q6 = function (match, outcome) { return 'Lowest Scoring Quarter'; };
var bo_r6 = function (match, outcome) { return 'Match Total Assists'; };
var bo_s6 = function (match, outcome) { return "".concat(match.homeTeam, " Match Total Assists"); };
var bo_t6 = function (match, outcome) { return "".concat(match.awayTeam, " Match Total Assists"); };
var bo_u6 = function (match, outcome) { return 'Assists Match Handicap'; };
var bo_v6 = function (match, outcome) { return 'Assists Result'; };
var bo_w6 = function (match, outcome) { return 'First 2-Pointer In Match'; };
var bo_x6 = function (match, outcome) { return 'First 3-Pointer In Match'; };
var bo_y6 = function (match, outcome) { return 'First Free Throw In Match'; };
var bo_z6 = function (match, outcome) { return 'To Happen First'; };
var bo_a7 = function (match, outcome) { return 'Most Points In A Quarter'; };
var bo_b7 = function (match, outcome) { return "Race To ".concat(outcome.condition, " Points In Match"); };
var bo_c7 = function (match, outcome) { return 'Triple-Double Total In Match'; };
var bo_d7 = function (match, outcome) { return 'Double-Double Total In Match'; };
var bo_e7 = function (match, outcome) { return "Race To ".concat(outcome.condition, " - First Quarter"); };
var bo_f7 = function (match, outcome) { return "Race To ".concat(outcome.condition, " - Second Quarter"); };
var bo_g7 = function (match, outcome) { return "Race To ".concat(outcome.condition, " - Third Quarter"); };
var bo_h7 = function (match, outcome) { return "Race To ".concat(outcome.condition, " - Fourth Quarter"); };
var bo_i7 = function (match, outcome) { return 'Winning Margin 3-Way'; };
var bo_j7 = function (match, outcome) { return 'Winning Margin - First Quarter'; };
var bo_k7 = function (match, outcome) { return 'Winning Margin - Second Quarter'; };
var bo_l7 = function (match, outcome) { return 'Winning Margin - Third Quarter'; };
var bo_m7 = function (match, outcome) { return 'Winning Margin - Fourth Quarter'; };
var bo_n7 = function (match, outcome) { return 'First Half Exact Total'; };
var bo_o7 = function (match, outcome) { return 'Second Half Exact Total'; };
var bo_p7 = function (match, outcome) { return "".concat(match.homeTeam, " First Half Winning Margin"); };
var bo_q7 = function (match, outcome) { return "".concat(match.homeTeam, " Second Half Winning Margin"); };
var bo_r7 = function (match, outcome) { return "".concat(match.awayTeam, " First Half Winning Margin"); };
var bo_s7 = function (match, outcome) { return "".concat(match.awayTeam, " Second Half Winning Margin"); };
var bo_t7 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['points', 'points', 'points']), "  In The 1st Half"); };
var bo_u7 = function (match, outcome) { return "Race To Score ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['points', 'points', 'points']), "  In The 2nd Half"); };
var bo_v7 = function (match, outcome) { return "\u041A\u0442\u043E \u043F\u0435\u0440\u0432\u044B\u043C \u043D\u0430\u0431\u0435\u0440\u0435\u0442 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['очко', 'очков', 'очков']), " \u0432 \u043C\u0430\u0442\u0447\u0435"); };
var bo_w7 = function (match, outcome) { return 'Highest Scoring Half Total'; };
var bo_x7 = function (match, outcome) { return 'Lowest Scoring Half Total'; };
var bo_y7 = function (match, outcome) { return "Race To ".concat(outcome.condition, " - First Half"); };
var bo_z7 = function (match, outcome) { return "Race To ".concat(outcome.condition, " - Second Half"); };
var bo_a8 = function (match, outcome) { return 'First Period Total'; };
var bo_b8 = function (match, outcome) { return 'Second Period Total'; };
var bo_c8 = function (match, outcome) { return 'Third Period Total'; };
var bo_d8 = function (match, outcome) { return 'First Period Result'; };
var bo_e8 = function (match, outcome) { return 'Second Period Result'; };
var bo_f8 = function (match, outcome) { return 'Third Period Result'; };
var bo_g8 = function (match, outcome) { return 'To Win Match (inc. Penalty Shootouts)'; };
var bo_h8 = function (match, outcome) { return 'How many teams score in the 1 period'; };
var bo_i8 = function (match, outcome) { return 'How many teams score in the 2 period'; };
var bo_j8 = function (match, outcome) { return 'How many teams score in the 3 period'; };
var bo_k8 = function (match, outcome) { return 'Period&Match'; };
var bo_l8 = function (match, outcome) { return 'Overtime Total'; };
var bo_m8 = function (match, outcome) { return 'Overtime Result'; };
var bo_n8 = function (match, outcome) { return 'Overtime Handicap'; };
var bo_o8 = function (match, outcome) { return 'Final Score'; };
var bo_p8 = function (match, outcome) { return 'First Period Handicap'; };
var bo_q8 = function (match, outcome) { return 'Second Period Handicap'; };
var bo_r8 = function (match, outcome) { return 'Third Period Handicap'; };
var bo_s8 = function (match, outcome) { return 'First Period Correct Score'; };
var bo_t8 = function (match, outcome) { return 'Second Period Correct Score'; };
var bo_u8 = function (match, outcome) { return 'Third Period Correct Score'; };
var bo_v8 = function (match, outcome) { return "".concat(numeralMaleEnding(outcome.condition), " Goal"); };
var bo_w8 = function (match, outcome) { return 'First Set Handicap'; };
var bo_x8 = function (match, outcome) { return 'Second Set Handicap'; };
var bo_y8 = function (match, outcome) { return 'Third Set Handicap'; };
var bo_z8 = function (match, outcome) { return 'First Set Total'; };
var bo_a9 = function (match, outcome) { return 'Second Set Total'; };
var bo_b9 = function (match, outcome) { return 'Third Set Total'; };
var bo_c9 = function (match, outcome) { return 'Sets Total'; };
var bo_d9 = function (match, outcome) { return "".concat(match.homeTeam, " First Set Total"); };
var bo_e9 = function (match, outcome) { return "".concat(match.homeTeam, " Second Set Total"); };
var bo_f9 = function (match, outcome) { return "".concat(match.homeTeam, " Third Set Total"); };
var bo_g9 = function (match, outcome) { return "".concat(match.awayTeam, " First Set Total"); };
var bo_h9 = function (match, outcome) { return "".concat(match.awayTeam, " Second Set Total"); };
var bo_i9 = function (match, outcome) { return "".concat(match.awayTeam, " Third Set Total"); };
var bo_j9 = function (match, outcome) { return 'First Set Winner'; };
var bo_k9 = function (match, outcome) { return 'Second Set Winner'; };
var bo_l9 = function (match, outcome) { return 'Third Set Winner'; };
var bo_m9 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " - First Set"); };
var bo_n9 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " - Second Set"); };
var bo_o9 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " - Third Set"); };
var bo_p9 = function (match, outcome) { return 'Sets Handicap'; };
var bo_q9 = function (match, outcome) { return 'First Set Exact total'; };
var bo_r9 = function (match, outcome) { return 'Second Set Exact total'; };
var bo_s9 = function (match, outcome) { return 'Third Set Exact total'; };
var bo_t9 = function (match, outcome) { return "".concat(match.homeTeam, " First Set Winning Margin"); };
var bo_u9 = function (match, outcome) { return "".concat(match.homeTeam, " Second Set Winning Margin"); };
var bo_v9 = function (match, outcome) { return "".concat(match.homeTeam, " Third Set Winning Margin"); };
var bo_w9 = function (match, outcome) { return "".concat(match.awayTeam, " First Set Winning Margin"); };
var bo_x9 = function (match, outcome) { return "".concat(match.awayTeam, " Second Set Winning Margin"); };
var bo_y9 = function (match, outcome) { return "".concat(match.awayTeam, " Third Set Winning Margin"); };
var bo_z9 = function (match, outcome) { return 'First Set Even/Odd'; };
var bo_a10 = function (match, outcome) { return 'Second Set Even/Odd'; };
var bo_b10 = function (match, outcome) { return 'Third Set Even/Odd'; };
var bo_c10 = function (match, outcome) { return "First Set Result / Total ".concat(outcome.condition); };
var bo_d10 = function (match, outcome) { return "Second Set Result / Total ".concat(outcome.condition); };
var bo_e10 = function (match, outcome) { return "Third Set Result / Total ".concat(outcome.condition); };
var bo_f10 = function (match, outcome) { return 'To Win condition Point - First Set'; };
var bo_g10 = function (match, outcome) { return 'To Win condition Point - Second Set'; };
var bo_h10 = function (match, outcome) { return 'To Win condition Point - Third Set'; };
var bo_i10 = function (match, outcome) { return "Full time Result / Total ".concat(outcome.condition); };
var bo_j10 = function (match, outcome) { return 'First Set Winning Margin'; };
var bo_k10 = function (match, outcome) { return 'Second Set Winning Margin'; };
var bo_l10 = function (match, outcome) { return 'Third Set Winning Margin'; };
var bo_m10 = function (match, outcome) { return 'Race Total'; };
var bo_n10 = function (match, outcome) { return 'First Fire Line Total'; };
var bo_o10 = function (match, outcome) { return 'Second Fire Line Total'; };
var bo_p10 = function (match, outcome) { return 'Third Fire Line Total'; };
var bo_q10 = function (match, outcome) { return 'Fourth Fire Line Total'; };
var bo_r10 = function (match, outcome) { return 'Fifth Fire Line Total'; };
var bo_s10 = function (match, outcome) { return 'Sixth Fire Line Total'; };
var bo_t10 = function (match, outcome) { return 'Seventh Fire Line Total'; };
var bo_u10 = function (match, outcome) { return 'Eighth Fire Line Total'; };
var bo_v10 = function (match, outcome) { return "".concat(match.homeTeam, " First Fire Line Total"); };
var bo_w10 = function (match, outcome) { return "".concat(match.homeTeam, " Second Fire Line Total"); };
var bo_x10 = function (match, outcome) { return "".concat(match.homeTeam, " Third Fire Line Total"); };
var bo_y10 = function (match, outcome) { return "".concat(match.homeTeam, " Fourth Fire Line Total"); };
var bo_z10 = function (match, outcome) { return "".concat(match.homeTeam, " Fifth Fire Line Total"); };
var bo_a11 = function (match, outcome) { return "".concat(match.homeTeam, " Sixth Fire Line Total"); };
var bo_b11 = function (match, outcome) { return "".concat(match.homeTeam, " Seventh Fire Line Total"); };
var bo_c11 = function (match, outcome) { return "".concat(match.homeTeam, " Eighth Fire Line Total"); };
var bo_d11 = function (match, outcome) { return "".concat(match.awayTeam, " First Fire Line Total"); };
var bo_e11 = function (match, outcome) { return "".concat(match.awayTeam, " Second Fire Line Total"); };
var bo_f11 = function (match, outcome) { return "".concat(match.awayTeam, " Third Fire Line Total"); };
var bo_g11 = function (match, outcome) { return "".concat(match.awayTeam, " Fourth Fire Line Total"); };
var bo_h11 = function (match, outcome) { return "".concat(match.awayTeam, " Fifth Fire Line Total"); };
var bo_i11 = function (match, outcome) { return "".concat(match.awayTeam, " Sixth Fire Line Total"); };
var bo_j11 = function (match, outcome) { return "".concat(match.awayTeam, " Seventh Fire Line Total"); };
var bo_k11 = function (match, outcome) { return "".concat(match.awayTeam, " Eighth Fire Line Total"); };
var bo_l11 = function (match, outcome) { return 'First Fire Line Handicap'; };
var bo_m11 = function (match, outcome) { return 'Second Fire Line Handicap'; };
var bo_n11 = function (match, outcome) { return 'Third Fire Line Handicap'; };
var bo_o11 = function (match, outcome) { return 'Fourth Fire Line Handicap'; };
var bo_p11 = function (match, outcome) { return 'Fifth Fire Line Handicap'; };
var bo_q11 = function (match, outcome) { return 'Sixth Fire Line Handicap'; };
var bo_r11 = function (match, outcome) { return 'Seventh Fire Line Handicap'; };
var bo_s11 = function (match, outcome) { return 'Eighth Fire Line Handicap'; };
var bo_t11 = function (match, outcome) { return 'First Fire Line Result'; };
var bo_u11 = function (match, outcome) { return 'Second Fire Line Result'; };
var bo_v11 = function (match, outcome) { return 'Third Fire Line Result'; };
var bo_w11 = function (match, outcome) { return 'Fourth Fire Line Result'; };
var bo_x11 = function (match, outcome) { return 'Fifth Fire Line Result'; };
var bo_y11 = function (match, outcome) { return 'Sixth Fire Line Result'; };
var bo_z11 = function (match, outcome) { return 'Seventh Fire Line Result'; };
var bo_a12 = function (match, outcome) { return 'Eighth Fire Line Result'; };
var bo_b12 = function (match, outcome) { return 'First Fire Line Exact Total'; };
var bo_c12 = function (match, outcome) { return 'Second Fire Line Exact Total'; };
var bo_d12 = function (match, outcome) { return 'Third Fire Line Exact Total'; };
var bo_e12 = function (match, outcome) { return 'Fourth Fire Line Exact Total'; };
var bo_f12 = function (match, outcome) { return 'Fifth Fire Line Exact Total'; };
var bo_g12 = function (match, outcome) { return 'Sixth Fire Line Exact Total'; };
var bo_h12 = function (match, outcome) { return 'Seventh Fire Line Exact Total'; };
var bo_i12 = function (match, outcome) { return 'Eighth Fire Line Exact Total'; };
var bo_j12 = function (match, outcome) { return 'Will Fight Go The Distance?'; };
var bo_k12 = function (match, outcome) { return 'Fight Result'; };
var bo_l12 = function (match, outcome) { return 'Round Betting'; };
var bo_m12 = function (match, outcome) { return 'Double Outcome'; };
var bo_n12 = function (match, outcome) { return 'Total'; };
var bo_o12 = function (match, outcome) { return "Who Wins ".concat(outcome.condition, " Round?"); };
var bo_p12 = function (match, outcome) { return 'FirstBlood'; };
var bo_q12 = function (match, outcome) { return "FirstBlood In ".concat(outcome.condition, " Round"); };
var bo_r12 = function (match, outcome) { return "Who Wins ".concat(numeralNeuterEnding(outcome.condition), " Map?"); };
var bo_s12 = function (match, outcome) { return "FirstBlood In ".concat(numeralNeuterEnding(outcome.condition), " Map"); };
var bo_t12 = function (match, outcome) { return "Race To ".concat(outcome.condition, " Kills In 1st Map"); };
var bo_u12 = function (match, outcome) { return "Race To ".concat(outcome.condition, " Kills In 2nd Map"); };
var bo_v12 = function (match, outcome) { return "Race To ".concat(outcome.condition, " Kills In 3rd Map"); };
var bo_w12 = function (match, outcome) { return "Race To ".concat(outcome.condition, " Kills In 4th Map"); };
var bo_x12 = function (match, outcome) { return "Race To ".concat(outcome.condition, " Kills In 5th Map"); };
var bo_y12 = function (match, outcome) { return 'First Map Result'; };
var bo_z12 = function (match, outcome) { return 'Second Map Result'; };
var bo_a13 = function (match, outcome) { return 'Third Map Result'; };
var bo_b13 = function (match, outcome) { return 'Fourth Map Result'; };
var bo_c13 = function (match, outcome) { return 'Fifth Map Result'; };
var bo_d13 = function (match, outcome) { return 'First blood In First Map'; };
var bo_e13 = function (match, outcome) { return 'First blood In Second Map'; };
var bo_f13 = function (match, outcome) { return 'First blood In Third Map'; };
var bo_g13 = function (match, outcome) { return 'First blood In Fourth Map'; };
var bo_h13 = function (match, outcome) { return 'First blood In Fifth Map'; };
var bo_i13 = function (match, outcome) { return 'To Win Match (inc. Shootouts)'; };
var bo_j13 = function (match, outcome) { return "Total Of Team Scored ".concat(outcome.conditionTwo, "+ Goals"); };
var bo_k13 = function (match, outcome) { return 'Highest Scoring Team Total'; };
var bo_l13 = function (match, outcome) { return "Both Halves Total Under ".concat(outcome.condition); };
var bo_m13 = function (match, outcome) { return "Both Halves Total Over ".concat(outcome.condition); };
var bo_n13 = function (match, outcome) { return 'First Half Total Even/Odd'; };
var bo_o13 = function (match, outcome) { return 'Second Half Total Even/Odd'; };
var bo_p13 = function (match, outcome) { return "".concat(match.homeTeam, " First Half Goals"); };
var bo_q13 = function (match, outcome) { return "".concat(match.homeTeam, " Second Half Goals"); };
var bo_r13 = function (match, outcome) { return "".concat(match.awayTeam, " First Half Goals"); };
var bo_s13 = function (match, outcome) { return "".concat(match.awayTeam, " Second Half Goals"); };
var bo_t13 = function (match, outcome) { return "".concat(match.homeTeam, " Full Time Goals"); };
var bo_u13 = function (match, outcome) { return "".concat(match.awayTeam, " Full Time Goals"); };
var bo_v13 = function (match, outcome) { return 'Lowest Scoring Team Total'; };
var bo_w13 = function (match, outcome) { return "".concat(match.homeTeam, " To Score In The First Half Only"); };
var bo_x13 = function (match, outcome) { return "".concat(match.awayTeam, " To Score In The First Half Only"); };
var bo_y13 = function (match, outcome) { return "".concat(match.homeTeam, " To Score In The Second Half Only"); };
var bo_z13 = function (match, outcome) { return "".concat(match.awayTeam, " To Score In The Second Half Only"); };
var bo_a14 = function (match, outcome) { return 'Teams To Score In The First Half'; };
var bo_b14 = function (match, outcome) { return 'Teams To Score In The Second Half'; };
var bo_c14 = function (match, outcome) { return "Teams To Score Over ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['Goal', 'Goals', 'Goals'])); };
var bo_d14 = function (match, outcome) { return 'First Goal Method'; };
var bo_e14 = function (match, outcome) { return 'Team To Qualify Next Round'; };
var bo_f14 = function (match, outcome) { return 'Team To Kick Off'; };
var bo_g14 = function (match, outcome) { return 'Either Team To Score Two Goals In A Row'; };
var bo_h14 = function (match, outcome) { return "".concat(match.homeTeam, " To Win From Behind"); };
var bo_i14 = function (match, outcome) { return "The ".concat(numeralFemaleEnding(outcome.condition), " Yellow Card To Receive"); };
var bo_j14 = function (match, outcome) { return "".concat(match.awayTeam, " To Win From Behind"); };
var bo_k14 = function (match, outcome) { return 'First To Happen In Match'; };
var bo_l14 = function (match, outcome) { return 'A Player to Score Exacly 2 Goals'; };
var bo_m14 = function (match, outcome) { return 'Hat-Trick'; };
var bo_n14 = function (match, outcome) { return "Team To Serve ".concat(numeralMaleEnding(outcome.condition), " Corner In The Full Time"); };
var bo_o14 = function (match, outcome) { return "Teams To Score Exactly ".concat(outcome.conditionTwo, " ").concat(plural(outcome.conditionTwo, ['Goal', 'Goals', 'Goals'])); };
var bo_p14 = function (match, outcome) { return "Both Teams To Score Exactly ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['Goal', 'Goalа', 'Goals'])); };
var bo_q14 = function (match, outcome) { return 'Last Team To Score'; };
var bo_r14 = function (match, outcome) { return 'Own Goal'; };
var bo_s14 = function (match, outcome) { return 'Substitute To Score'; };
var bo_t14 = function (match, outcome) { return 'Last Goal Minute'; };
var bo_u14 = function (match, outcome) { return 'Team To Lift The Cup'; };
var bo_v14 = function (match, outcome) { return 'Team To Lift The Super Cup'; };
var bo_w14 = function (match, outcome) { return "Half When ".concat(numeralMaleEnding(outcome.condition), " Goal To Score"); };
var bo_x14 = function (match, outcome) { return '1-15th Mins Double Chance'; };
var bo_y14 = function (match, outcome) { return '16-30th Mins Double Chance'; };
var bo_z14 = function (match, outcome) { return '31st Min - Half Time Double Chance'; };
var bo_a15 = function (match, outcome) { return '46-60th Mins Double Chance'; };
var bo_b15 = function (match, outcome) { return '61-75th Mins Double Chance'; };
var bo_c15 = function (match, outcome) { return '75th Min - Full Time Double Chance'; };
var bo_d15 = function (match, outcome) { return "".concat(match.homeTeam, " To Score The ").concat(numeralMaleEnding(outcome.condition), " Shootout Penalty"); };
var bo_e15 = function (match, outcome) { return "".concat(match.awayTeam, " To Score The ").concat(numeralMaleEnding(outcome.condition), " Shootout Penalty"); };
var bo_f15 = function (match, outcome) { return "".concat(match.homeTeam, " To Score The ").concat(numeralMaleEnding(outcome.condition), " Goal"); };
var bo_g15 = function (match, outcome) { return "".concat(match.awayTeam, " To Score Its ").concat(numeralMaleEnding(outcome.condition), " Goal"); };
var bo_h15 = function (match, outcome) { return 'First Half Corners'; };
var bo_i15 = function (match, outcome) { return 'First Half Yellow Cards'; };
var bo_j15 = function (match, outcome) { return 'Full Time Corners Handicap'; };
var bo_k15 = function (match, outcome) { return 'First Half Corners Handicap'; };
var bo_l15 = function (match, outcome) { return 'Yellow Cards Handicap'; };
var bo_m15 = function (match, outcome) { return 'First Half Yellow Cards Handicap'; };
var bo_n15 = function (match, outcome) { return 'Full Time Corners Result'; };
var bo_o15 = function (match, outcome) { return 'First Half Corners Result'; };
var bo_p15 = function (match, outcome) { return 'Full Time Yellow Cards Result'; };
var bo_q15 = function (match, outcome) { return 'First Half Yellow Cards Result'; };
var bo_r15 = function (match, outcome) { return "Race To Score ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['Goal', 'Goals', 'Goals']), " In The Full Time"); };
var bo_s15 = function (match, outcome) { return "".concat(numeralMaleEnding(outcome.condition), " Penalty To Be Missed"); };
var bo_t15 = function (match, outcome) { return 'Full Time Total'; };
var bo_u15 = function (match, outcome) { return 'Total Throws-in'; };
var bo_v15 = function (match, outcome) { return 'Half Time / Full Time'; };
var bo_w15 = function (match, outcome) { return 'Asian Total'; };
var bo_x15 = function (match, outcome) { return 'Total Corners'; };
var bo_y15 = function (match, outcome) { return 'Full Time Result'; };
var bo_z15 = function (match, outcome) { return 'Penalties Total'; };
var bo_a16 = function (match, outcome) { return 'Red Cards Total'; };
var bo_b16 = function (match, outcome) { return 'First Goal Minute'; };
var bo_c16 = function (match, outcome) { return 'Goal Minutes Total'; };
var bo_d16 = function (match, outcome) { return 'Total Shots On Target'; };
var bo_e16 = function (match, outcome) { return 'Yellow Cards Total'; };
var bo_f16 = function (match, outcome) { return '1-15th Mins Handicap'; };
var bo_g16 = function (match, outcome) { return '16-30th Mins Handicap'; };
var bo_h16 = function (match, outcome) { return '31st Min - Half Time Handicap'; };
var bo_i16 = function (match, outcome) { return '46-60th Mins Handicap'; };
var bo_j16 = function (match, outcome) { return '61-75th Mins Handicap'; };
var bo_k16 = function (match, outcome) { return '76th Min - Full Time'; };
var bo_l16 = function (match, outcome) { return "".concat(match.awayTeam, " Clean Sheet"); };
var bo_m16 = function (match, outcome) { return "".concat(match.homeTeam, " Clean Sheet"); };
var bo_n16 = function (match, outcome) { return 'Substitutions Total'; };
var bo_o16 = function (match, outcome) { return 'Full Time Total Even/Odd'; };
var bo_p16 = function (match, outcome) { return '1-15th Mins Total'; };
var bo_q16 = function (match, outcome) { return '16-30th Mins Total'; };
var bo_r16 = function (match, outcome) { return '31st Min - Half Time Total'; };
var bo_s16 = function (match, outcome) { return '46-60th Mins Total'; };
var bo_t16 = function (match, outcome) { return '61-75th Mins Total'; };
var bo_u16 = function (match, outcome) { return '76th Min - Full Time Total'; };
var bo_v16 = function (match, outcome) { return "".concat(match.homeTeam, " 1-15th Mins Total"); };
var bo_w16 = function (match, outcome) { return "".concat(match.homeTeam, " 16-30th Mins Total"); };
var bo_x16 = function (match, outcome) { return "".concat(match.homeTeam, " 31st Min - Half Time Total"); };
var bo_y16 = function (match, outcome) { return "".concat(match.homeTeam, " 46-60th Mins Total"); };
var bo_z16 = function (match, outcome) { return "".concat(match.homeTeam, " 61-75th Mins Total"); };
var bo_a17 = function (match, outcome) { return "".concat(match.homeTeam, " 76th Min - Full Time Total"); };
var bo_b17 = function (match, outcome) { return "".concat(match.awayTeam, " 1-15th Mins Total"); };
var bo_c17 = function (match, outcome) { return "".concat(match.awayTeam, " 16-30th Mins Total"); };
var bo_d17 = function (match, outcome) { return "".concat(match.awayTeam, " 31st Min - Half Time Total"); };
var bo_e17 = function (match, outcome) { return "".concat(match.awayTeam, " 46-60th Mins Total"); };
var bo_f17 = function (match, outcome) { return "".concat(match.awayTeam, " 61-75th Mins Total"); };
var bo_g17 = function (match, outcome) { return "".concat(match.awayTeam, " 76th Min - Full Time Total"); };
var bo_h17 = function (match, outcome) { return 'Exact First Half Total'; };
var bo_i17 = function (match, outcome) { return 'Exact Second Half Total'; };
var bo_j17 = function (match, outcome) { return "".concat(match.homeTeam, " To Win To Nil"); };
var bo_k17 = function (match, outcome) { return "".concat(match.awayTeam, " To Win To Nil"); };
var bo_l17 = function (match, outcome) { return "".concat(match.homeTeam, " To Score Exactly ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Goal', 'Goals', 'Goals'])); };
var bo_m17 = function (match, outcome) { return "".concat(match.awayTeam, " To Score Exactly ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Goal', 'Goalа', 'Goals'])); };
var bo_n17 = function (match, outcome) { return 'First Half Correct Score'; };
var bo_o17 = function (match, outcome) { return 'Second Half Correct Score'; };
var bo_p17 = function (match, outcome) { return 'Missed Penalties Total'; };
var bo_q17 = function (match, outcome) { return "Both Teams To Score Under ".concat(outcome.condition); };
var bo_r17 = function (match, outcome) { return "Both Teams To Score Over ".concat(outcome.condition); };
var bo_s17 = function (match, outcome) { return 'Half With Most Goals'; };
var bo_t17 = function (match, outcome) { return '1-15th Mins Result'; };
var bo_u17 = function (match, outcome) { return '16-30th Mins Result'; };
var bo_v17 = function (match, outcome) { return '31st Min - Half Time Result'; };
var bo_w17 = function (match, outcome) { return '46-60th Mins Result'; };
var bo_x17 = function (match, outcome) { return '61-75th Mins Result'; };
var bo_y17 = function (match, outcome) { return '75th Min - Full Time Result'; };
var bo_z17 = function (match, outcome) { return "".concat(match.homeTeam, " To Win Either Half"); };
var bo_a18 = function (match, outcome) { return "".concat(match.awayTeam, " To Win Either Half"); };
var bo_b18 = function (match, outcome) { return "Total Of Teams Scored ".concat(outcome.conditionTwo, " - ").concat(outcome.conditionThree, " Goals\u00A0"); };
var bo_c18 = function (match, outcome) { return "".concat(outcome.playerName, " (").concat(match.homeTeam, ") To Score"); };
var bo_d18 = function (match, outcome) { return "".concat(outcome.playerName, " (").concat(match.awayTeam, ") To Score"); };
var bo_e18 = function (match, outcome) { return 'Games Result'; };
var bo_f18 = function (match, outcome) { return 'Games Handicap'; };
var bo_g18 = function (match, outcome) { return 'Games Total'; };
var bo_h18 = function (match, outcome) { return 'Home Teams Total'; };
var bo_i18 = function (match, outcome) { return 'Away Teams Total'; };
var bo_j18 = function (match, outcome) { return 'Highest Scoring Match Total'; };
var bo_k18 = function (match, outcome) { return 'Lowest Scoring Match Total'; };
var bo_l18 = function (match, outcome) { return 'Scoreless Games Total'; };
var bo_m18 = function (match, outcome) { return 'Home Teams To Win Total'; };
var bo_n18 = function (match, outcome) { return 'Away Teams To Win Total'; };
var bo_o18 = function (match, outcome) { return 'Draws Total'; };
var bo_p18 = function (match, outcome) { return 'Both Teams To Score: 1st Half&2nd Half'; };
var bo_q18 = function (match, outcome) { return "Total ".concat(outcome.condition, "/Both Teams To Score"); };
var bo_r18 = function (match, outcome) { return "".concat(match.homeTeam, " To Score and Not To Win"); };
var bo_s18 = function (match, outcome) { return "".concat(match.awayTeam, " To Score and Not To Win"); };
var bo_t18 = function (match, outcome) { return 'Winning Method'; };
var bo_u18 = function (match, outcome) { return 'Injury Time in First Half'; };
var bo_v18 = function (match, outcome) { return 'Injury Time in Second Half'; };
var bo_w18 = function (match, outcome) { return 'Will Anybody Hit the Goalpost or Crossbar?'; };
var bo_x18 = function (match, outcome) { return 'First Substitution time'; };
var bo_y18 = function (match, outcome) { return "".concat(match.homeTeam, " to Recieve Red Card"); };
var bo_z18 = function (match, outcome) { return "".concat(match.awayTeam, "  to Recieve Red Card"); };
var bo_a19 = function (match, outcome) { return 'To Be Penalty an Send Off'; };
var bo_b19 = function (match, outcome) { return 'Goal In Injury Time'; };
var bo_c19 = function (match, outcome) { return 'Yellow Card For Simulation'; };
var bo_d19 = function (match, outcome) { return 'Yellow Card For Taken Off T-Shirt'; };
var bo_e19 = function (match, outcome) { return 'To Be Corner Kicks From Each Pitch Corner'; };
var bo_f19 = function (match, outcome) { return 'Who Takes 3rd Place?'; };
var bo_g19 = function (match, outcome) { return "Total: ".concat(match.awayTeam, "  (Extra Time)"); };
var bo_h19 = function (match, outcome) { return "Total: ".concat(match.homeTeam, "  (Extra Time)"); };
var bo_i19 = function (match, outcome) { return 'Double Chance (Extra Time)'; };
var bo_j19 = function (match, outcome) { return 'Точный счет  (Extra Time)'; };
var bo_k19 = function (match, outcome) { return 'Handicap (Extra Time)'; };
var bo_l19 = function (match, outcome) { return 'Total (Extra Time)'; };
var bo_m19 = function (match, outcome) { return "".concat(match.homeTeam, " - ").concat(match.awayTeam, " (Extra Time)"); };
var bo_n19 = function (match, outcome) { return "Who Scores ".concat(numeralMaleEnding(outcome.condition), " goal?"); };
var bo_o19 = function (match, outcome) { return 'Handicap - First Extra Time'; };
var bo_p19 = function (match, outcome) { return 'First Extra Time Total'; };
var bo_q19 = function (match, outcome) { return 'First Extra Time Result'; };
var bo_r19 = function (match, outcome) { return 'Handicap - Second Extra Time'; };
var bo_s19 = function (match, outcome) { return 'Second Extra Time Total'; };
var bo_t19 = function (match, outcome) { return 'Second Extra Time Result'; };
var bo_u19 = function (match, outcome) { return 'Shoot-out Correct Score'; };
var bo_v19 = function (match, outcome) { return "Total Penalty Scored: ".concat(match.awayTeam, " (Shoot-out)"); };
var bo_w19 = function (match, outcome) { return "Total Penalty Scored: ".concat(match.homeTeam, " (Shoot-out)"); };
var bo_x19 = function (match, outcome) { return 'Total Penalty Scored (Shoot-out)'; };
var bo_y19 = function (match, outcome) { return 'Total Penalty Missed (Shoot-out)'; };
var bo_z19 = function (match, outcome) { return "European Handicap ".concat(europeanHandicapCondition(outcome.condition)); };
var bo_a20 = function (match, outcome) { return "European Handicap ".concat(europeanHandicapCondition(outcome.condition), " - First Half"); };
var bo_b20 = function (match, outcome) { return "European Handicap ".concat(europeanHandicapCondition(outcome.condition), " - Second Half"); };
var bo_c20 = function (match, outcome) { return "Who Scores ".concat(numeralMaleEnding(outcome.condition), " Goal - First Half?"); };
var bo_d20 = function (match, outcome) { return "Rest Of Game (current score ".concat(outcome.condition, ":").concat(outcome.conditionTwo, ")"); };
var bo_e20 = function (match, outcome) { return "Rest Of First Half (current score ".concat(outcome.condition, ":").concat(outcome.conditionTwo, ")"); };
var bo_f20 = function (match, outcome) { return "First Corners Half Total: ".concat(match.homeTeam); };
var bo_g20 = function (match, outcome) { return "First Corners Half Total: ".concat(match.awayTeam); };
var bo_h20 = function (match, outcome) { return "Corners Total: ".concat(match.homeTeam); };
var bo_i20 = function (match, outcome) { return "Corners Total: ".concat(match.awayTeam); };
var bo_j20 = function (match, outcome) { return 'First Half Double Chance'; };
var bo_k20 = function (match, outcome) { return 'Second Half Double Chance'; };
var bo_l20 = function (match, outcome) { return 'Both To Score?'; };
var bo_m20 = function (match, outcome) { return "Both Teams To Score ".concat(outcome.conditionTwo, " And More Goals\u00A0(Their Total)"); };
var bo_n20 = function (match, outcome) { return 'First Half Even/Odd'; };
var bo_o20 = function (match, outcome) { return 'Second Half Even/Odd'; };
var bo_p20 = function (match, outcome) { return "".concat(match.homeTeam, " To Score In The First Half"); };
var bo_q20 = function (match, outcome) { return "".concat(match.homeTeam, " To Score In The Second Half"); };
var bo_r20 = function (match, outcome) { return "".concat(match.awayTeam, " To Score In The First Half"); };
var bo_s20 = function (match, outcome) { return "".concat(match.awayTeam, " To Score In The Second Half"); };
var bo_t20 = function (match, outcome) { return "Teams To Score Over ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['goal', 'Goals', 'Goals'])); };
var bo_u20 = function (match, outcome) { return "Teams To Score Exactly ".concat(outcome.conditionTwo, " ").concat(plural(outcome.conditionTwo, ['goal', 'Goals', 'Goals']), "\u00A0(Their Total)"); };
var bo_v20 = function (match, outcome) { return 'Match (Full Time) Total'; };
var bo_w20 = function (match, outcome) { return 'Half Time / Match (Full Time)'; };
var bo_x20 = function (match, outcome) { return 'Match (Full Time) Correct Score'; };
var bo_y20 = function (match, outcome) { return 'Match (Full Time) Exact Total'; };
var bo_z20 = function (match, outcome) { return 'Match (Full Time) Draw'; };
var bo_a21 = function (match, outcome) { return 'Total Penalties'; };
var bo_b21 = function (match, outcome) { return 'Total Red Cards'; };
var bo_c21 = function (match, outcome) { return 'Total Goal Minutes'; };
var bo_d21 = function (match, outcome) { return 'Total Yellow Cards'; };
var bo_e21 = function (match, outcome) { return '1-15th Min Handicap'; };
var bo_f21 = function (match, outcome) { return '16-30th Min Handicap'; };
var bo_g21 = function (match, outcome) { return '46-60th Min Handicap'; };
var bo_h21 = function (match, outcome) { return '61-75th Min Handicap'; };
var bo_i21 = function (match, outcome) { return "".concat(match.homeTeam, " To Score"); };
var bo_j21 = function (match, outcome) { return "".concat(match.awayTeam, " To Score"); };
var bo_k21 = function (match, outcome) { return 'Total Substitutions'; };
var bo_l21 = function (match, outcome) { return 'Match (Full Time) Total Even/Odd'; };
var bo_m21 = function (match, outcome) { return '1-15th Min Total'; };
var bo_n21 = function (match, outcome) { return '16-30th Min Total'; };
var bo_o21 = function (match, outcome) { return '46-60th Min Total'; };
var bo_p21 = function (match, outcome) { return '61-75th Min Total'; };
var bo_q21 = function (match, outcome) { return "".concat(match.homeTeam, " 1-15th Min Total"); };
var bo_r21 = function (match, outcome) { return "".concat(match.homeTeam, " 16-30th Min Total"); };
var bo_s21 = function (match, outcome) { return "".concat(match.homeTeam, " 46-60th Min Total"); };
var bo_t21 = function (match, outcome) { return "".concat(match.homeTeam, " 61-75th Min Total"); };
var bo_u21 = function (match, outcome) { return "".concat(match.awayTeam, " 1-15th Min Total"); };
var bo_v21 = function (match, outcome) { return "".concat(match.awayTeam, " 16-30th Min Total"); };
var bo_w21 = function (match, outcome) { return "".concat(match.awayTeam, " 46-60th Min Total"); };
var bo_x21 = function (match, outcome) { return "".concat(match.awayTeam, " 61-75th Min Total"); };
var bo_y21 = function (match, outcome) { return "".concat(match.awayTeam, " To Score Exactly ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Goal', 'Goals', 'Goals'])); };
var bo_z21 = function (match, outcome) { return 'Total Missed Penalties'; };
var bo_a22 = function (match, outcome) { return 'Team To Win 1st-15th Min'; };
var bo_b22 = function (match, outcome) { return 'Team To Win 16th-30th Min'; };
var bo_c22 = function (match, outcome) { return 'Team To Win 31st Min - Half Time'; };
var bo_d22 = function (match, outcome) { return 'Team To Win 46th-60th Min'; };
var bo_e22 = function (match, outcome) { return 'Team To Win 61st-75th Min'; };
var bo_f22 = function (match, outcome) { return 'Team To Win 75th Min - Full Time'; };
var bo_g22 = function (match, outcome) { return "Teams To Score ".concat(outcome.conditionTwo, " Through ").concat(outcome.conditionThree, " Goals\u00A0(Total)"); };
var bo_h22 = function (match, outcome) { return "Team To Score The ".concat(numeralMaleEnding(outcome.condition), " goal"); };
var bo_i22 = function (match, outcome) { return 'First Period Exact Total'; };
var bo_j22 = function (match, outcome) { return 'Second Period Exact Total'; };
var bo_k22 = function (match, outcome) { return "Game Result / Total ".concat(outcome.condition); };
var bo_l22 = function (match, outcome) { return "".concat(match.homeTeam, " First Period Winning Margin"); };
var bo_m22 = function (match, outcome) { return "".concat(match.homeTeam, " Second Period Winning Margin"); };
var bo_n22 = function (match, outcome) { return "".concat(match.awayTeam, " First Period Winning Margin"); };
var bo_o22 = function (match, outcome) { return "".concat(match.awayTeam, " Second Period Winning Margin"); };
var bo_p22 = function (match, outcome) { return "Team To First Score ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['goal', 'goals', 'goals'])); };
var bo_q22 = function (match, outcome) { return 'Hat-Tricks Total'; };
var bo_r22 = function (match, outcome) { return 'To Win Match (inc. shootouts)'; };
var bo_s22 = function (match, outcome) { return "".concat(match.homeTeam, " Victory Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['goal', 'goals', 'goals'])); };
var bo_t22 = function (match, outcome) { return "".concat(match.awayTeam, " Victory Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['goal', 'goals', 'goals'])); };
var bo_u22 = function (match, outcome) { return "Teams To Score Over ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['goal', 'goals', 'goals'])); };
var bo_v22 = function (match, outcome) { return 'First Period Even/Odd'; };
var bo_w22 = function (match, outcome) { return 'Second Period Even/Odd'; };
var bo_x22 = function (match, outcome) { return 'Third Period Even/Odd'; };
var bo_y22 = function (match, outcome) { return 'Highest Scoring Period Total'; };
var bo_z22 = function (match, outcome) { return 'Lowest Scoring Period Total'; };
var bo_a23 = function (match, outcome) { return 'Third Period Exact Total'; };
var bo_b23 = function (match, outcome) { return "".concat(match.homeTeam, " First Period Total"); };
var bo_c23 = function (match, outcome) { return "".concat(match.homeTeam, " Second Period Total"); };
var bo_d23 = function (match, outcome) { return "".concat(match.homeTeam, " Third Period Total"); };
var bo_e23 = function (match, outcome) { return "".concat(match.awayTeam, " First Period Total"); };
var bo_f23 = function (match, outcome) { return "".concat(match.awayTeam, " Second Period Total"); };
var bo_g23 = function (match, outcome) { return "".concat(match.awayTeam, " Third Period Total"); };
var bo_h23 = function (match, outcome) { return 'Overtime'; };
var bo_i23 = function (match, outcome) { return 'Both Teams To Score'; };
var bo_j23 = function (match, outcome) { return "".concat(match.homeTeam, " To Score ").concat(numeralMaleEnding(outcome.condition), " Shootout"); };
var bo_k23 = function (match, outcome) { return "".concat(match.awayTeam, " To Score ").concat(numeralMaleEnding(outcome.condition), " Shootout"); };
var bo_l23 = function (match, outcome) { return 'To Win Match (inc. overtime)'; };
var bo_m23 = function (match, outcome) { return "".concat(match.homeTeam, " to Score Each Period"); };
var bo_n23 = function (match, outcome) { return "".concat(match.awayTeam, "  to Score Each Period"); };
var bo_o23 = function (match, outcome) { return 'To Score Each Period'; };
var bo_p23 = function (match, outcome) { return 'Highest Scoring Period'; };
var bo_q23 = function (match, outcome) { return "".concat(match.homeTeam, " to Win One of Periods"); };
var bo_r23 = function (match, outcome) { return "".concat(match.awayTeam, " to Win One of Periods"); };
var bo_s23 = function (match, outcome) { return 'Draw to Be One of Periods'; };
var bo_t23 = function (match, outcome) { return '1-10 Minutes Result'; };
var bo_u23 = function (match, outcome) { return '11-20 Minutes Result'; };
var bo_v23 = function (match, outcome) { return '21-30 Minutes Result'; };
var bo_w23 = function (match, outcome) { return '31-40 Minutes Result'; };
var bo_x23 = function (match, outcome) { return '41-50 Minutes Result'; };
var bo_y23 = function (match, outcome) { return '51-60 Minutes Result'; };
var bo_z23 = function (match, outcome) { return '1-10 Minutes Handicap'; };
var bo_a24 = function (match, outcome) { return '11-20 Minutes Handicap'; };
var bo_b24 = function (match, outcome) { return '21-30 Minutes Handicap'; };
var bo_c24 = function (match, outcome) { return '31-40 Minutes Handicap'; };
var bo_d24 = function (match, outcome) { return '41-50 Minutes Handicap'; };
var bo_e24 = function (match, outcome) { return '51-60 Minutes Handicap'; };
var bo_f24 = function (match, outcome) { return '1-10 Minutes Total'; };
var bo_g24 = function (match, outcome) { return '11-20 Minutes Total'; };
var bo_h24 = function (match, outcome) { return '21-30 Minutes Total'; };
var bo_i24 = function (match, outcome) { return '31-40 Minutes Total'; };
var bo_j24 = function (match, outcome) { return '41-50 Minutes Total'; };
var bo_k24 = function (match, outcome) { return '51-60 Minutes Total'; };
var bo_l24 = function (match, outcome) { return 'Highest Number Even/Odd'; };
var bo_m24 = function (match, outcome) { return 'Lowest Number Even/Odd'; };
var bo_n24 = function (match, outcome) { return 'First Number Even/Odd'; };
var bo_o24 = function (match, outcome) { return 'Last Number Even/Odd'; };
var bo_p24 = function (match, outcome) { return 'First Is Greater Than Last Number'; };
var bo_q24 = function (match, outcome) { return 'All Drawn Numbers Even'; };
var bo_r24 = function (match, outcome) { return 'All Drawn Numbers Odd'; };
var bo_s24 = function (match, outcome) { return 'Two Сonsecutive Numbers To Draw'; };
var bo_t24 = function (match, outcome) { return 'Lowest Number'; };
var bo_u24 = function (match, outcome) { return 'Highest Number'; };
var bo_v24 = function (match, outcome) { return 'Drawn Numbers Total Value'; };
var bo_w24 = function (match, outcome) { return "To Draw A Number Divisible By ".concat(outcome.condition); };
var bo_x24 = function (match, outcome) { return 'Difference Between The Highest And The Lowest Numbers Drawn'; };
var bo_y24 = function (match, outcome) { return 'Odd Numbers Total Value'; };
var bo_z24 = function (match, outcome) { return 'Even Numbers Total Value'; };
var bo_a25 = function (match, outcome) { return 'First Number'; };
var bo_b25 = function (match, outcome) { return 'Second Number'; };
var bo_c25 = function (match, outcome) { return 'Third Number'; };
var bo_d25 = function (match, outcome) { return 'Fourth Number'; };
var bo_e25 = function (match, outcome) { return 'Fifth Number'; };
var bo_f25 = function (match, outcome) { return 'Sixth Number'; };
var bo_g25 = function (match, outcome) { return 'Seventh Number'; };
var bo_h25 = function (match, outcome) { return "At Least One Number Drawn Between ".concat(outcome.condition, " - ").concat(outcome.conditionTwo); };
var bo_i25 = function (match, outcome) { return 'Lowest And Highest Numbers Drawn Total'; };
var bo_j25 = function (match, outcome) { return "".concat(match.homeTeam, " to win by Submission"); };
var bo_k25 = function (match, outcome) { return "".concat(match.awayTeam, " to win by Submission"); };
var bo_l25 = function (match, outcome) { return "".concat(match.homeTeam, " to win by KO/TKO/DQ"); };
var bo_m25 = function (match, outcome) { return "".concat(match.awayTeam, " to win by KO/TKO/DQ"); };
var bo_n25 = function (match, outcome) { return 'Medals Total'; };
var bo_o25 = function (match, outcome) { return 'Twenty Ninth Frame Result'; };
var bo_p25 = function (match, outcome) { return 'Thirtieth Frame Result'; };
var bo_q25 = function (match, outcome) { return 'Thirty First Frame Result'; };
var bo_r25 = function (match, outcome) { return 'Thirty Second Frame Result'; };
var bo_s25 = function (match, outcome) { return 'Thirty Third Frame Result'; };
var bo_t25 = function (match, outcome) { return 'Thirty Fourth Frame Result'; };
var bo_u25 = function (match, outcome) { return 'Thirty Fifth Frame Result'; };
var bo_v25 = function (match, outcome) { return 'Thirty Sixth Frame Result'; };
var bo_w25 = function (match, outcome) { return 'Thirty Seventh Frame Result'; };
var bo_x25 = function (match, outcome) { return 'Eighteenth Frame Even/Odd'; };
var bo_y25 = function (match, outcome) { return 'Nineteenth Frame Even/Odd'; };
var bo_z25 = function (match, outcome) { return 'Twentieth Frame Even/Odd'; };
var bo_a26 = function (match, outcome) { return 'Twenty First Frame Even/Odd'; };
var bo_b26 = function (match, outcome) { return 'Twenty Second Frame Even/Odd'; };
var bo_c26 = function (match, outcome) { return 'Twenty Third Frame Even/Odd'; };
var bo_d26 = function (match, outcome) { return 'Twenty Fourth Frame Even/Odd'; };
var bo_e26 = function (match, outcome) { return 'Twenty Fifth Frame Even/Odd'; };
var bo_f26 = function (match, outcome) { return 'Twenty Sixth Frame Even/Odd'; };
var bo_g26 = function (match, outcome) { return 'Twenty Seventh Frame Even/Odd'; };
var bo_h26 = function (match, outcome) { return 'Twenty Eighth Frame Even/Odd'; };
var bo_i26 = function (match, outcome) { return 'Twenty Ninth Frame Even/Odd'; };
var bo_j26 = function (match, outcome) { return 'Thirty Frame Even/Odd'; };
var bo_k26 = function (match, outcome) { return 'Thirty First Frame Even/Odd'; };
var bo_l26 = function (match, outcome) { return 'Thirty Second Frame Even/Odd'; };
var bo_m26 = function (match, outcome) { return 'Thirty Third Frame Even/Odd'; };
var bo_n26 = function (match, outcome) { return 'Thirty Fourth Frame Even/Odd'; };
var bo_o26 = function (match, outcome) { return 'Thirty Fifth Frame Even/Odd'; };
var bo_p26 = function (match, outcome) { return 'Thirty Sixth Frame Even/Odd'; };
var bo_q26 = function (match, outcome) { return 'Thirty Seventh Frame Even/Odd'; };
var bo_r26 = function (match, outcome) { return 'First Legally Potted Colour - First Frame'; };
var bo_s26 = function (match, outcome) { return 'First Legally Potted Colour - Second Frame'; };
var bo_t26 = function (match, outcome) { return 'First Legally Potted Colour - Third Frame'; };
var bo_u26 = function (match, outcome) { return 'First Legally Potted Colour - Fourth Frame'; };
var bo_v26 = function (match, outcome) { return 'First Legally Potted Colour - Fifth Frame'; };
var bo_w26 = function (match, outcome) { return 'First Legally Potted Colour - Sixth Frame'; };
var bo_x26 = function (match, outcome) { return 'First Legally Potted Colour - Seventh Frame'; };
var bo_y26 = function (match, outcome) { return 'First Legally Potted Colour - Eighth Frame'; };
var bo_z26 = function (match, outcome) { return 'First Legally Potted Colour - Ninth Frame'; };
var bo_a27 = function (match, outcome) { return 'First Legally Potted Colour - Tenth Frame'; };
var bo_b27 = function (match, outcome) { return 'First Legally Potted Colour - Eleventh Frame'; };
var bo_c27 = function (match, outcome) { return 'First Legally Potted Colour - Twelfth Frame'; };
var bo_d27 = function (match, outcome) { return 'First Legally Potted Colour - Thirteenth Frame'; };
var bo_e27 = function (match, outcome) { return 'First Legally Potted Colour - Fourteenth Frame'; };
var bo_f27 = function (match, outcome) { return 'First Legally Potted Colour - Fifteenth Frame'; };
var bo_g27 = function (match, outcome) { return 'First Legally Potted Colour - Sixteenth Frame'; };
var bo_h27 = function (match, outcome) { return 'First Legally Potted Colour - Seventeenth Frame'; };
var bo_i27 = function (match, outcome) { return 'First Legally Potted Colour - Eighteenth Frame'; };
var bo_j27 = function (match, outcome) { return 'First Legally Potted Colour - Nineteenth Frame'; };
var bo_k27 = function (match, outcome) { return 'First Legally Potted Colour - Twentieth Frame'; };
var bo_l27 = function (match, outcome) { return 'First Legally Potted Colour - Twenty First Frame'; };
var bo_m27 = function (match, outcome) { return 'First Legally Potted Colour - Twenty Second Frame'; };
var bo_n27 = function (match, outcome) { return 'First Legally Potted Colour - Twenty Third Frame'; };
var bo_o27 = function (match, outcome) { return 'First Legally Potted Colour - Twenty Fourth Frame'; };
var bo_p27 = function (match, outcome) { return 'First Legally Potted Colour - Twenty Fifth Frame'; };
var bo_q27 = function (match, outcome) { return 'First Legally Potted Colour - Twenty Sixth Frame'; };
var bo_r27 = function (match, outcome) { return 'First Legally Potted Colour - Twenty Seventh Frame'; };
var bo_s27 = function (match, outcome) { return 'First Legally Potted Colour - Twenty Eighth Frame'; };
var bo_t27 = function (match, outcome) { return 'First Legally Potted Colour - Twenty Ninth Frame'; };
var bo_u27 = function (match, outcome) { return 'First Legally Potted Colour - Thirtieth Frame'; };
var bo_v27 = function (match, outcome) { return 'First Legally Potted Colour - Thirty First Frame'; };
var bo_w27 = function (match, outcome) { return 'First Legally Potted Colour - Thirty Second Frame'; };
var bo_x27 = function (match, outcome) { return 'First Legally Potted Colour - Thirty Third Frame'; };
var bo_y27 = function (match, outcome) { return 'First Legally Potted Colour - Thirty Fourth Frame'; };
var bo_z27 = function (match, outcome) { return 'First Legally Potted Colour - Thirty Fifth Frame'; };
var bo_a28 = function (match, outcome) { return 'First Legally Potted Colour - Thirty Sixth Frame'; };
var bo_b28 = function (match, outcome) { return 'First Legally Potted Colour - Thirty Seventh Frame'; };
var bo_c28 = function (match, outcome) { return 'First Frame Result'; };
var bo_d28 = function (match, outcome) { return 'Second Frame Result'; };
var bo_e28 = function (match, outcome) { return 'Third Frame Result'; };
var bo_f28 = function (match, outcome) { return 'Fourth Frame Result'; };
var bo_g28 = function (match, outcome) { return 'Fifth Frame Result'; };
var bo_h28 = function (match, outcome) { return 'Sixth Frame Result'; };
var bo_i28 = function (match, outcome) { return 'Seventh Frame Result'; };
var bo_j28 = function (match, outcome) { return 'Eighth Frame Result'; };
var bo_k28 = function (match, outcome) { return 'Ninth Frame Result'; };
var bo_l28 = function (match, outcome) { return 'Tenth Frame Result'; };
var bo_m28 = function (match, outcome) { return 'Eleventh Frame Result'; };
var bo_n28 = function (match, outcome) { return 'Twelfth Frame Result'; };
var bo_o28 = function (match, outcome) { return 'Thirteenth Frame Result'; };
var bo_p28 = function (match, outcome) { return 'Fourteenth Frame Result'; };
var bo_q28 = function (match, outcome) { return 'Fifteenth Frame Result'; };
var bo_r28 = function (match, outcome) { return 'Sixteenth Frame Result'; };
var bo_s28 = function (match, outcome) { return 'Seventeenth Frame Result'; };
var bo_t28 = function (match, outcome) { return 'Eighteenth Frame Result'; };
var bo_u28 = function (match, outcome) { return 'Nineteenth Frame Result'; };
var bo_v28 = function (match, outcome) { return 'Twentieth Frame Result'; };
var bo_w28 = function (match, outcome) { return 'Twenty First Frame Result'; };
var bo_x28 = function (match, outcome) { return 'Twenty Second Frame Result'; };
var bo_y28 = function (match, outcome) { return 'Twenty Third Frame Result'; };
var bo_z28 = function (match, outcome) { return 'Twenty Fourth Frame Result'; };
var bo_a29 = function (match, outcome) { return 'Twenty Fifth Frame Result'; };
var bo_b29 = function (match, outcome) { return 'Twenty Sixth Frame Result'; };
var bo_c29 = function (match, outcome) { return 'Twenty Seventh Frame Result'; };
var bo_d29 = function (match, outcome) { return 'Twenty Eighth Frame Result'; };
var bo_e29 = function (match, outcome) { return 'First Player To Pot - Seventh Frame'; };
var bo_f29 = function (match, outcome) { return 'First Player To Pot - Eighth Frame'; };
var bo_g29 = function (match, outcome) { return 'First Player To Pot - Ninth Frame'; };
var bo_h29 = function (match, outcome) { return 'First Player To Pot - Tenth Frame'; };
var bo_i29 = function (match, outcome) { return 'First Player To Pot - Eleventh Frame'; };
var bo_j29 = function (match, outcome) { return 'First Player To Pot - Twelfth Frame'; };
var bo_k29 = function (match, outcome) { return 'First Player To Pot - Thirteenth Frame'; };
var bo_l29 = function (match, outcome) { return 'First Player To Pot - Fourteenth Frame'; };
var bo_m29 = function (match, outcome) { return 'First Player To Pot - Fifteenth Frame'; };
var bo_n29 = function (match, outcome) { return 'First Player To Pot - Sixteenth Frame'; };
var bo_o29 = function (match, outcome) { return 'First Player To Pot - Seventeenth Frame'; };
var bo_p29 = function (match, outcome) { return 'First Player To Pot - Eighteenth Frame'; };
var bo_q29 = function (match, outcome) { return 'First Player To Pot - Nineteenth Frame'; };
var bo_r29 = function (match, outcome) { return 'First Player To Pot - Twentieth Frame'; };
var bo_s29 = function (match, outcome) { return 'First Player To Pot - Twenty First Frame'; };
var bo_t29 = function (match, outcome) { return 'First Player To Pot - Twenty Second Frame'; };
var bo_u29 = function (match, outcome) { return 'First Player To Pot - Twenty Third Frame'; };
var bo_v29 = function (match, outcome) { return 'First Player To Pot - Twenty Fourth Frame'; };
var bo_w29 = function (match, outcome) { return 'First Player To Pot - Twenty Fifth Frame'; };
var bo_x29 = function (match, outcome) { return 'First Player To Pot - Twenty Sixth Frame'; };
var bo_y29 = function (match, outcome) { return 'First Player To Pot - Twenty Seventh Frame'; };
var bo_z29 = function (match, outcome) { return 'First Player To Pot - Twenty Eighth Frame'; };
var bo_a30 = function (match, outcome) { return 'First Player To Pot - Twenty Ninth Frame'; };
var bo_b30 = function (match, outcome) { return 'First Player To Pot - Thirtieth Frame'; };
var bo_c30 = function (match, outcome) { return 'First Player To Pot - Thirty First Frame'; };
var bo_d30 = function (match, outcome) { return 'First Player To Pot - Thirty Second Frame'; };
var bo_e30 = function (match, outcome) { return 'First Player To Pot - Thirty Third Frame'; };
var bo_f30 = function (match, outcome) { return 'First Player To Pot - Thirty Fourth Frame'; };
var bo_g30 = function (match, outcome) { return 'First Player To Pot - Thirty Fifth Frame'; };
var bo_h30 = function (match, outcome) { return 'First Player To Pot - Thirty Sixth Frame'; };
var bo_i30 = function (match, outcome) { return 'First Player To Pot - Thirty Seventh Frame'; };
var bo_j30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The First Frame"); };
var bo_k30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Second Frame"); };
var bo_l30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Third Frame"); };
var bo_m30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Fourth Frame"); };
var bo_n30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Fifth Frame"); };
var bo_o30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Sixth Frame"); };
var bo_p30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Seventh Frame"); };
var bo_q30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Eighth Frame"); };
var bo_r30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Ninth Frame"); };
var bo_s30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Tenth Frame"); };
var bo_t30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Eleventh Frame"); };
var bo_u30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Twelfth Frame"); };
var bo_v30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Thirteenth Frame"); };
var bo_w30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Fourteenth Frame"); };
var bo_x30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Fifteenth Frame"); };
var bo_y30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Sixteenth Frame"); };
var bo_z30 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Seventeenth Frame"); };
var bo_a31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Eighteenth Frame"); };
var bo_b31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Nineteenth Frame"); };
var bo_c31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Twentieth Frame"); };
var bo_d31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Twenty First Frame"); };
var bo_e31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Twenty Second Frame"); };
var bo_f31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Twenty Third Frame"); };
var bo_g31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Twenty Fourth Frame"); };
var bo_h31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Twenty Fifth Frame"); };
var bo_i31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Twenty Sixth Frame"); };
var bo_j31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Twenty Seventh Frame"); };
var bo_k31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Twenty Eighth Frame"); };
var bo_l31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Twenty Ninth Frame"); };
var bo_m31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Thirtieth Frame"); };
var bo_n31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Thirty First Frame"); };
var bo_o31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Thirty Second Frame"); };
var bo_p31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Thirty Third Frame"); };
var bo_q31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Thirty Fourth Frame"); };
var bo_r31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Thirty Fifth Frame"); };
var bo_s31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Thirty Sixth Frame"); };
var bo_t31 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " In The Thirty Seventh Frame"); };
var bo_u31 = function (match, outcome) { return 'First Frame Even/Odd'; };
var bo_v31 = function (match, outcome) { return 'Second Frame Even/Odd'; };
var bo_w31 = function (match, outcome) { return 'Third Frame Even/Odd'; };
var bo_x31 = function (match, outcome) { return 'Fourth Frame Even/Odd'; };
var bo_y31 = function (match, outcome) { return 'Fifth Frame Even/Odd'; };
var bo_z31 = function (match, outcome) { return 'Sixth Frame Even/Odd'; };
var bo_a32 = function (match, outcome) { return 'Seventh Frame Even/Odd'; };
var bo_b32 = function (match, outcome) { return 'Eighth Frame Even/Odd'; };
var bo_c32 = function (match, outcome) { return 'Ninth Frame Even/Odd'; };
var bo_d32 = function (match, outcome) { return 'Tenth Frame Even/Odd'; };
var bo_e32 = function (match, outcome) { return 'Eleventh Frame Even/Odd'; };
var bo_f32 = function (match, outcome) { return 'Twelfth Frame Even/Odd'; };
var bo_g32 = function (match, outcome) { return 'Thirteenth Frame Even/Odd'; };
var bo_h32 = function (match, outcome) { return 'Fourteenth Frame Even/Odd'; };
var bo_i32 = function (match, outcome) { return 'Fifteenth Frame Even/Odd'; };
var bo_j32 = function (match, outcome) { return 'Sixteenth Frame Even/Odd'; };
var bo_k32 = function (match, outcome) { return 'Seventeenth Frame Even/Odd'; };
var bo_l32 = function (match, outcome) { return 'Match Century Breaks Total'; };
var bo_m32 = function (match, outcome) { return 'First Frame Handicap'; };
var bo_n32 = function (match, outcome) { return 'Second Frame Handicap'; };
var bo_o32 = function (match, outcome) { return 'Third Frame Handicap'; };
var bo_p32 = function (match, outcome) { return 'Fourth Frame Handicap'; };
var bo_q32 = function (match, outcome) { return 'Fifth Frame Handicap'; };
var bo_r32 = function (match, outcome) { return 'Sixth Frame Handicap'; };
var bo_s32 = function (match, outcome) { return 'Seventh Frame Handicap'; };
var bo_t32 = function (match, outcome) { return 'Eighth Frame Handicap'; };
var bo_u32 = function (match, outcome) { return 'Ninth Frame Handicap'; };
var bo_v32 = function (match, outcome) { return 'Tenth Frame Handicap'; };
var bo_w32 = function (match, outcome) { return 'Eleventh Frame Handicap'; };
var bo_x32 = function (match, outcome) { return 'Twelfth Frame Handicap'; };
var bo_y32 = function (match, outcome) { return 'Thirteenth Frame Handicap'; };
var bo_z32 = function (match, outcome) { return 'Fourteenth Frame Handicap'; };
var bo_a33 = function (match, outcome) { return 'Fifteenth Frame Handicap'; };
var bo_b33 = function (match, outcome) { return 'Sixteenth Frame Handicap'; };
var bo_c33 = function (match, outcome) { return 'Seventeenth Frame Handicap'; };
var bo_d33 = function (match, outcome) { return 'Eighteenth Frame Handicap'; };
var bo_e33 = function (match, outcome) { return 'Nineteenth Frame Handicap'; };
var bo_f33 = function (match, outcome) { return 'Twentieth Frame Handicap'; };
var bo_g33 = function (match, outcome) { return 'Twenty First Frame Handicap'; };
var bo_h33 = function (match, outcome) { return 'Twenty Second Frame Handicap'; };
var bo_i33 = function (match, outcome) { return 'Twenty Third Frame Handicap'; };
var bo_j33 = function (match, outcome) { return 'Twenty Fourth Frame Handicap'; };
var bo_k33 = function (match, outcome) { return 'Twenty Fifth Frame Handicap'; };
var bo_l33 = function (match, outcome) { return 'Twenty Sixth Frame Handicap'; };
var bo_m33 = function (match, outcome) { return 'Twenty Seventh Frame Handicap'; };
var bo_n33 = function (match, outcome) { return 'Twenty Eighth Frame Handicap'; };
var bo_o33 = function (match, outcome) { return 'Twenty Ninth Frame Handicap'; };
var bo_p33 = function (match, outcome) { return 'Thirty Frame Handicap'; };
var bo_q33 = function (match, outcome) { return 'Thirty First Frame Handicap'; };
var bo_r33 = function (match, outcome) { return 'Thirty Second Frame Handicap'; };
var bo_s33 = function (match, outcome) { return 'Thirty Third Frame Handicap'; };
var bo_t33 = function (match, outcome) { return 'Thirty Fourth Frame Handicap'; };
var bo_u33 = function (match, outcome) { return 'Thirty Fifth Frame Handicap'; };
var bo_v33 = function (match, outcome) { return 'Thirty Sixth Frame Handicap'; };
var bo_w33 = function (match, outcome) { return 'Thirty Seventh Frame Handicap'; };
var bo_x33 = function (match, outcome) { return 'First Frame Total'; };
var bo_y33 = function (match, outcome) { return 'Second Frame Total'; };
var bo_z33 = function (match, outcome) { return 'Third Frame Total'; };
var bo_a34 = function (match, outcome) { return 'Fourth Frame Total'; };
var bo_b34 = function (match, outcome) { return 'Fifth Frame Total'; };
var bo_c34 = function (match, outcome) { return 'Sixth Frame Total'; };
var bo_d34 = function (match, outcome) { return 'Seventh Frame Total'; };
var bo_e34 = function (match, outcome) { return 'Eighth Frame Total'; };
var bo_f34 = function (match, outcome) { return 'Ninth Frame Total'; };
var bo_g34 = function (match, outcome) { return 'Tenth Frame Total'; };
var bo_h34 = function (match, outcome) { return 'Eleventh Frame Total'; };
var bo_i34 = function (match, outcome) { return 'Twelfth Frame Total'; };
var bo_j34 = function (match, outcome) { return 'Thirteenth Frame Total'; };
var bo_k34 = function (match, outcome) { return 'Fourteenth Frame Total'; };
var bo_l34 = function (match, outcome) { return 'Fifteenth Frame Total'; };
var bo_m34 = function (match, outcome) { return 'Sixteenth Frame Total'; };
var bo_n34 = function (match, outcome) { return 'Seventeenth Frame Total'; };
var bo_o34 = function (match, outcome) { return 'Eighteenth Frame Total'; };
var bo_p34 = function (match, outcome) { return 'Nineteenth Frame Total'; };
var bo_q34 = function (match, outcome) { return 'Twentieth Frame Total'; };
var bo_r34 = function (match, outcome) { return 'Twenty First Frame Total'; };
var bo_s34 = function (match, outcome) { return 'Twenty Second Frame Total'; };
var bo_t34 = function (match, outcome) { return 'Twenty Third Frame'; };
var bo_u34 = function (match, outcome) { return 'Twenty Fourth Frame Total'; };
var bo_v34 = function (match, outcome) { return 'Twenty Fifth Frame Total'; };
var bo_w34 = function (match, outcome) { return 'Twenty Sixth Frame Total'; };
var bo_x34 = function (match, outcome) { return 'Twenty Seventh Frame Total'; };
var bo_y34 = function (match, outcome) { return 'Twenty Eighth Frame Total'; };
var bo_z34 = function (match, outcome) { return 'Twenty Ninth Frame Total'; };
var bo_a35 = function (match, outcome) { return 'Thirtieth Frame Total'; };
var bo_b35 = function (match, outcome) { return 'Thirty First Frame Total'; };
var bo_c35 = function (match, outcome) { return 'Thirty Second Frame Total'; };
var bo_d35 = function (match, outcome) { return 'Thirty Third Frame Total'; };
var bo_e35 = function (match, outcome) { return 'Thirty Fourth Frame'; };
var bo_f35 = function (match, outcome) { return 'Thirty Fifth Frame Total'; };
var bo_g35 = function (match, outcome) { return 'Thirty Sixth Frame Total'; };
var bo_h35 = function (match, outcome) { return 'Thirty Seventh Frame Total'; };
var bo_i35 = function (match, outcome) { return 'First Player To Pot - First Frame'; };
var bo_j35 = function (match, outcome) { return 'First Player To Pot - Second Frame'; };
var bo_k35 = function (match, outcome) { return 'First Player To Pot - Third Frame'; };
var bo_l35 = function (match, outcome) { return 'First Player To Pot - Fourth Frame'; };
var bo_m35 = function (match, outcome) { return 'First Player To Pot - Fifth Frame'; };
var bo_n35 = function (match, outcome) { return 'First Player To Pot - Sixth Frame'; };
var bo_o35 = function (match, outcome) { return 'Fourth Game Handicap'; };
var bo_p35 = function (match, outcome) { return 'Fifth Game Handicap'; };
var bo_q35 = function (match, outcome) { return 'Sixth Game Handicap'; };
var bo_r35 = function (match, outcome) { return 'Seventh Game Handicap'; };
var bo_s35 = function (match, outcome) { return 'Fourth Game Total'; };
var bo_t35 = function (match, outcome) { return 'Fifth Game Total'; };
var bo_u35 = function (match, outcome) { return 'Sixth Game Total'; };
var bo_v35 = function (match, outcome) { return 'Seventh Game Total'; };
var bo_w35 = function (match, outcome) { return 'Match Games Total'; };
var bo_x35 = function (match, outcome) { return "".concat(match.homeTeam, " Fourth Game Total"); };
var bo_y35 = function (match, outcome) { return "".concat(match.homeTeam, " Fifth Game Total"); };
var bo_z35 = function (match, outcome) { return "".concat(match.homeTeam, " Sixth Game Total"); };
var bo_a36 = function (match, outcome) { return "".concat(match.homeTeam, " Seventh Game Total"); };
var bo_b36 = function (match, outcome) { return "".concat(match.awayTeam, " Fourth Game Total"); };
var bo_c36 = function (match, outcome) { return "".concat(match.awayTeam, " Fifth Game Total"); };
var bo_d36 = function (match, outcome) { return "".concat(match.awayTeam, " Sixth Game Total"); };
var bo_e36 = function (match, outcome) { return "".concat(match.awayTeam, " Seventh Game Total"); };
var bo_f36 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " - Fourth Game"); };
var bo_g36 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " - Fifth Game"); };
var bo_h36 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " - Sixth Game"); };
var bo_i36 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " - Seventh Game"); };
var bo_j36 = function (match, outcome) { return 'Fourth Game Winner'; };
var bo_k36 = function (match, outcome) { return 'Fifth Game Winner'; };
var bo_l36 = function (match, outcome) { return 'Sixth Game Winner'; };
var bo_m36 = function (match, outcome) { return 'Seventh Game Winner'; };
var bo_n36 = function (match, outcome) { return "".concat(match.homeTeam, " 1st Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_o36 = function (match, outcome) { return "".concat(match.homeTeam, " 2nd Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_p36 = function (match, outcome) { return "".concat(match.homeTeam, " 3rd Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_q36 = function (match, outcome) { return "".concat(match.homeTeam, " 4th Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_r36 = function (match, outcome) { return "".concat(match.homeTeam, " 5th Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_s36 = function (match, outcome) { return "".concat(match.homeTeam, " 6th Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_t36 = function (match, outcome) { return "".concat(match.homeTeam, " 7th Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_u36 = function (match, outcome) { return "".concat(match.awayTeam, " 1st Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_v36 = function (match, outcome) { return "".concat(match.awayTeam, " 2nd Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_w36 = function (match, outcome) { return "".concat(match.awayTeam, " 3rd Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_x36 = function (match, outcome) { return "".concat(match.awayTeam, " 4th Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_y36 = function (match, outcome) { return "".concat(match.awayTeam, " 5th Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_z36 = function (match, outcome) { return "".concat(match.awayTeam, " 6th Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_a37 = function (match, outcome) { return "".concat(match.awayTeam, " 7th Game Winning Margin - ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points'])); };
var bo_b37 = function (match, outcome) { return 'First Game Exact Total'; };
var bo_c37 = function (match, outcome) { return 'Second Game Exact Total'; };
var bo_d37 = function (match, outcome) { return 'Third Game Exact Total'; };
var bo_e37 = function (match, outcome) { return 'Fourth Game Exact Total'; };
var bo_f37 = function (match, outcome) { return 'Fifth Game Exact Total'; };
var bo_g37 = function (match, outcome) { return 'Sixth Game Exact Total'; };
var bo_h37 = function (match, outcome) { return 'Seventh Game Exact Total'; };
var bo_i37 = function (match, outcome) { return "".concat(numeralNeuterEnding(outcome.condition), " Point - First Game"); };
var bo_j37 = function (match, outcome) { return "".concat(numeralNeuterEnding(outcome.condition), " Point - Second Game"); };
var bo_k37 = function (match, outcome) { return "".concat(numeralNeuterEnding(outcome.condition), " Point - Third Game"); };
var bo_l37 = function (match, outcome) { return "".concat(numeralNeuterEnding(outcome.condition), " Point - Fourth Game"); };
var bo_m37 = function (match, outcome) { return "".concat(numeralNeuterEnding(outcome.condition), " Point - Fifth Game"); };
var bo_n37 = function (match, outcome) { return "".concat(numeralNeuterEnding(outcome.condition), " Point - Sixth Game"); };
var bo_o37 = function (match, outcome) { return "".concat(numeralNeuterEnding(outcome.condition), " Point - Seventh Game"); };
var bo_p37 = function (match, outcome) { return 'Fourth Set Even/Odd'; };
var bo_q37 = function (match, outcome) { return 'Fifth Set Even/Odd'; };
var bo_r37 = function (match, outcome) { return 'Sixth Set Even/Odd'; };
var bo_s37 = function (match, outcome) { return 'Seventh Set Even/Odd'; };
var bo_t37 = function (match, outcome) { return 'Match Correct Score'; };
var bo_u37 = function (match, outcome) { return "".concat(match.awayTeam, " To Break In The 1st or 2-nd Games"); };
var bo_v37 = function (match, outcome) { return 'Games Taken In A Row Total By Player'; };
var bo_w37 = function (match, outcome) { return 'Players To Exchange The Breaks'; };
var bo_x37 = function (match, outcome) { return "".concat(match.homeTeam, " Fourth Set Total"); };
var bo_y37 = function (match, outcome) { return "".concat(match.homeTeam, " Fifth Set Total"); };
var bo_z37 = function (match, outcome) { return "".concat(match.awayTeam, " Fourth Set Total"); };
var bo_a38 = function (match, outcome) { return "".concat(match.awayTeam, " Fifth Set Total"); };
var bo_b38 = function (match, outcome) { return 'First Set / Match'; };
var bo_c38 = function (match, outcome) { return "Break Point In The ".concat(outcome.condition, " Game"); };
var bo_d38 = function (match, outcome) { return 'Second Set Breaks Total'; };
var bo_e38 = function (match, outcome) { return 'Third Set Breaks Total'; };
var bo_f38 = function (match, outcome) { return 'Fourth Set Breaks Total'; };
var bo_g38 = function (match, outcome) { return 'Fifth Set Breaks Total'; };
var bo_h38 = function (match, outcome) { return "Result & Total ".concat(outcome.condition, " - Second Set"); };
var bo_i38 = function (match, outcome) { return "Result & Total ".concat(outcome.condition, " - Third Set"); };
var bo_j38 = function (match, outcome) { return "Result & Total ".concat(outcome.condition, " - Fourth Set"); };
var bo_k38 = function (match, outcome) { return "Result & Total ".concat(outcome.condition, " - Fifth Set"); };
var bo_l38 = function (match, outcome) { return "".concat(match.homeTeam, " First Set Breaks Total"); };
var bo_m38 = function (match, outcome) { return "".concat(match.homeTeam, " Second Set Breaks Total"); };
var bo_n38 = function (match, outcome) { return "".concat(match.homeTeam, " Third Set Breaks Total"); };
var bo_o38 = function (match, outcome) { return "".concat(match.homeTeam, " Fourth Set Breaks Total"); };
var bo_p38 = function (match, outcome) { return "".concat(match.homeTeam, " Fifth Set Breaks Total"); };
var bo_q38 = function (match, outcome) { return "".concat(match.awayTeam, " First Set Breaks Total"); };
var bo_r38 = function (match, outcome) { return "".concat(match.awayTeam, " Second Set Breaks Total"); };
var bo_s38 = function (match, outcome) { return "".concat(match.awayTeam, " Third Set Breaks Total"); };
var bo_t38 = function (match, outcome) { return "".concat(match.awayTeam, " Fourth Set Breaks Total"); };
var bo_u38 = function (match, outcome) { return "".concat(match.awayTeam, " Fifth Set Breaks Total"); };
var bo_v38 = function (match, outcome) { return "A Player To Win ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - First Set"); };
var bo_w38 = function (match, outcome) { return "A Player To Win ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - Second Set"); };
var bo_x38 = function (match, outcome) { return "A Player To Win ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - Third Set"); };
var bo_y38 = function (match, outcome) { return "A Player To Win ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - Fourth Set"); };
var bo_z38 = function (match, outcome) { return "A Player To Win ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - Fifth Set"); };
var bo_a39 = function (match, outcome) { return "".concat(match.homeTeam, " To Win ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - Second Set"); };
var bo_b39 = function (match, outcome) { return "".concat(match.homeTeam, " To Win ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - Third Set"); };
var bo_c39 = function (match, outcome) { return "".concat(match.homeTeam, " To Win ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - Fourth Set"); };
var bo_d39 = function (match, outcome) { return "".concat(match.homeTeam, " To Win ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - Fifth Set"); };
var bo_e39 = function (match, outcome) { return "".concat(match.awayTeam, " To Win ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - First Set"); };
var bo_f39 = function (match, outcome) { return "".concat(match.awayTeam, " To Win ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - Second Set"); };
var bo_g39 = function (match, outcome) { return "".concat(match.awayTeam, " To Win ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - Third Set"); };
var bo_h39 = function (match, outcome) { return "".concat(match.awayTeam, " To Win ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - Fourth Set"); };
var bo_i39 = function (match, outcome) { return "".concat(match.awayTeam, " To Win ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " In A Row - Fifth Set"); };
var bo_j39 = function (match, outcome) { return 'Match Handicap'; };
var bo_k39 = function (match, outcome) { return 'Fourth Set Handicap'; };
var bo_l39 = function (match, outcome) { return 'Fifth Set Handicap'; };
var bo_m39 = function (match, outcome) { return 'Fourth Set Total'; };
var bo_n39 = function (match, outcome) { return 'Fifth Set Total'; };
var bo_o39 = function (match, outcome) { return 'Number of Sets'; };
var bo_p39 = function (match, outcome) { return "".concat(outcome.condition, " Game Score"); };
var bo_q39 = function (match, outcome) { return "".concat(outcome.condition, " Game Winner"); };
var bo_r39 = function (match, outcome) { return '1st Set Score'; };
var bo_s39 = function (match, outcome) { return '2nd Set Score'; };
var bo_t39 = function (match, outcome) { return '3rd Set Score'; };
var bo_u39 = function (match, outcome) { return '4th Set Score'; };
var bo_v39 = function (match, outcome) { return '5th Set Score'; };
var bo_w39 = function (match, outcome) { return "15X15 in ".concat(outcome.condition, " Game"); };
var bo_x39 = function (match, outcome) { return "30X30 in ".concat(outcome.condition, " Game"); };
var bo_y39 = function (match, outcome) { return "".concat(outcome.condition, " Game To Deuce"); };
var bo_z39 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " - First Set"); };
var bo_a40 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " - Second Set"); };
var bo_b40 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " - Third Set"); };
var bo_c40 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " - Fourth Set"); };
var bo_d40 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['Game', 'Games', 'Games']), " - Fifth Set"); };
var bo_e40 = function (match, outcome) { return 'Fourth Set Winner'; };
var bo_f40 = function (match, outcome) { return 'Fifth Set Winner'; };
var bo_g40 = function (match, outcome) { return "First Point - ".concat(outcome.condition, " Game"); };
var bo_h40 = function (match, outcome) { return 'Tie Break in First Set'; };
var bo_i40 = function (match, outcome) { return 'Tie Break in Second Set'; };
var bo_j40 = function (match, outcome) { return 'Tie Break in Third Set'; };
var bo_k40 = function (match, outcome) { return 'Tie Break in Fourth Set'; };
var bo_l40 = function (match, outcome) { return 'Tie Break in Fifth Set'; };
var bo_m40 = function (match, outcome) { return 'Tie Break in Match'; };
var bo_n40 = function (match, outcome) { return 'First Set Tie-Break Total'; };
var bo_o40 = function (match, outcome) { return 'Second Set Tie-Break Total'; };
var bo_p40 = function (match, outcome) { return 'Third Set Tie-Break Total'; };
var bo_q40 = function (match, outcome) { return 'Fourth Set Tie-Break Total'; };
var bo_r40 = function (match, outcome) { return 'Fifth Set Tie-Break Total'; };
var bo_s40 = function (match, outcome) { return 'First Set Tie-Break Score'; };
var bo_t40 = function (match, outcome) { return 'Second Set Tie-Break Score'; };
var bo_u40 = function (match, outcome) { return 'Third Set Tie-Break Score'; };
var bo_v40 = function (match, outcome) { return 'Fourth Set Tie-Break Score'; };
var bo_w40 = function (match, outcome) { return 'Fifth Set Tie-Break Score'; };
var bo_x40 = function (match, outcome) { return 'First Set Tie Break Exact Total'; };
var bo_y40 = function (match, outcome) { return 'Second Set Tie Break Exact Total'; };
var bo_z40 = function (match, outcome) { return 'Third Set Tie Break Exact Total'; };
var bo_a41 = function (match, outcome) { return 'Fourth Set Tie Break Exact Total'; };
var bo_b41 = function (match, outcome) { return 'Fifth Set Tie Break Exact Total'; };
var bo_c41 = function (match, outcome) { return 'First Set Tie Break Winner'; };
var bo_d41 = function (match, outcome) { return 'Second Set Tie Break Winner'; };
var bo_e41 = function (match, outcome) { return 'Third Set Tie Break Winner'; };
var bo_f41 = function (match, outcome) { return 'Fourth Set Tie Break Winner'; };
var bo_g41 = function (match, outcome) { return 'Fifth Set Tie Break Winner'; };
var bo_h41 = function (match, outcome) { return 'First Set Breaks Total'; };
var bo_i41 = function (match, outcome) { return 'Match Breaks Total'; };
var bo_j41 = function (match, outcome) { return "".concat(match.homeTeam, " To Win A Set In The Match"); };
var bo_k41 = function (match, outcome) { return "".concat(match.awayTeam, " To Win A Set In The Match"); };
var bo_l41 = function (match, outcome) { return "Result & Total ".concat(outcome.condition, " - First Set"); };
var bo_m41 = function (match, outcome) { return 'Lowest Scoring Set Total'; };
var bo_n41 = function (match, outcome) { return 'To Serve The First Ace'; };
var bo_o41 = function (match, outcome) { return 'To Double Fault First'; };
var bo_p41 = function (match, outcome) { return "".concat(match.homeTeam, " Highest Serving Speed (km/h)"); };
var bo_q41 = function (match, outcome) { return "".concat(match.awayTeam, " Highest Serving Speed (km/h)"); };
var bo_r41 = function (match, outcome) { return 'To Lose First Set / To Win Match'; };
var bo_s41 = function (match, outcome) { return "".concat(match.homeTeam, " % Good First Serves"); };
var bo_t41 = function (match, outcome) { return "".concat(match.awayTeam, " % Good First Serves"); };
var bo_u41 = function (match, outcome) { return 'Match Breaks Result'; };
var bo_v41 = function (match, outcome) { return "".concat(match.homeTeam, " Breaks Total"); };
var bo_w41 = function (match, outcome) { return "".concat(match.awayTeam, " Breaks Total"); };
var bo_x41 = function (match, outcome) { return 'To Break First'; };
var bo_y41 = function (match, outcome) { return "".concat(match.homeTeam, " To Break In The 1st or 2nd Game"); };
var bo_z41 = function (match, outcome) { return 'A Set To Be Completed 6:0 or 0:6'; };
var bo_a42 = function (match, outcome) { return "".concat(numeralMaleEnding(outcome.condition), " Game Winner"); };
var bo_b42 = function (match, outcome) { return "To Be 15x15 In ".concat(outcome.condition, " Game?"); };
var bo_c42 = function (match, outcome) { return "To Be 30x30 In ".concat(outcome.condition, " Game?"); };
var bo_d42 = function (match, outcome) { return "To Be 40x40 In ".concat(outcome.condition, " Game?"); };
var bo_e42 = function (match, outcome) { return "".concat(numeralMaleEnding(outcome.condition), " Game Score"); };
var bo_f42 = function (match, outcome) { return 'Aces Total'; };
var bo_g42 = function (match, outcome) { return "Match Aces Total: ".concat(match.homeTeam); };
var bo_h42 = function (match, outcome) { return "Match Aces Total: ".concat(match.awayTeam); };
var bo_i42 = function (match, outcome) { return 'Match Total Double Faults'; };
var bo_j42 = function (match, outcome) { return "Match Total Double Faults: ".concat(match.homeTeam); };
var bo_k42 = function (match, outcome) { return "Match Total Double Faults: ".concat(match.awayTeam); };
var bo_l42 = function (match, outcome) { return 'Highest Scoring Set'; };
var bo_m42 = function (match, outcome) { return 'To Win Match By Ace'; };
var bo_n42 = function (match, outcome) { return "To Be Ace In 1st Or 2nd Games: ".concat(match.homeTeam); };
var bo_o42 = function (match, outcome) { return "To Be Ace In 1st Or 2nd Games: ".concat(match.awayTeam); };
var bo_p42 = function (match, outcome) { return "To Be Double Fault In 1st Or 2nd Games: ".concat(match.homeTeam); };
var bo_q42 = function (match, outcome) { return "To Be Double Fault In 1st Or 2nd Games: ".concat(match.awayTeam); };
var bo_r42 = function (match, outcome) { return 'First Set Aces Total'; };
var bo_s42 = function (match, outcome) { return 'To Be Disqualification Or Retirement'; };
var bo_t42 = function (match, outcome) { return "Win % 1st serve ".concat(match.homeTeam); };
var bo_u42 = function (match, outcome) { return "Win % 1st serve ".concat(match.awayTeam); };
var bo_v42 = function (match, outcome) { return 'Breaks Result - First Set'; };
var bo_w42 = function (match, outcome) { return 'Breaks Result - Second Set'; };
var bo_x42 = function (match, outcome) { return 'Breaks Result - Third Set'; };
var bo_y42 = function (match, outcome) { return 'Breaks Result - Fourth Set'; };
var bo_z42 = function (match, outcome) { return 'Breaks Result - Fifth Set'; };
var bo_a43 = function (match, outcome) { return 'Match Breaks Handicap'; };
var bo_b43 = function (match, outcome) { return 'Breaks Handicap - First Set'; };
var bo_c43 = function (match, outcome) { return 'Breaks Handicap - Second Set'; };
var bo_d43 = function (match, outcome) { return 'Breaks Handicap - Third Set'; };
var bo_e43 = function (match, outcome) { return 'Breaks Handicap - Fourth Set'; };
var bo_f43 = function (match, outcome) { return 'Breaks Handicap - Fifth Set'; };
var bo_g43 = function (match, outcome) { return "Point Winner - Point ".concat(outcome.conditionTwo, ", Game ").concat(numeralMaleEnding(outcome.condition)); };
var bo_h43 = function (match, outcome) { return "To Win ".concat(outcome.condition, " And ").concat(outcome.conditionTwo, " Games"); };
var bo_i43 = function (match, outcome) { return "".concat(numeralMaleEnding(outcome.conditionTwo), " Game Handicap"); };
var bo_j43 = function (match, outcome) { return "".concat(numeralMaleEnding(outcome.conditionTwo), " Game Total"); };
var bo_k43 = function (match, outcome) { return 'First Set Result'; };
var bo_l43 = function (match, outcome) { return 'Second Set Result'; };
var bo_m43 = function (match, outcome) { return 'Third Set Result'; };
var bo_n43 = function (match, outcome) { return 'Fourth Set Result'; };
var bo_o43 = function (match, outcome) { return 'Fifth Set Result'; };
var bo_p43 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " - Fourth Set"); };
var bo_q43 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " - Fifth Set"); };
var bo_r43 = function (match, outcome) { return 'Handicap - Sets'; };
var bo_s43 = function (match, outcome) { return 'First Set Exact Total'; };
var bo_t43 = function (match, outcome) { return 'Second Set Exact Total'; };
var bo_u43 = function (match, outcome) { return 'Third Set Exact Total'; };
var bo_v43 = function (match, outcome) { return 'Fourth Set Exact Total'; };
var bo_w43 = function (match, outcome) { return 'Fifth Set Exact Total'; };
var bo_x43 = function (match, outcome) { return "".concat(match.homeTeam, " Fourth Set Winning Margin"); };
var bo_y43 = function (match, outcome) { return "".concat(match.homeTeam, " Fifth Set Winning Margin"); };
var bo_z43 = function (match, outcome) { return "".concat(match.awayTeam, " Fourth Set Winning Margin"); };
var bo_a44 = function (match, outcome) { return "".concat(match.awayTeam, " Fifth Set Winning Margin"); };
var bo_b44 = function (match, outcome) { return "First Set Result & Total ".concat(outcome.condition); };
var bo_c44 = function (match, outcome) { return "Fourth Set Result / Total ".concat(outcome.condition); };
var bo_d44 = function (match, outcome) { return "Fifth Set Result / Total ".concat(outcome.condition); };
var bo_e44 = function (match, outcome) { return 'Fifth Set Result / Total'; };
var bo_f44 = function (match, outcome) { return 'Highest Scoring Set Total'; };
var bo_g44 = function (match, outcome) { return 'Fourth Set Winning Margin'; };
var bo_h44 = function (match, outcome) { return 'Fifth Set Winning Margin'; };
var bo_i44 = function (match, outcome) { return '10 Points Miniset Winner - Fourth Set'; };
var bo_j44 = function (match, outcome) { return '10 Points Miniset Handicap - Fourth Set'; };
var bo_k44 = function (match, outcome) { return '10 Points Miniset Total - Fourth Set'; };
var bo_l44 = function (match, outcome) { return '15 Points Miniset Winner - Fourth Set'; };
var bo_m44 = function (match, outcome) { return '15 Points Miniset Handicap - Fourth Set'; };
var bo_n44 = function (match, outcome) { return '15 Points Miniset Total - Fourth Set'; };
var bo_o44 = function (match, outcome) { return "Who Wins ".concat(numeralNeuterEnding(outcome.condition), " Point In First Set"); };
var bo_p44 = function (match, outcome) { return "Who Wins ".concat(numeralNeuterEnding(outcome.condition), " Point In Second Set"); };
var bo_q44 = function (match, outcome) { return "Who Wins ".concat(numeralNeuterEnding(outcome.condition), " Point In Third Set"); };
var bo_r44 = function (match, outcome) { return "Who Wins ".concat(numeralNeuterEnding(outcome.condition), " Point In Fourth Set"); };
var bo_s44 = function (match, outcome) { return "Who Wins ".concat(numeralNeuterEnding(outcome.condition), " Point In Fifth Set"); };
var bo_t44 = function (match, outcome) { return "Result / Total ".concat(outcome.condition); };
var bo_u44 = function (match, outcome) { return 'Golden Set Handicap'; };
var bo_v44 = function (match, outcome) { return 'Golden Set Total'; };
var bo_w44 = function (match, outcome) { return "".concat(match.homeTeam, " Golden Set Total"); };
var bo_x44 = function (match, outcome) { return "".concat(match.awayTeam, " Golden Set Total"); };
var bo_y44 = function (match, outcome) { return 'Golden Set Result'; };
var bo_z44 = function (match, outcome) { return "Race To ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['point', 'points', 'points']), " - Golden Set"); };
var bo_a45 = function (match, outcome) { return 'Golden Set Exact Total'; };
var bo_b45 = function (match, outcome) { return 'Golden Set Even/Odd'; };
var bo_c45 = function (match, outcome) { return "Golden Set Result / Total ".concat(outcome.condition); };
var bo_d45 = function (match, outcome) { return 'Golden Set Winning Margin'; };
var bo_e45 = function (match, outcome) { return 'How many sets will exceed score limit'; };
var bo_f45 = function (match, outcome) { return "".concat(outcome.condition, " Round Winner"); };
var bo_g45 = function (match, outcome) { return 'Game Handicap'; };
var bo_h45 = function (match, outcome) { return 'Game Score'; };
var bo_i45 = function (match, outcome) { return '13th Sector To Appear'; };
var bo_j45 = function (match, outcome) { return '13th Sector To Appear in The First Round'; };
var fa_b1 = function (match, outcome) { return "Han1(".concat(signed(outcome.condition), ")"); };
var fa_c1 = function (match, outcome) { return "Han2(".concat(signed(-outcome.condition), ")"); };
var fa_d1 = function (match, outcome) { return "Under ".concat(outcome.condition); };
var fa_e1 = function (match, outcome) { return "Over ".concat(outcome.condition); };
var fa_f1 = function (match, outcome) { return 'Even'; };
var fa_g1 = function (match, outcome) { return 'Odd'; };
var fa_h1 = function (match, outcome) { return "".concat(match.homeTeam); };
var fa_i1 = function (match, outcome) { return "".concat(match.awayTeam); };
var fa_j1 = function (match, outcome) { return '1-st Higher'; };
var fa_k1 = function (match, outcome) { return '2-nd Higher'; };
var fa_l1 = function (match, outcome) { return 'Yes'; };
var fa_m1 = function (match, outcome) { return 'No'; };
var fa_n1 = function (match, outcome) { return '0-2'; };
var fa_o1 = function (match, outcome) { return '0-3'; };
var fa_p1 = function (match, outcome) { return '1-2'; };
var fa_q1 = function (match, outcome) { return '1-3'; };
var fa_r1 = function (match, outcome) { return '2-0'; };
var fa_s1 = function (match, outcome) { return '2-1'; };
var fa_t1 = function (match, outcome) { return '2-3'; };
var fa_u1 = function (match, outcome) { return '3-0'; };
var fa_v1 = function (match, outcome) { return '3-1'; };
var fa_w1 = function (match, outcome) { return '3-2'; };
var fa_x1 = function (match, outcome) { return 'W1'; };
var fa_y1 = function (match, outcome) { return 'W2'; };
var fa_z1 = function (match, outcome) { return 'Х'; };
var fa_a2 = function (match, outcome) { return 'No one'; };
var fa_b2 = function (match, outcome) { return '1X'; };
var fa_c2 = function (match, outcome) { return '12'; };
var fa_d2 = function (match, outcome) { return '2X'; };
var fa_e2 = function (match, outcome) { return "W1&Tu ".concat(outcome.condition); };
var fa_f2 = function (match, outcome) { return "W1&To ".concat(outcome.condition); };
var fa_g2 = function (match, outcome) { return "W2&Tu ".concat(outcome.condition); };
var fa_h2 = function (match, outcome) { return "W2&To ".concat(outcome.condition); };
var fa_i2 = function (match, outcome) { return "\u0425&Tu ".concat(outcome.condition); };
var fa_j2 = function (match, outcome) { return "\u0425&To ".concat(outcome.condition); };
var fa_k2 = function (match, outcome) { return '0'; };
var fa_l2 = function (match, outcome) { return '1'; };
var fa_m2 = function (match, outcome) { return '2'; };
var fa_n2 = function (match, outcome) { return '3'; };
var fa_o2 = function (match, outcome) { return '4'; };
var fa_p2 = function (match, outcome) { return '≥ 5'; };
var fa_q2 = function (match, outcome) { return 'Both'; };
var fa_r2 = function (match, outcome) { return 'One'; };
var fa_s2 = function (match, outcome) { return 'No Goals'; };
var fa_t2 = function (match, outcome) { return '0-0'; };
var fa_u2 = function (match, outcome) { return '0-1'; };
var fa_v2 = function (match, outcome) { return '0-4'; };
var fa_w2 = function (match, outcome) { return '0-5'; };
var fa_x2 = function (match, outcome) { return '1-0'; };
var fa_y2 = function (match, outcome) { return '1-1'; };
var fa_z2 = function (match, outcome) { return '1-4'; };
var fa_a3 = function (match, outcome) { return '1-5'; };
var fa_b3 = function (match, outcome) { return '2-2'; };
var fa_c3 = function (match, outcome) { return '2-4'; };
var fa_d3 = function (match, outcome) { return '2-5'; };
var fa_e3 = function (match, outcome) { return '2-6'; };
var fa_f3 = function (match, outcome) { return '3-3'; };
var fa_g3 = function (match, outcome) { return '3-4'; };
var fa_h3 = function (match, outcome) { return '3-5'; };
var fa_i3 = function (match, outcome) { return '4-0'; };
var fa_j3 = function (match, outcome) { return '4-1'; };
var fa_k3 = function (match, outcome) { return '4-2'; };
var fa_l3 = function (match, outcome) { return '4-3'; };
var fa_m3 = function (match, outcome) { return '4-4'; };
var fa_n3 = function (match, outcome) { return '5-0'; };
var fa_o3 = function (match, outcome) { return '5-1'; };
var fa_p3 = function (match, outcome) { return '5-2'; };
var fa_q3 = function (match, outcome) { return '5-3'; };
var fa_r3 = function (match, outcome) { return 'Any Other'; };
var fa_s3 = function (match, outcome) { return "\u2264 ".concat(outcome.condition); };
var fa_t3 = function (match, outcome) { return "".concat(outcome.condition + 1, " - ").concat(outcome.condition + 2); };
var fa_u3 = function (match, outcome) { return "".concat(outcome.condition + 3, " - ").concat(outcome.condition + 4); };
var fa_v3 = function (match, outcome) { return "".concat(outcome.condition + 5, " - ").concat(outcome.condition + 6); };
var fa_w3 = function (match, outcome) { return "".concat(outcome.condition + 7, " - ").concat(outcome.condition + 8); };
var fa_x3 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 9); };
var fa_y3 = function (match, outcome) { return '6-9'; };
var fa_z3 = function (match, outcome) { return '10-12'; };
var fa_a4 = function (match, outcome) { return '13-16'; };
var fa_b4 = function (match, outcome) { return '17-20'; };
var fa_c4 = function (match, outcome) { return '21+'; };
var fa_d4 = function (match, outcome) { return '1st Half'; };
var fa_e4 = function (match, outcome) { return '2nd Half'; };
var fa_f4 = function (match, outcome) { return '1st Quarter'; };
var fa_g4 = function (match, outcome) { return '2nd Quarter'; };
var fa_h4 = function (match, outcome) { return '3rd Quarter'; };
var fa_i4 = function (match, outcome) { return '4th Quarter'; };
var fa_j4 = function (match, outcome) { return 'W1: 1-2'; };
var fa_k4 = function (match, outcome) { return 'W1: 3-5'; };
var fa_l4 = function (match, outcome) { return 'W1: 6-9'; };
var fa_m4 = function (match, outcome) { return 'W1: 10-12'; };
var fa_n4 = function (match, outcome) { return 'W1: 13-16'; };
var fa_o4 = function (match, outcome) { return 'W1: 17-20'; };
var fa_p4 = function (match, outcome) { return 'W1: 21+'; };
var fa_q4 = function (match, outcome) { return 'W2: 1-2'; };
var fa_r4 = function (match, outcome) { return 'W2: 3-5'; };
var fa_s4 = function (match, outcome) { return 'W2: 6-9'; };
var fa_t4 = function (match, outcome) { return 'W2: 10-12'; };
var fa_u4 = function (match, outcome) { return 'W2: 13-16'; };
var fa_v4 = function (match, outcome) { return 'W2: 17-20'; };
var fa_w4 = function (match, outcome) { return 'W2: 21+'; };
var fa_x4 = function (match, outcome) { return 'W1: 3-4'; };
var fa_y4 = function (match, outcome) { return 'W1: 5-7'; };
var fa_z4 = function (match, outcome) { return 'W1: 8+'; };
var fa_a5 = function (match, outcome) { return 'Х2'; };
var fa_b5 = function (match, outcome) { return 'W2: 3-4'; };
var fa_c5 = function (match, outcome) { return 'W2: 5-7'; };
var fa_d5 = function (match, outcome) { return 'W2: 8+'; };
var fa_e5 = function (match, outcome) { return 'Х1'; };
var fa_f5 = function (match, outcome) { return 'Free Throw'; };
var fa_g5 = function (match, outcome) { return '3-Pointer'; };
var fa_h5 = function (match, outcome) { return '2-Pointer'; };
var fa_i5 = function (match, outcome) { return "W1 \u2265 ".concat(outcome.condition); };
var fa_j5 = function (match, outcome) { return "Margin under ".concat(outcome.condition); };
var fa_k5 = function (match, outcome) { return "W2 \u2265 ".concat(outcome.condition); };
var fa_l5 = function (match, outcome) { return 'Neither'; };
var fa_m5 = function (match, outcome) { return 'W1: 1'; };
var fa_n5 = function (match, outcome) { return 'W1: 2'; };
var fa_o5 = function (match, outcome) { return 'W1: 3'; };
var fa_p5 = function (match, outcome) { return 'W1: 4'; };
var fa_q5 = function (match, outcome) { return 'W1: 5+'; };
var fa_r5 = function (match, outcome) { return 'W2: 1'; };
var fa_s5 = function (match, outcome) { return 'W2: 2'; };
var fa_t5 = function (match, outcome) { return 'W2: 3'; };
var fa_u5 = function (match, outcome) { return 'W2: 4'; };
var fa_v5 = function (match, outcome) { return 'W2: 5+'; };
var fa_w5 = function (match, outcome) { return '1Х'; };
var fa_x5 = function (match, outcome) { return '0 or 1'; };
var fa_y5 = function (match, outcome) { return '5'; };
var fa_z5 = function (match, outcome) { return '6'; };
var fa_a6 = function (match, outcome) { return '7'; };
var fa_b6 = function (match, outcome) { return '8+'; };
var fa_c6 = function (match, outcome) { return 'W1&W1'; };
var fa_d6 = function (match, outcome) { return 'W1&X'; };
var fa_e6 = function (match, outcome) { return 'W1&W2'; };
var fa_f6 = function (match, outcome) { return 'X&W1'; };
var fa_g6 = function (match, outcome) { return 'X&X'; };
var fa_h6 = function (match, outcome) { return 'X&W2'; };
var fa_i6 = function (match, outcome) { return 'W2&W1'; };
var fa_j6 = function (match, outcome) { return 'W2&X'; };
var fa_k6 = function (match, outcome) { return 'W2&W2'; };
var fa_l6 = function (match, outcome) { return "".concat(outcome.condition + 1); };
var fa_m6 = function (match, outcome) { return "".concat(outcome.condition + 2); };
var fa_n6 = function (match, outcome) { return "".concat(outcome.condition + 3); };
var fa_o6 = function (match, outcome) { return "".concat(outcome.condition + 4); };
var fa_p6 = function (match, outcome) { return "".concat(outcome.condition + 5); };
var fa_q6 = function (match, outcome) { return "".concat(outcome.condition + 6); };
var fa_r6 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 7); };
var fa_s6 = function (match, outcome) { return '4-6'; };
var fa_t6 = function (match, outcome) { return '7+'; };
var fa_u6 = function (match, outcome) { return '7 And More'; };
var fa_v6 = function (match, outcome) { return '7 and more'; };
var fa_w6 = function (match, outcome) { return 'W1&U'; };
var fa_x6 = function (match, outcome) { return 'W1&O'; };
var fa_y6 = function (match, outcome) { return 'W2&U'; };
var fa_z6 = function (match, outcome) { return 'W2&O'; };
var fa_a7 = function (match, outcome) { return 'W1: 2-3'; };
var fa_b7 = function (match, outcome) { return 'W1: 4-6'; };
var fa_c7 = function (match, outcome) { return 'W1: ≥7'; };
var fa_d7 = function (match, outcome) { return 'W2: 2-3'; };
var fa_e7 = function (match, outcome) { return 'W2: 4-6'; };
var fa_f7 = function (match, outcome) { return 'W2: ≥7'; };
var fa_g7 = function (match, outcome) { return "".concat(outcome.condition); };
var fa_h7 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 6); };
var fa_i7 = function (match, outcome) { return 'W1: To Win Inside Distance'; };
var fa_j7 = function (match, outcome) { return 'W1: Point Victory'; };
var fa_k7 = function (match, outcome) { return 'Draw'; };
var fa_l7 = function (match, outcome) { return 'W2: To Win Inside Distance'; };
var fa_m7 = function (match, outcome) { return 'W2: Point Victory'; };
var fa_n7 = function (match, outcome) { return 'W1: 1 round'; };
var fa_o7 = function (match, outcome) { return 'W1: 2 round'; };
var fa_p7 = function (match, outcome) { return 'W1: 3 round'; };
var fa_q7 = function (match, outcome) { return 'W1: 4 round'; };
var fa_r7 = function (match, outcome) { return 'W1: 5 round'; };
var fa_s7 = function (match, outcome) { return 'W1: 6 round'; };
var fa_t7 = function (match, outcome) { return 'W1: 7 round'; };
var fa_u7 = function (match, outcome) { return 'W1: 8 round'; };
var fa_v7 = function (match, outcome) { return 'W1: 9 round'; };
var fa_w7 = function (match, outcome) { return 'W1: 10 round'; };
var fa_x7 = function (match, outcome) { return 'W1: 11 round'; };
var fa_y7 = function (match, outcome) { return 'W1: 12 round'; };
var fa_z7 = function (match, outcome) { return 'W2: 1 round'; };
var fa_a8 = function (match, outcome) { return 'W2: 2 round'; };
var fa_b8 = function (match, outcome) { return 'W2: 3 round'; };
var fa_c8 = function (match, outcome) { return 'W2: 4 round'; };
var fa_d8 = function (match, outcome) { return 'W2: 5 round'; };
var fa_e8 = function (match, outcome) { return 'W2: 6 round'; };
var fa_f8 = function (match, outcome) { return 'W2: 7 round'; };
var fa_g8 = function (match, outcome) { return 'W2: 8 round'; };
var fa_h8 = function (match, outcome) { return 'W2: 9 round'; };
var fa_i8 = function (match, outcome) { return 'W2: 10 round'; };
var fa_j8 = function (match, outcome) { return 'W2: 11 round'; };
var fa_k8 = function (match, outcome) { return 'W2: 12 round'; };
var fa_l8 = function (match, outcome) { return "HAN1(".concat(signed(outcome.condition), ")"); };
var fa_m8 = function (match, outcome) { return "HAN2(".concat(signed(-outcome.condition), ")"); };
var fa_n8 = function (match, outcome) { return '1st Higher'; };
var fa_o8 = function (match, outcome) { return '2nd Higher'; };
var fa_p8 = function (match, outcome) { return 'X'; };
var fa_q8 = function (match, outcome) { return 'One Only'; };
var fa_r8 = function (match, outcome) { return 'Both Teams'; };
var fa_s8 = function (match, outcome) { return 'Only One'; };
var fa_t8 = function (match, outcome) { return 'Header'; };
var fa_u8 = function (match, outcome) { return 'Shot'; };
var fa_v8 = function (match, outcome) { return 'Own Goal'; };
var fa_w8 = function (match, outcome) { return 'Penalty'; };
var fa_x8 = function (match, outcome) { return "Next Round: ".concat(match.homeTeam); };
var fa_y8 = function (match, outcome) { return "Next Round: ".concat(match.awayTeam); };
var fa_z8 = function (match, outcome) { return 'No Yellow Cards'; };
var fa_a9 = function (match, outcome) { return 'Corner'; };
var fa_b9 = function (match, outcome) { return 'Offside'; };
var fa_c9 = function (match, outcome) { return 'Yellow Card'; };
var fa_d9 = function (match, outcome) { return 'Goal'; };
var fa_e9 = function (match, outcome) { return "Before ".concat(outcome.condition); };
var fa_f9 = function (match, outcome) { return "After ".concat(outcome.condition); };
var fa_g9 = function (match, outcome) { return 'First Half'; };
var fa_h9 = function (match, outcome) { return 'Second Half'; };
var fa_i9 = function (match, outcome) { return 'In The First Half'; };
var fa_j9 = function (match, outcome) { return 'In The Second Half'; };
var fa_k9 = function (match, outcome) { return 'Not To Score'; };
var fa_l9 = function (match, outcome) { return 'No One'; };
var fa_m9 = function (match, outcome) { return '1&1'; };
var fa_n9 = function (match, outcome) { return '1&X'; };
var fa_o9 = function (match, outcome) { return '1&2'; };
var fa_p9 = function (match, outcome) { return 'X&1'; };
var fa_q9 = function (match, outcome) { return 'X&2'; };
var fa_r9 = function (match, outcome) { return '2&1'; };
var fa_s9 = function (match, outcome) { return '2&X'; };
var fa_t9 = function (match, outcome) { return '2&2'; };
var fa_u9 = function (match, outcome) { return '0-6'; };
var fa_v9 = function (match, outcome) { return '1-6'; };
var fa_w9 = function (match, outcome) { return '6-0'; };
var fa_x9 = function (match, outcome) { return '6-1'; };
var fa_y9 = function (match, outcome) { return 'Draw by Goals'; };
var fa_z9 = function (match, outcome) { return 'Scoreless Draw'; };
var fa_a10 = function (match, outcome) { return 'No Draw'; };
var fa_b10 = function (match, outcome) { return 'No Goal'; };
var fa_c10 = function (match, outcome) { return 'Tie'; };
var fa_d10 = function (match, outcome) { return 'Yes&Yes'; };
var fa_e10 = function (match, outcome) { return 'Yes&No'; };
var fa_f10 = function (match, outcome) { return 'No&Yes'; };
var fa_g10 = function (match, outcome) { return 'No&No'; };
var fa_h10 = function (match, outcome) { return 'Over&Yes'; };
var fa_i10 = function (match, outcome) { return 'Over&No'; };
var fa_j10 = function (match, outcome) { return 'Under&Yes'; };
var fa_k10 = function (match, outcome) { return 'Under&No'; };
var fa_l10 = function (match, outcome) { return 'W1 in Full Time'; };
var fa_m10 = function (match, outcome) { return 'W2 in Full Time'; };
var fa_n10 = function (match, outcome) { return 'W1 in Extra Time'; };
var fa_o10 = function (match, outcome) { return 'W2 in Extra Time'; };
var fa_p10 = function (match, outcome) { return 'W1 by Shootouts'; };
var fa_q10 = function (match, outcome) { return 'W2 by Shootouts'; };
var fa_r10 = function (match, outcome) { return 'Half Time'; };
var fa_s10 = function (match, outcome) { return 'Any other'; };
var fa_t10 = function (match, outcome) { return 'П1'; };
var fa_u10 = function (match, outcome) { return 'П2'; };
var fa_v10 = function (match, outcome) { return '5-4'; };
var fa_w10 = function (match, outcome) { return 'W1 with any other'; };
var fa_x10 = function (match, outcome) { return '4-5'; };
var fa_y10 = function (match, outcome) { return 'W2 with any other'; };
var fa_z10 = function (match, outcome) { return '1-10'; };
var fa_a11 = function (match, outcome) { return '11-20'; };
var fa_b11 = function (match, outcome) { return '21-30'; };
var fa_c11 = function (match, outcome) { return '31-40'; };
var fa_d11 = function (match, outcome) { return '41-50'; };
var fa_e11 = function (match, outcome) { return '51-60'; };
var fa_f11 = function (match, outcome) { return '61-70'; };
var fa_g11 = function (match, outcome) { return '71-80'; };
var fa_h11 = function (match, outcome) { return '81-FT'; };
var fa_i11 = function (match, outcome) { return '5 And More'; };
var fa_j11 = function (match, outcome) { return 'No One To Score'; };
var fa_k11 = function (match, outcome) { return 'Each Team'; };
var fa_l11 = function (match, outcome) { return 'V1'; };
var fa_m11 = function (match, outcome) { return 'V2'; };
var fa_n11 = function (match, outcome) { return 'To Score'; };
var fa_o11 = function (match, outcome) { return 'First Under'; };
var fa_p11 = function (match, outcome) { return 'Equal'; };
var fa_q11 = function (match, outcome) { return 'First Over'; };
var fa_r11 = function (match, outcome) { return 'V1: 1-2'; };
var fa_s11 = function (match, outcome) { return 'V1: 3-4'; };
var fa_t11 = function (match, outcome) { return 'V1: 5-7'; };
var fa_u11 = function (match, outcome) { return 'V1: 8 and more'; };
var fa_v11 = function (match, outcome) { return 'X2'; };
var fa_w11 = function (match, outcome) { return 'X1'; };
var fa_x11 = function (match, outcome) { return 'no one'; };
var fa_y11 = function (match, outcome) { return 'One not to score'; };
var fa_z11 = function (match, outcome) { return '5+'; };
var fa_a12 = function (match, outcome) { return '1<2'; };
var fa_b12 = function (match, outcome) { return '1=2'; };
var fa_c12 = function (match, outcome) { return '1>2'; };
var fa_d12 = function (match, outcome) { return '1<3'; };
var fa_e12 = function (match, outcome) { return '1=3'; };
var fa_f12 = function (match, outcome) { return '1>3'; };
var fa_g12 = function (match, outcome) { return '2<3'; };
var fa_h12 = function (match, outcome) { return '2=3'; };
var fa_i12 = function (match, outcome) { return '2>3'; };
var fa_j12 = function (match, outcome) { return 'yes'; };
var fa_k12 = function (match, outcome) { return 'no'; };
var fa_l12 = function (match, outcome) { return 'Yellow Ball'; };
var fa_m12 = function (match, outcome) { return 'Green Ball'; };
var fa_n12 = function (match, outcome) { return 'Brown Ball'; };
var fa_o12 = function (match, outcome) { return 'Blue Ball'; };
var fa_p12 = function (match, outcome) { return 'Pink Ball'; };
var fa_q12 = function (match, outcome) { return 'Black Ball'; };
var fa_r12 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 5); };
var fa_s12 = function (match, outcome) { return '≤ 14'; };
var fa_t12 = function (match, outcome) { return ' 15 - 17'; };
var fa_u12 = function (match, outcome) { return ' 18 - 19'; };
var fa_v12 = function (match, outcome) { return '≥ 20'; };
var fa_w12 = function (match, outcome) { return 'W1-Love'; };
var fa_x12 = function (match, outcome) { return 'W1-15'; };
var fa_y12 = function (match, outcome) { return 'W1-30'; };
var fa_z12 = function (match, outcome) { return 'W1-40'; };
var fa_a13 = function (match, outcome) { return 'Love-W2'; };
var fa_b13 = function (match, outcome) { return '15-W2'; };
var fa_c13 = function (match, outcome) { return '30-W2'; };
var fa_d13 = function (match, outcome) { return '40-W2'; };
var fa_e13 = function (match, outcome) { return '3-6'; };
var fa_f13 = function (match, outcome) { return '5-7'; };
var fa_g13 = function (match, outcome) { return '6-2'; };
var fa_h13 = function (match, outcome) { return '6-3'; };
var fa_i13 = function (match, outcome) { return '6-4'; };
var fa_j13 = function (match, outcome) { return '6-7'; };
var fa_k13 = function (match, outcome) { return '7-5'; };
var fa_l13 = function (match, outcome) { return '7-6'; };
var fa_m13 = function (match, outcome) { return '7-0'; };
var fa_n13 = function (match, outcome) { return '7-1'; };
var fa_o13 = function (match, outcome) { return '7-2'; };
var fa_p13 = function (match, outcome) { return '7-3'; };
var fa_q13 = function (match, outcome) { return '7-4'; };
var fa_r13 = function (match, outcome) { return 'W1 Any Other'; };
var fa_s13 = function (match, outcome) { return '0-7'; };
var fa_t13 = function (match, outcome) { return '1-7'; };
var fa_u13 = function (match, outcome) { return '2-7'; };
var fa_v13 = function (match, outcome) { return '3-7'; };
var fa_w13 = function (match, outcome) { return '4-7'; };
var fa_x13 = function (match, outcome) { return 'W2 Any Other'; };
var fa_y13 = function (match, outcome) { return '8'; };
var fa_z13 = function (match, outcome) { return '9'; };
var fa_a14 = function (match, outcome) { return '10'; };
var fa_b14 = function (match, outcome) { return '11'; };
var fa_c14 = function (match, outcome) { return '≥ 13'; };
var fa_d14 = function (match, outcome) { return "".concat(match.homeTeam, " (Svr)"); };
var fa_e14 = function (match, outcome) { return "".concat(match.awayTeam, " (Svr)"); };
var fa_f14 = function (match, outcome) { return 'W1-0'; };
var fa_g14 = function (match, outcome) { return '0-W2'; };
var fa_h14 = function (match, outcome) { return 'Second'; };
var fa_i14 = function (match, outcome) { return 'First'; };
var fa_j14 = function (match, outcome) { return 'Да'; };
var fa_k14 = function (match, outcome) { return 'Нет'; };
var fa_l14 = function (match, outcome) { return 'Both W1'; };
var fa_m14 = function (match, outcome) { return 'Both W2'; };
var fa_n14 = function (match, outcome) { return 'Han1'; };
var fa_o14 = function (match, outcome) { return 'Han2'; };
var fa_p14 = function (match, outcome) { return 'W1: 7+'; };
var fa_q14 = function (match, outcome) { return 'W2: 7+'; };
var fa_r14 = function (match, outcome) { return '6-5'; };
var fa_s14 = function (match, outcome) { return '5-6'; };
var baseOutcomeConfig = {
    11: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    32: {
        73: bo_b1,
        318: bo_j1,
        21: bo_k1,
        22: bo_l1,
        23: bo_m1,
        195: bo_n1,
        196: bo_o1,
        197: bo_p1,
        352: bo_q1,
        748: bo_r1,
        102: bo_s1,
        403: bo_g1,
        366: bo_t1,
        367: bo_u1,
        368: bo_v1,
        138: bo_w1,
        139: bo_x1,
        140: bo_y1,
        182: bo_z1,
        183: bo_a2,
        184: bo_b2,
        122: bo_c2,
        123: bo_d2,
        124: bo_e2,
        129: bo_f2,
        130: bo_g2,
        131: bo_h2,
        566: bo_i2,
        567: bo_j2,
        568: bo_k2,
        616: bo_l2,
        617: bo_m2,
        618: bo_n2,
        257: bo_o2,
        307: bo_p2,
        443: bo_h1,
        608: bo_i1,
        362: bo_q2,
        363: bo_r2,
        364: bo_s2,
        17: bo_t2,
        18: bo_u2,
        19: bo_v2,
        176: bo_w2,
        177: bo_x2,
        178: bo_y2,
        358: bo_z2,
        359: bo_a3,
        360: bo_b3,
        13: bo_c3,
        14: bo_d3,
        15: bo_e3,
        172: bo_f3,
        173: bo_g3,
        174: bo_h3,
        256: bo_d1,
        306: bo_e1
    },
    35: {
        138: bo_i3,
        256: bo_d1,
        21: bo_j3,
        673: bo_k3,
        182: bo_l3,
        306: bo_e1,
        698: bo_g1,
        731: bo_m3,
        656: bo_n3,
        195: bo_o3,
        74: bo_b1,
        349: bo_j1,
        443: bo_h1,
        608: bo_i1,
        911: bo_p3,
        426: bo_q3,
        535: bo_r3,
        871: bo_s3,
        710: bo_t3,
        742: bo_u3
    },
    10: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        1: bo_v3,
        443: bo_h1,
        608: bo_i1
    },
    31: {
        74: bo_b1,
        349: bo_c1,
        21: bo_w3,
        22: bo_x3,
        23: bo_y3,
        24: bo_z3,
        256: bo_d1,
        306: bo_e1,
        195: bo_a4,
        196: bo_b4,
        197: bo_c4,
        198: bo_d4,
        673: bo_e4,
        674: bo_f4,
        675: bo_g4,
        676: bo_h4,
        103: bo_i4,
        403: bo_g1,
        138: bo_j4,
        139: bo_k4,
        140: bo_l4,
        141: bo_m4,
        182: bo_n4,
        183: bo_o4,
        184: bo_p4,
        185: bo_q4,
        238: bo_o3,
        682: bo_r4,
        239: bo_s4,
        58: bo_j3,
        59: bo_t4,
        681: bo_k3,
        234: bo_i3,
        235: bo_u4,
        236: bo_l3,
        237: bo_v4,
        725: bo_w4,
        726: bo_x4,
        727: bo_y4,
        728: bo_z4,
        782: bo_a5,
        778: bo_b5,
        779: bo_c5,
        780: bo_d5,
        781: bo_e5,
        783: bo_f5,
        773: bo_g5,
        474: bo_h5,
        421: bo_i5,
        530: bo_j5,
        422: bo_k5,
        531: bo_l5,
        444: bo_m5,
        888: bo_n5,
        280: bo_o5,
        317: bo_p5,
        424: bo_q5,
        533: bo_r5,
        423: bo_s5,
        532: bo_t5,
        637: bo_u5,
        788: bo_v5,
        784: bo_w5,
        785: bo_x5,
        786: bo_y5,
        787: bo_z5,
        774: bo_a6,
        775: bo_b6,
        776: bo_c6,
        777: bo_d6,
        281: bo_e6,
        137: bo_f6,
        246: bo_g6,
        248: bo_h6,
        240: bo_i6,
        232: bo_j6,
        241: bo_k6,
        233: bo_l6,
        61: bo_m6,
        62: bo_n6,
        684: bo_o6,
        685: bo_p6,
        443: bo_h1,
        608: bo_i1,
        890: bo_q6,
        242: bo_r6,
        245: bo_s6,
        243: bo_t6,
        60: bo_u6,
        683: bo_v6,
        406: bo_w6,
        405: bo_x6,
        404: bo_y6,
        700: bo_z6,
        408: bo_a7,
        407: bo_b7,
        247: bo_c7,
        244: bo_d7,
        638: bo_e7,
        639: bo_f7,
        640: bo_g7,
        641: bo_h7,
        646: bo_i7,
        642: bo_j7,
        643: bo_k7,
        644: bo_l7,
        645: bo_m7
    },
    41: {
        74: bo_b1,
        349: bo_c1,
        21: bo_j3,
        22: bo_t4,
        403: bo_g1,
        673: bo_k3,
        674: bo_r4,
        195: bo_o3,
        196: bo_s4,
        791: bo_n7,
        792: bo_o7,
        637: bo_u5,
        796: bo_v5,
        794: bo_p7,
        795: bo_q7,
        789: bo_r7,
        790: bo_s7,
        725: bo_t7,
        726: bo_u7,
        793: bo_a5,
        411: bo_v7,
        701: bo_m5,
        251: bo_w7,
        252: bo_x7,
        409: bo_k5,
        430: bo_l5,
        410: bo_s5,
        431: bo_t5,
        281: bo_e6,
        137: bo_f6,
        249: bo_g6,
        250: bo_h6,
        63: bo_m6,
        64: bo_n6,
        686: bo_o6,
        687: bo_p6,
        103: bo_i4,
        256: bo_d1,
        306: bo_e1,
        138: bo_i3,
        139: bo_u4,
        182: bo_l3,
        183: bo_v4,
        443: bo_h1,
        608: bo_i1,
        648: bo_y7,
        649: bo_z7
    },
    18: {
        74: bo_b1,
        349: bo_j1,
        656: bo_n3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_a8,
        196: bo_b8,
        197: bo_c8,
        673: bo_d8,
        674: bo_e8,
        675: bo_f8,
        610: bo_g8,
        443: bo_h1,
        608: bo_i1,
        806: bo_v5,
        893: bo_v5,
        707: bo_h8,
        708: bo_i8,
        709: bo_j8,
        889: bo_a5,
        904: bo_k8,
        253: bo_l8,
        688: bo_m8,
        65: bo_n8,
        751: bo_o8,
        21: bo_p8,
        22: bo_q8,
        23: bo_r8,
        743: bo_s8,
        744: bo_t8,
        745: bo_u8,
        615: bo_v8,
        350: bo_l8
    },
    3: {
        73: bo_b1,
        318: bo_j1,
        21: bo_w8,
        22: bo_x8,
        23: bo_y8,
        195: bo_z8,
        196: bo_a9,
        197: bo_b9,
        352: bo_c9,
        746: bo_r1,
        102: bo_s1,
        403: bo_g1,
        138: bo_d9,
        139: bo_e9,
        140: bo_f9,
        182: bo_g9,
        183: bo_h9,
        184: bo_i9,
        366: bo_j9,
        367: bo_k9,
        368: bo_l9,
        566: bo_m9,
        567: bo_n9,
        568: bo_o9,
        74: bo_p9,
        854: bo_q9,
        855: bo_r9,
        856: bo_s9,
        857: bo_q9,
        858: bo_r9,
        859: bo_s9,
        797: bo_t9,
        798: bo_u9,
        799: bo_v9,
        851: bo_w9,
        852: bo_x9,
        853: bo_y9,
        83: bo_z9,
        84: bo_a10,
        85: bo_b10,
        905: bo_c10,
        906: bo_d10,
        907: bo_e10,
        443: bo_h1,
        608: bo_i1,
        362: bo_q2,
        363: bo_r2,
        17: bo_t2,
        18: bo_u2,
        176: bo_w2,
        177: bo_x2,
        358: bo_z2,
        359: bo_a3,
        13: bo_c3,
        14: bo_d3,
        172: bo_f3,
        173: bo_g3,
        616: bo_f10,
        617: bo_g10,
        618: bo_h10,
        891: bo_i10,
        257: bo_d1,
        307: bo_e1,
        800: bo_j10,
        801: bo_k10,
        802: bo_l10
    },
    20: {
        74: bo_b1,
        349: bo_m10,
        256: bo_d1,
        306: bo_e1,
        698: bo_g1,
        195: bo_n10,
        196: bo_o10,
        197: bo_p10,
        198: bo_q10,
        199: bo_r10,
        200: bo_s10,
        201: bo_t10,
        202: bo_u10,
        138: bo_v10,
        139: bo_w10,
        140: bo_x10,
        141: bo_y10,
        142: bo_z10,
        143: bo_a11,
        144: bo_b11,
        145: bo_c11,
        182: bo_d11,
        183: bo_e11,
        184: bo_f11,
        185: bo_g11,
        186: bo_h11,
        187: bo_i11,
        188: bo_j11,
        189: bo_k11,
        21: bo_l11,
        22: bo_m11,
        23: bo_n11,
        24: bo_o11,
        25: bo_p11,
        26: bo_q11,
        27: bo_r11,
        28: bo_s11,
        673: bo_t11,
        674: bo_u11,
        675: bo_v11,
        676: bo_w11,
        677: bo_x11,
        678: bo_y11,
        679: bo_z11,
        680: bo_a12,
        860: bo_b12,
        861: bo_c12,
        862: bo_d12,
        863: bo_e12,
        864: bo_f12,
        865: bo_g12,
        866: bo_h12,
        867: bo_i12,
        443: bo_h1,
        608: bo_i1
    },
    5: {
        349: bo_j1,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1,
        945: bo_j12,
        948: bo_k12,
        949: bo_l12
    },
    40: {
        656: bo_m12,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    37: {
        443: bo_h1,
        608: bo_i1
    },
    38: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_n12,
        615: bo_o12,
        413: bo_p12,
        414: bo_q12
    },
    42: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_n12,
        615: bo_r12,
        413: bo_p12,
        414: bo_s12,
        566: bo_t12,
        567: bo_u12,
        568: bo_v12,
        569: bo_w12,
        570: bo_x12,
        698: bo_g1,
        366: bo_y12,
        367: bo_z12,
        368: bo_a13,
        369: bo_b13,
        370: bo_c13,
        940: bo_d13,
        941: bo_e13,
        942: bo_f13,
        943: bo_g13,
        944: bo_h13
    },
    26: {
        443: bo_h1,
        608: bo_i1
    },
    25: {
        443: bo_h1,
        608: bo_i1
    },
    16: {
        443: bo_h1,
        608: bo_i1
    },
    12: {
        74: bo_b1,
        349: bo_c1,
        656: bo_n3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    36: {
        610: bo_i13,
        698: bo_g1,
        656: bo_n3,
        74: bo_b1,
        349: bo_c1,
        615: bo_v8,
        256: bo_d1,
        306: bo_e1,
        673: bo_d8,
        21: bo_p8,
        195: bo_a8,
        443: bo_h1,
        608: bo_i1
    },
    7: {
        425: bo_k5,
        534: bo_l5,
        540: bo_j13,
        343: bo_k13,
        345: bo_w7,
        260: bo_l13,
        261: bo_m13,
        83: bo_n13,
        84: bo_o13,
        803: bo_p13,
        868: bo_q13,
        869: bo_r13,
        870: bo_s13,
        805: bo_t13,
        892: bo_u13,
        346: bo_v13,
        419: bo_w13,
        528: bo_x13,
        420: bo_y13,
        529: bo_z13,
        707: bo_a14,
        708: bo_b14,
        706: bo_c14,
        804: bo_d14,
        474: bo_e14,
        614: bo_f14,
        609: bo_g14,
        416: bo_h14,
        732: bo_i14,
        525: bo_j14,
        850: bo_k14,
        473: bo_l14,
        442: bo_m14,
        729: bo_n14,
        538: bo_o14,
        542: bo_p14,
        730: bo_q14,
        471: bo_r14,
        635: bo_s14,
        714: bo_t14,
        624: bo_u14,
        625: bo_v14,
        715: bo_w14,
        650: bo_x14,
        651: bo_y14,
        652: bo_z14,
        653: bo_a15,
        654: bo_b15,
        655: bo_c15,
        634: bo_d15,
        626: bo_e15,
        733: bo_f15,
        734: bo_g15,
        258: bo_h15,
        259: bo_i15,
        66: bo_j15,
        67: bo_k15,
        81: bo_l15,
        68: bo_m15,
        689: bo_n15,
        690: bo_o15,
        699: bo_p15,
        691: bo_q15,
        723: bo_r15,
        633: bo_s15,
        74: bo_b1,
        349: bo_t15,
        656: bo_n3,
        698: bo_g1,
        322: bo_u15,
        904: bo_v15,
        1: bo_v3,
        136: bo_w15,
        747: bo_u3,
        871: bo_s3,
        255: bo_x15,
        705: bo_y15,
        323: bo_z15,
        324: bo_a16,
        702: bo_b16,
        278: bo_c16,
        256: bo_d1,
        306: bo_e1,
        195: bo_o3,
        196: bo_s4,
        21: bo_j3,
        22: bo_t4,
        282: bo_d16,
        911: bo_i10,
        353: bo_e16,
        673: bo_k3,
        674: bo_r4,
        2: bo_f16,
        5: bo_g16,
        7: bo_h16,
        939: bo_i16,
        9: bo_j16,
        12: bo_k16,
        417: bo_l16,
        526: bo_m16,
        325: bo_n16,
        103: bo_o16,
        160: bo_p16,
        163: bo_q16,
        165: bo_r16,
        166: bo_s16,
        168: bo_t16,
        171: bo_u16,
        148: bo_v16,
        149: bo_w16,
        150: bo_x16,
        151: bo_y16,
        152: bo_z16,
        153: bo_a17,
        154: bo_b17,
        155: bo_c17,
        156: bo_d17,
        157: bo_e17,
        158: bo_f17,
        159: bo_g17,
        731: bo_v8,
        765: bo_h17,
        766: bo_i17,
        415: bo_j17,
        524: bo_k17,
        418: bo_l17,
        527: bo_m17,
        743: bo_n17,
        744: bo_o17,
        710: bo_t3,
        321: bo_p17,
        326: bo_q17,
        327: bo_r17,
        724: bo_s17,
        661: bo_t17,
        664: bo_u17,
        666: bo_v17,
        667: bo_w17,
        669: bo_x17,
        672: bo_y17,
        426: bo_q3,
        535: bo_r3,
        537: bo_z17,
        541: bo_a18,
        539: bo_b18,
        138: bo_i3,
        139: bo_u4,
        182: bo_l3,
        183: bo_v4,
        437: bo_c18,
        436: bo_d18,
        694: bo_e18,
        71: bo_f18,
        271: bo_g18,
        268: bo_h18,
        265: bo_i18,
        267: bo_j18,
        270: bo_k18,
        272: bo_l18,
        269: bo_m18,
        266: bo_n18,
        264: bo_o18,
        281: bo_e6,
        137: bo_f6,
        660: bo_n3,
        880: bo_p18,
        879: bo_q18,
        429: bo_r18,
        433: bo_s18,
        443: bo_h1,
        608: bo_i1,
        881: bo_t18,
        273: bo_u18,
        274: bo_v18,
        435: bo_w18,
        704: bo_x18,
        432: bo_y18,
        428: bo_z18,
        434: bo_a19,
        439: bo_b19,
        440: bo_c19,
        441: bo_d19,
        438: bo_e19,
        623: bo_f19,
        180: bo_g19,
        146: bo_h19,
        659: bo_i19,
        749: bo_j19,
        69: bo_k19,
        262: bo_l19,
        692: bo_m19,
        703: bo_n19,
        70: bo_o19,
        263: bo_p19,
        693: bo_q19,
        72: bo_r19,
        277: bo_s19,
        695: bo_t19,
        750: bo_u19,
        181: bo_v19,
        147: bo_w19,
        276: bo_x19,
        275: bo_y19,
        735: bo_z19,
        736: bo_a20,
        737: bo_b20,
        738: bo_c20,
        739: bo_d20,
        740: bo_e20,
        356: bo_f20,
        357: bo_g20,
        354: bo_h20,
        355: bo_i20,
        937: bo_b16,
        657: bo_j20,
        658: bo_k20,
        412: bo_l20
    },
    14: {
        443: bo_h1,
        608: bo_i1
    },
    34: {
        425: bo_k5,
        534: bo_l5,
        540: bo_m20,
        343: bo_k13,
        345: bo_w7,
        260: bo_l13,
        261: bo_m13,
        83: bo_n20,
        84: bo_o20,
        803: bo_p20,
        868: bo_q20,
        869: bo_r20,
        870: bo_s20,
        346: bo_v13,
        419: bo_w13,
        528: bo_x13,
        420: bo_y13,
        529: bo_z13,
        707: bo_a14,
        708: bo_b14,
        706: bo_t20,
        538: bo_u20,
        74: bo_b1,
        349: bo_v20,
        656: bo_m12,
        698: bo_g1,
        322: bo_u15,
        904: bo_w20,
        1: bo_v3,
        136: bo_w15,
        747: bo_x20,
        871: bo_y20,
        255: bo_x15,
        705: bo_z20,
        323: bo_a21,
        324: bo_b21,
        702: bo_b16,
        278: bo_c21,
        256: bo_d1,
        306: bo_e1,
        195: bo_o3,
        196: bo_s4,
        21: bo_j3,
        22: bo_t4,
        282: bo_d16,
        911: bo_p3,
        353: bo_d21,
        673: bo_k3,
        674: bo_r4,
        2: bo_e21,
        5: bo_f21,
        7: bo_h16,
        939: bo_g21,
        9: bo_h21,
        12: bo_k16,
        417: bo_i21,
        526: bo_j21,
        325: bo_k21,
        103: bo_l21,
        160: bo_m21,
        163: bo_n21,
        165: bo_r16,
        166: bo_o21,
        168: bo_p21,
        171: bo_u16,
        148: bo_q21,
        149: bo_r21,
        150: bo_x16,
        151: bo_s21,
        152: bo_t21,
        153: bo_a17,
        154: bo_u21,
        155: bo_v21,
        156: bo_d17,
        157: bo_w21,
        158: bo_x21,
        159: bo_g17,
        731: bo_v8,
        765: bo_h17,
        766: bo_i17,
        415: bo_j17,
        524: bo_k17,
        418: bo_l17,
        527: bo_y21,
        743: bo_n17,
        744: bo_o17,
        710: bo_t3,
        321: bo_z21,
        326: bo_q17,
        327: bo_r17,
        724: bo_s17,
        661: bo_a22,
        664: bo_b22,
        666: bo_c22,
        667: bo_d22,
        669: bo_e22,
        672: bo_f22,
        426: bo_q3,
        535: bo_r3,
        537: bo_z17,
        541: bo_a18,
        539: bo_g22,
        138: bo_i3,
        139: bo_u4,
        182: bo_l3,
        183: bo_v4,
        443: bo_h1,
        608: bo_i1
    },
    19: {
        74: bo_b1,
        349: bo_j1,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_a8,
        196: bo_b8,
        103: bo_s1,
        615: bo_h22,
        886: bo_i22,
        887: bo_j22,
        911: bo_k22,
        884: bo_l22,
        885: bo_m22,
        882: bo_n22,
        883: bo_o22,
        723: bo_p22,
        673: bo_d8,
        674: bo_e8,
        21: bo_j3,
        22: bo_t4,
        138: bo_i3,
        182: bo_l3,
        443: bo_h1,
        608: bo_i1
    },
    30: {
        74: bo_b1,
        349: bo_c1,
        656: bo_n3,
        698: bo_g1,
        21: bo_p8,
        22: bo_q8,
        23: bo_r8,
        279: bo_q22,
        610: bo_r22,
        256: bo_d1,
        306: bo_e1,
        195: bo_a8,
        196: bo_b8,
        197: bo_c8,
        673: bo_d8,
        674: bo_e8,
        675: bo_f8,
        350: bo_l8,
        103: bo_i4,
        415: bo_j17,
        524: bo_k17,
        743: bo_s8,
        744: bo_t8,
        745: bo_u8,
        710: bo_t3,
        403: bo_g1,
        426: bo_s22,
        535: bo_t22,
        706: bo_u22,
        343: bo_k13,
        346: bo_v13,
        83: bo_v22,
        84: bo_w22,
        85: bo_x22,
        344: bo_y22,
        347: bo_z22,
        765: bo_i22,
        766: bo_j22,
        767: bo_a23,
        138: bo_b23,
        139: bo_c23,
        140: bo_d23,
        182: bo_e23,
        183: bo_f23,
        184: bo_g23,
        751: bo_o8,
        911: bo_p3,
        889: bo_a5,
        637: bo_h23,
        615: bo_v8,
        412: bo_i23,
        634: bo_j23,
        626: bo_k23,
        611: bo_l23,
        443: bo_h1,
        608: bo_i1,
        904: bo_k8,
        449: bo_m23,
        446: bo_n23,
        451: bo_o23,
        711: bo_p23,
        712: bo_p23,
        713: bo_p23,
        450: bo_q23,
        447: bo_r23,
        448: bo_s23,
        662: bo_t23,
        663: bo_u23,
        665: bo_v23,
        668: bo_w23,
        670: bo_x23,
        671: bo_y23,
        3: bo_z23,
        4: bo_a24,
        6: bo_b24,
        8: bo_c24,
        10: bo_d24,
        11: bo_e24,
        161: bo_f24,
        162: bo_g24,
        164: bo_h24,
        167: bo_i24,
        169: bo_j24,
        170: bo_k24,
        707: bo_h8,
        708: bo_i8,
        709: bo_j8,
        946: bo_h14,
        947: bo_j14
    },
    23: {
        443: bo_h1,
        608: bo_i1
    },
    13: {
        468: bo_l24,
        470: bo_m24,
        467: bo_n24,
        469: bo_o24,
        464: bo_p24,
        466: bo_q24,
        465: bo_r24,
        463: bo_s24,
        289: bo_t24,
        288: bo_u24,
        292: bo_v24,
        461: bo_w24,
        283: bo_x24,
        295: bo_y24,
        293: bo_z24,
        284: bo_a25,
        285: bo_b25,
        316: bo_c25,
        286: bo_d25,
        287: bo_e25,
        290: bo_f25,
        291: bo_g25,
        462: bo_h25,
        294: bo_i25
    },
    39: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        698: bo_g1,
        349: bo_j1,
        950: bo_l12,
        955: bo_j12,
        951: bo_j25,
        952: bo_k25,
        953: bo_l25,
        954: bo_m25
    },
    33: {
        348: bo_n25,
        443: bo_h1,
        608: bo_i1
    },
    24: {
        443: bo_h1,
        608: bo_i1
    },
    9: {
        74: bo_b1,
        349: bo_j1,
        656: bo_n3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_o3,
        196: bo_s4,
        673: bo_k3,
        674: bo_r4,
        443: bo_h1,
        608: bo_i1
    },
    21: {
        443: bo_h1,
        608: bo_i1
    },
    29: {
        394: bo_o25,
        395: bo_p25,
        396: bo_q25,
        397: bo_r25,
        398: bo_s25,
        399: bo_t25,
        400: bo_u25,
        401: bo_v25,
        402: bo_w25,
        100: bo_x25,
        101: bo_y25,
        104: bo_z25,
        105: bo_a26,
        106: bo_b26,
        107: bo_c26,
        108: bo_d26,
        109: bo_e26,
        110: bo_f26,
        111: bo_g26,
        112: bo_h26,
        113: bo_i26,
        114: bo_j26,
        115: bo_k26,
        116: bo_l26,
        117: bo_m26,
        118: bo_n26,
        119: bo_o26,
        120: bo_p26,
        121: bo_q26,
        808: bo_r26,
        809: bo_s26,
        810: bo_t26,
        811: bo_u26,
        812: bo_v26,
        813: bo_w26,
        814: bo_x26,
        815: bo_y26,
        816: bo_z26,
        817: bo_a27,
        818: bo_b27,
        819: bo_c27,
        820: bo_d27,
        821: bo_e27,
        822: bo_f27,
        823: bo_g27,
        824: bo_h27,
        825: bo_i27,
        826: bo_j27,
        827: bo_k27,
        828: bo_l27,
        829: bo_m27,
        830: bo_n27,
        831: bo_o27,
        832: bo_p27,
        833: bo_q27,
        834: bo_r27,
        835: bo_s27,
        836: bo_t27,
        837: bo_u27,
        838: bo_v27,
        839: bo_w27,
        840: bo_x27,
        841: bo_y27,
        842: bo_z27,
        843: bo_a28,
        844: bo_b28,
        366: bo_c28,
        367: bo_d28,
        368: bo_e28,
        369: bo_f28,
        370: bo_g28,
        371: bo_h28,
        372: bo_i28,
        373: bo_j28,
        374: bo_k28,
        375: bo_l28,
        376: bo_m28,
        377: bo_n28,
        378: bo_o28,
        379: bo_p28,
        380: bo_q28,
        381: bo_r28,
        382: bo_s28,
        383: bo_t28,
        384: bo_u28,
        385: bo_v28,
        386: bo_w28,
        387: bo_x28,
        388: bo_y28,
        389: bo_z28,
        390: bo_a29,
        391: bo_b29,
        392: bo_c29,
        393: bo_d29,
        481: bo_e29,
        482: bo_f29,
        483: bo_g29,
        484: bo_h29,
        485: bo_i29,
        486: bo_j29,
        487: bo_k29,
        488: bo_l29,
        489: bo_m29,
        490: bo_n29,
        491: bo_o29,
        492: bo_p29,
        493: bo_q29,
        494: bo_r29,
        495: bo_s29,
        496: bo_t29,
        497: bo_u29,
        498: bo_v29,
        499: bo_w29,
        500: bo_x29,
        501: bo_y29,
        502: bo_z29,
        503: bo_a30,
        504: bo_b30,
        505: bo_c30,
        506: bo_d30,
        507: bo_e30,
        508: bo_f30,
        509: bo_g30,
        510: bo_h30,
        511: bo_i30,
        566: bo_j30,
        567: bo_k30,
        568: bo_l30,
        569: bo_m30,
        570: bo_n30,
        571: bo_o30,
        572: bo_p30,
        573: bo_q30,
        574: bo_r30,
        575: bo_s30,
        576: bo_t30,
        577: bo_u30,
        578: bo_v30,
        579: bo_w30,
        580: bo_x30,
        581: bo_y30,
        582: bo_z30,
        583: bo_a31,
        584: bo_b31,
        585: bo_c31,
        586: bo_d31,
        587: bo_e31,
        588: bo_f31,
        589: bo_g31,
        590: bo_h31,
        591: bo_i31,
        592: bo_j31,
        593: bo_k31,
        594: bo_l31,
        595: bo_m31,
        596: bo_n31,
        597: bo_o31,
        598: bo_p31,
        599: bo_q31,
        600: bo_r31,
        601: bo_s31,
        602: bo_t31,
        83: bo_u31,
        84: bo_v31,
        85: bo_w31,
        86: bo_x31,
        87: bo_y31,
        88: bo_z31,
        89: bo_a32,
        90: bo_b32,
        91: bo_c32,
        92: bo_d32,
        93: bo_e32,
        94: bo_f32,
        95: bo_g32,
        96: bo_h32,
        97: bo_i32,
        98: bo_j32,
        99: bo_k32,
        74: bo_b1,
        349: bo_j1,
        254: bo_l32,
        403: bo_g1,
        21: bo_m32,
        22: bo_n32,
        23: bo_o32,
        24: bo_p32,
        25: bo_q32,
        26: bo_r32,
        27: bo_s32,
        28: bo_t32,
        29: bo_u32,
        30: bo_v32,
        31: bo_w32,
        32: bo_x32,
        33: bo_y32,
        34: bo_z32,
        35: bo_a33,
        36: bo_b33,
        37: bo_c33,
        38: bo_d33,
        39: bo_e33,
        40: bo_f33,
        41: bo_g33,
        42: bo_h33,
        43: bo_i33,
        44: bo_j33,
        45: bo_k33,
        46: bo_l33,
        47: bo_m33,
        48: bo_n33,
        49: bo_o33,
        50: bo_p33,
        51: bo_q33,
        52: bo_r33,
        53: bo_s33,
        54: bo_t33,
        55: bo_u33,
        56: bo_v33,
        57: bo_w33,
        195: bo_x33,
        196: bo_y33,
        197: bo_z33,
        198: bo_a34,
        199: bo_b34,
        200: bo_c34,
        201: bo_d34,
        202: bo_e34,
        203: bo_f34,
        204: bo_g34,
        205: bo_h34,
        206: bo_i34,
        207: bo_j34,
        208: bo_k34,
        209: bo_l34,
        210: bo_m34,
        211: bo_n34,
        212: bo_o34,
        213: bo_p34,
        214: bo_q34,
        215: bo_r34,
        216: bo_s34,
        217: bo_t34,
        218: bo_u34,
        219: bo_v34,
        220: bo_w34,
        221: bo_x34,
        222: bo_y34,
        223: bo_z34,
        224: bo_a35,
        225: bo_b35,
        226: bo_c35,
        227: bo_d35,
        228: bo_e35,
        229: bo_f35,
        230: bo_g35,
        231: bo_h35,
        475: bo_i35,
        476: bo_j35,
        477: bo_k35,
        478: bo_l35,
        479: bo_m35,
        480: bo_n35,
        443: bo_h1,
        608: bo_i1
    },
    15: {
        443: bo_h1,
        608: bo_i1
    },
    2: {
        73: bo_b1,
        318: bo_j1,
        21: bo_k1,
        22: bo_l1,
        23: bo_m1,
        24: bo_o35,
        25: bo_p35,
        26: bo_q35,
        27: bo_r35,
        195: bo_n1,
        196: bo_o1,
        197: bo_p1,
        198: bo_s35,
        199: bo_t35,
        200: bo_u35,
        201: bo_v35,
        352: bo_w35,
        102: bo_s1,
        403: bo_g1,
        138: bo_w1,
        139: bo_x1,
        140: bo_y1,
        141: bo_x35,
        142: bo_y35,
        143: bo_z35,
        144: bo_a36,
        182: bo_z1,
        183: bo_a2,
        184: bo_b2,
        185: bo_b36,
        186: bo_c36,
        187: bo_d36,
        188: bo_e36,
        566: bo_i2,
        567: bo_j2,
        568: bo_k2,
        569: bo_f36,
        570: bo_g36,
        571: bo_h36,
        572: bo_i36,
        366: bo_t1,
        367: bo_u1,
        368: bo_v1,
        369: bo_j36,
        370: bo_k36,
        371: bo_l36,
        372: bo_m36,
        122: bo_n36,
        123: bo_o36,
        124: bo_p36,
        125: bo_q36,
        126: bo_r36,
        127: bo_s36,
        128: bo_t36,
        129: bo_u36,
        130: bo_v36,
        131: bo_w36,
        132: bo_x36,
        133: bo_y36,
        134: bo_z36,
        135: bo_a37,
        872: bo_b37,
        873: bo_c37,
        874: bo_d37,
        875: bo_e37,
        876: bo_f37,
        877: bo_g37,
        878: bo_h37,
        616: bo_i37,
        617: bo_j37,
        618: bo_k37,
        619: bo_l37,
        620: bo_m37,
        621: bo_n37,
        622: bo_o37,
        894: bo_b37,
        895: bo_c37,
        896: bo_d37,
        897: bo_e37,
        898: bo_f37,
        899: bo_g37,
        900: bo_h37,
        443: bo_h1,
        608: bo_i1,
        83: bo_z9,
        84: bo_a10,
        85: bo_b10,
        86: bo_p37,
        87: bo_q37,
        88: bo_r37,
        89: bo_s37,
        257: bo_d1,
        307: bo_e1,
        752: bo_t37,
        753: bo_t37
    },
    6: {
        553: bo_u37,
        339: bo_v37,
        547: bo_w37,
        138: bo_d9,
        139: bo_e9,
        140: bo_f9,
        141: bo_x37,
        142: bo_y37,
        182: bo_g9,
        183: bo_h9,
        184: bo_i9,
        185: bo_z37,
        186: bo_a38,
        83: bo_z9,
        84: bo_a10,
        85: bo_b10,
        86: bo_p37,
        87: bo_q37,
        807: bo_b38,
        636: bo_c38,
        334: bo_d38,
        335: bo_e38,
        336: bo_f38,
        337: bo_g38,
        906: bo_h38,
        907: bo_i38,
        908: bo_j38,
        909: bo_k38,
        300: bo_l38,
        301: bo_m38,
        302: bo_n38,
        303: bo_o38,
        304: bo_p38,
        310: bo_q38,
        311: bo_r38,
        312: bo_s38,
        313: bo_t38,
        314: bo_u38,
        554: bo_v38,
        555: bo_w38,
        556: bo_x38,
        557: bo_y38,
        558: bo_z38,
        517: bo_a39,
        518: bo_a39,
        519: bo_b39,
        520: bo_c39,
        521: bo_d39,
        561: bo_e39,
        562: bo_f39,
        563: bo_g39,
        564: bo_h39,
        565: bo_i39,
        73: bo_j39,
        318: bo_j1,
        21: bo_w8,
        22: bo_x8,
        23: bo_y8,
        24: bo_k39,
        25: bo_l39,
        195: bo_z8,
        196: bo_a9,
        197: bo_b9,
        198: bo_m39,
        199: bo_n39,
        352: bo_o39,
        748: bo_r1,
        102: bo_s1,
        403: bo_g1,
        903: bo_p39,
        445: bo_q39,
        754: bo_r39,
        755: bo_s39,
        756: bo_t39,
        757: bo_u39,
        758: bo_v39,
        452: bo_w39,
        453: bo_x39,
        454: bo_y39,
        566: bo_z39,
        567: bo_a40,
        568: bo_b40,
        569: bo_c40,
        570: bo_d40,
        366: bo_j9,
        367: bo_k9,
        368: bo_l9,
        369: bo_e40,
        370: bo_f40,
        522: bo_g40,
        627: bo_h40,
        628: bo_i40,
        629: bo_j40,
        630: bo_k40,
        631: bo_l40,
        632: bo_m40,
        190: bo_n40,
        191: bo_o40,
        192: bo_p40,
        193: bo_q40,
        194: bo_r40,
        759: bo_s40,
        760: bo_t40,
        761: bo_u40,
        762: bo_v40,
        763: bo_w40,
        768: bo_x40,
        769: bo_y40,
        770: bo_z40,
        771: bo_a41,
        772: bo_b41,
        603: bo_c41,
        604: bo_d41,
        605: bo_e41,
        606: bo_f41,
        607: bo_g41,
        257: bo_d1,
        307: bo_e1,
        696: bo_g1,
        333: bo_h41,
        341: bo_i41,
        427: bo_j41,
        536: bo_k41,
        905: bo_l41,
        320: bo_m41,
        514: bo_n41,
        516: bo_o41,
        305: bo_p41,
        315: bo_q41,
        523: bo_r41,
        299: bo_s41,
        309: bo_t41,
        697: bo_u41,
        298: bo_v41,
        308: bo_w41,
        515: bo_x41,
        549: bo_y41,
        548: bo_z41,
        443: bo_h1,
        608: bo_i1,
        550: bo_a42,
        551: bo_a42,
        455: bo_b42,
        456: bo_b42,
        457: bo_c42,
        458: bo_c42,
        459: bo_d42,
        460: bo_d42,
        512: bo_g40,
        513: bo_g40,
        901: bo_e42,
        902: bo_e42,
        340: bo_f42,
        328: bo_g42,
        329: bo_h42,
        342: bo_i42,
        330: bo_j42,
        331: bo_k42,
        722: bo_l42,
        560: bo_m42,
        543: bo_n42,
        544: bo_o42,
        545: bo_p42,
        546: bo_q42,
        332: bo_r42,
        559: bo_s42,
        296: bo_t42,
        297: bo_u42,
        717: bo_v42,
        718: bo_w42,
        719: bo_x42,
        720: bo_y42,
        721: bo_z42,
        552: bo_a43,
        76: bo_b43,
        77: bo_c43,
        78: bo_d43,
        79: bo_e43,
        80: bo_f43,
        647: bo_g43,
        741: bo_h43,
        82: bo_i43,
        338: bo_j43
    },
    17: {
        348: bo_n25,
        443: bo_h1,
        608: bo_i1
    },
    4: {
        73: bo_b1,
        318: bo_j1,
        21: bo_w8,
        22: bo_x8,
        23: bo_y8,
        24: bo_k39,
        25: bo_l39,
        195: bo_z8,
        196: bo_a9,
        197: bo_b9,
        198: bo_m39,
        199: bo_n39,
        352: bo_c9,
        764: bo_t37,
        102: bo_s1,
        403: bo_g1,
        138: bo_d9,
        139: bo_e9,
        140: bo_f9,
        141: bo_x37,
        142: bo_y37,
        182: bo_g9,
        183: bo_h9,
        184: bo_i9,
        185: bo_z37,
        186: bo_a38,
        366: bo_k43,
        367: bo_l43,
        368: bo_m43,
        369: bo_n43,
        370: bo_o43,
        566: bo_m9,
        567: bo_n9,
        568: bo_o9,
        569: bo_p43,
        570: bo_q43,
        74: bo_r43,
        923: bo_s43,
        924: bo_t43,
        925: bo_u43,
        926: bo_v43,
        927: bo_w43,
        929: bo_s43,
        930: bo_t43,
        931: bo_u43,
        932: bo_v43,
        933: bo_w43,
        845: bo_t9,
        846: bo_u9,
        847: bo_v9,
        848: bo_x43,
        849: bo_y43,
        918: bo_w9,
        919: bo_x9,
        920: bo_y9,
        921: bo_z43,
        922: bo_a44,
        83: bo_z9,
        84: bo_a10,
        85: bo_b10,
        86: bo_p37,
        87: bo_q37,
        905: bo_b44,
        906: bo_d10,
        907: bo_e10,
        908: bo_c44,
        909: bo_d44,
        807: bo_e44,
        319: bo_f44,
        320: bo_m41,
        912: bo_j10,
        913: bo_k10,
        914: bo_l10,
        915: bo_g44,
        916: bo_h44,
        443: bo_h1,
        608: bo_i1,
        257: bo_d1,
        307: bo_e1,
        362: bo_q2,
        363: bo_r2,
        364: bo_s2,
        365: bo_i44,
        17: bo_t2,
        18: bo_u2,
        19: bo_v2,
        20: bo_j44,
        176: bo_w2,
        177: bo_x2,
        178: bo_y2,
        179: bo_k44,
        358: bo_z2,
        359: bo_a3,
        360: bo_b3,
        361: bo_l44,
        13: bo_c3,
        14: bo_d3,
        15: bo_e3,
        16: bo_m44,
        172: bo_f3,
        173: bo_g3,
        174: bo_h3,
        175: bo_n44,
        281: bo_e6,
        137: bo_f6,
        616: bo_o44,
        617: bo_p44,
        618: bo_q44,
        619: bo_r44,
        620: bo_s44,
        891: bo_t44,
        26: bo_u44,
        200: bo_v44,
        143: bo_w44,
        187: bo_x44,
        371: bo_y44,
        571: bo_z44,
        928: bo_a45,
        934: bo_a45,
        88: bo_b45,
        910: bo_c45,
        917: bo_d45,
        936: bo_e45
    },
    8: {
        74: bo_b1,
        349: bo_j1,
        656: bo_n3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_a4,
        196: bo_b4,
        197: bo_c4,
        198: bo_d4,
        673: bo_e4,
        674: bo_f4,
        675: bo_g4,
        676: bo_h4,
        103: bo_s1,
        443: bo_h1,
        608: bo_i1
    },
    27: {
        443: bo_h1,
        608: bo_i1
    },
    28: {
        403: bo_g1,
        615: bo_f45,
        74: bo_g45,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        935: bo_h45,
        612: bo_i45,
        613: bo_j45,
        443: bo_h1,
        608: bo_i1
    }
};
var outcomeConfig = {
    7: {
        426: function (match, outcome) { return "".concat(match.homeTeam, " to win by ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['goal', 'goals'])); },
        535: function (match, outcome) { return "".concat(match.awayTeam, " to win by ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['goal', 'goals'])); }
    },
    6: {
        455: function (match, outcome) { return "To Be 15x15 In ".concat(outcome.condition, " game?"); },
        456: function (match, outcome) { return "To Be 15x15 In ".concat(outcome.condition, " game?"); },
        457: function (match, outcome) { return "To Be 30x30 In ".concat(outcome.condition, " game?"); },
        458: function (match, outcome) { return "To Be 30x30 In ".concat(outcome.condition, " game?"); },
        459: function (match, outcome) { return "To Be 40x40 In ".concat(outcome.condition, " game?"); },
        460: function (match, outcome) { return "To Be 40x40 In ".concat(outcome.condition, " game?"); }
    }
};
var baseFactorNameConfig = {
    11: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    32: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_n1,
            2: fa_o1,
            3: fa_p1,
            4: fa_q1,
            5: fa_r1,
            6: fa_s1,
            7: fa_t1,
            8: fa_u1,
            9: fa_v1,
            10: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        122: {
            1: fa_l1,
            2: fa_m1
        },
        123: {
            1: fa_l1,
            2: fa_m1
        },
        124: {
            1: fa_l1,
            2: fa_m1
        },
        129: {
            1: fa_l1,
            2: fa_m1
        },
        130: {
            1: fa_l1,
            2: fa_m1
        },
        131: {
            1: fa_l1,
            2: fa_m1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        362: {
            1: fa_x1,
            2: fa_y1
        },
        363: {
            1: fa_x1,
            2: fa_y1
        },
        364: {
            1: fa_x1,
            2: fa_y1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_x1,
            2: fa_y1
        },
        359: {
            1: fa_x1,
            2: fa_y1
        },
        360: {
            1: fa_x1,
            2: fa_y1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        }
    },
    35: {
        138: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        731: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        742: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        }
    },
    10: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    31: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        676: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        238: {
            1: fa_d1,
            2: fa_e1
        },
        682: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        239: {
            1: fa_d1,
            2: fa_e1
        },
        58: {
            1: fa_b1,
            2: fa_c1
        },
        59: {
            1: fa_b1,
            2: fa_c1
        },
        681: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        234: {
            1: fa_d1,
            2: fa_e1
        },
        235: {
            1: fa_d1,
            2: fa_e1
        },
        236: {
            1: fa_d1,
            2: fa_e1
        },
        237: {
            1: fa_d1,
            2: fa_e1
        },
        725: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        726: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        727: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        728: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        782: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        778: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        779: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        780: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        781: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        783: {
            1: fa_p1,
            2: fa_h3,
            3: fa_y3,
            4: fa_z3,
            5: fa_a4,
            6: fa_b4,
            7: fa_c4,
            8: fa_y1
        },
        773: {
            1: fa_p1,
            2: fa_h3,
            3: fa_y3,
            4: fa_z3,
            5: fa_a4,
            6: fa_b4,
            7: fa_c4,
            8: fa_x1
        },
        474: {
            1: fa_h1,
            2: fa_i1
        },
        421: {
            1: fa_l1,
            2: fa_m1
        },
        530: {
            1: fa_l1,
            2: fa_m1
        },
        422: {
            1: fa_l1,
            2: fa_m1
        },
        531: {
            1: fa_l1,
            2: fa_m1
        },
        444: {
            1: fa_d4,
            2: fa_e4
        },
        888: {
            1: fa_f4,
            2: fa_g4,
            3: fa_h4,
            4: fa_i4
        },
        280: {
            1: fa_d1,
            2: fa_e1
        },
        317: {
            1: fa_d1,
            2: fa_e1
        },
        424: {
            1: fa_l1,
            2: fa_m1
        },
        533: {
            1: fa_l1,
            2: fa_m1
        },
        423: {
            1: fa_l1,
            2: fa_m1
        },
        532: {
            1: fa_l1,
            2: fa_m1
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        788: {
            1: fa_j4,
            2: fa_k4,
            3: fa_l4,
            4: fa_m4,
            5: fa_n4,
            6: fa_o4,
            7: fa_p4,
            8: fa_q4,
            9: fa_r4,
            10: fa_s4,
            11: fa_t4,
            12: fa_u4,
            13: fa_v4,
            14: fa_w4
        },
        784: {
            1: fa_j4,
            2: fa_x4,
            3: fa_y4,
            4: fa_z4,
            5: fa_a5
        },
        785: {
            1: fa_j4,
            2: fa_x4,
            3: fa_y4,
            4: fa_z4,
            5: fa_a5
        },
        786: {
            1: fa_j4,
            2: fa_x4,
            3: fa_y4,
            4: fa_z4,
            5: fa_a5
        },
        787: {
            1: fa_j4,
            2: fa_x4,
            3: fa_y4,
            4: fa_z4,
            5: fa_a5
        },
        774: {
            1: fa_q4,
            2: fa_b5,
            3: fa_c5,
            4: fa_d5,
            5: fa_e5
        },
        775: {
            1: fa_q4,
            2: fa_b5,
            3: fa_c5,
            4: fa_d5,
            5: fa_e5
        },
        776: {
            1: fa_q4,
            2: fa_b5,
            3: fa_c5,
            4: fa_d5,
            5: fa_e5
        },
        777: {
            1: fa_q4,
            2: fa_b5,
            3: fa_c5,
            4: fa_d5,
            5: fa_e5
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        246: {
            1: fa_d1,
            2: fa_e1
        },
        248: {
            1: fa_d1,
            2: fa_e1
        },
        240: {
            1: fa_d1,
            2: fa_e1
        },
        232: {
            1: fa_d1,
            2: fa_e1
        },
        241: {
            1: fa_d1,
            2: fa_e1
        },
        233: {
            1: fa_d1,
            2: fa_e1
        },
        61: {
            1: fa_b1,
            2: fa_c1
        },
        62: {
            1: fa_b1,
            2: fa_c1
        },
        684: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        685: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        890: {
            1: fa_f4,
            2: fa_g4,
            3: fa_h4,
            4: fa_i4
        },
        242: {
            1: fa_d1,
            2: fa_e1
        },
        245: {
            1: fa_d1,
            2: fa_e1
        },
        243: {
            1: fa_d1,
            2: fa_e1
        },
        60: {
            1: fa_b1,
            2: fa_c1
        },
        683: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        406: {
            1: fa_h1,
            2: fa_i1
        },
        405: {
            1: fa_h1,
            2: fa_i1
        },
        404: {
            1: fa_h1,
            2: fa_i1
        },
        700: {
            1: fa_f5,
            2: fa_g5,
            3: fa_h5
        },
        408: {
            1: fa_h1,
            2: fa_i1
        },
        407: {
            1: fa_h1,
            2: fa_i1
        },
        247: {
            1: fa_d1,
            2: fa_e1
        },
        244: {
            1: fa_d1,
            2: fa_e1
        },
        638: {
            1: fa_h1,
            2: fa_i1
        },
        639: {
            1: fa_h1,
            2: fa_i1
        },
        640: {
            1: fa_h1,
            2: fa_i1
        },
        641: {
            1: fa_h1,
            2: fa_i1
        },
        646: {
            1: fa_i5,
            2: fa_j5,
            3: fa_k5
        },
        642: {
            1: fa_i5,
            2: fa_j5,
            3: fa_k5
        },
        643: {
            1: fa_i5,
            2: fa_j5,
            3: fa_k5
        },
        644: {
            1: fa_i5,
            2: fa_j5,
            3: fa_k5
        },
        645: {
            1: fa_i5,
            2: fa_j5,
            3: fa_k5
        }
    },
    41: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        791: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        792: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        796: {
            1: fa_j4,
            2: fa_k4,
            3: fa_l4,
            4: fa_m4,
            5: fa_n4,
            6: fa_o4,
            7: fa_p4,
            8: fa_q4,
            9: fa_r4,
            10: fa_s4,
            11: fa_t4,
            12: fa_u4,
            13: fa_v4,
            14: fa_w4
        },
        794: {
            1: fa_j4,
            2: fa_x4,
            3: fa_y4,
            4: fa_z4,
            5: fa_a5
        },
        795: {
            1: fa_j4,
            2: fa_x4,
            3: fa_y4,
            4: fa_z4,
            5: fa_a5
        },
        789: {
            1: fa_q4,
            2: fa_b5,
            3: fa_c5,
            4: fa_d5,
            5: fa_e5
        },
        790: {
            1: fa_q4,
            2: fa_b5,
            3: fa_c5,
            4: fa_d5,
            5: fa_e5
        },
        725: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        726: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        793: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        411: {
            1: fa_h1,
            2: fa_i1
        },
        701: {
            1: fa_d4,
            2: fa_e4,
            3: fa_l5
        },
        251: {
            1: fa_d1,
            2: fa_e1
        },
        252: {
            1: fa_d1,
            2: fa_e1
        },
        409: {
            1: fa_l1,
            2: fa_m1
        },
        430: {
            1: fa_l1,
            2: fa_m1
        },
        410: {
            1: fa_l1,
            2: fa_m1
        },
        431: {
            1: fa_l1,
            2: fa_m1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        249: {
            1: fa_d1,
            2: fa_e1
        },
        250: {
            1: fa_d1,
            2: fa_e1
        },
        63: {
            1: fa_b1,
            2: fa_c1
        },
        64: {
            1: fa_b1,
            2: fa_c1
        },
        686: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        687: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        648: {
            1: fa_h1,
            2: fa_i1
        },
        649: {
            1: fa_h1,
            2: fa_i1
        }
    },
    18: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        610: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        806: {
            1: fa_m5,
            2: fa_n5,
            3: fa_o5,
            4: fa_p5,
            5: fa_q5,
            6: fa_a5
        },
        893: {
            1: fa_r5,
            2: fa_s5,
            3: fa_t5,
            4: fa_u5,
            5: fa_v5,
            6: fa_w5
        },
        707: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l5
        },
        708: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l5
        },
        709: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l5
        },
        889: {
            1: fa_x5,
            2: fa_m2,
            3: fa_n2,
            4: fa_o2,
            5: fa_y5,
            6: fa_z5,
            7: fa_a6,
            8: fa_b6
        },
        904: {
            1: fa_c6,
            2: fa_d6,
            3: fa_e6,
            4: fa_f6,
            5: fa_g6,
            6: fa_h6,
            7: fa_i6,
            8: fa_j6,
            9: fa_k6
        },
        253: {
            1: fa_d1,
            2: fa_e1
        },
        688: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        65: {
            1: fa_b1,
            2: fa_c1
        },
        751: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        745: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        350: {
            1: fa_d1,
            2: fa_e1
        }
    },
    3: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        746: {
            1: fa_r1,
            2: fa_s1,
            3: fa_p1,
            4: fa_n1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        854: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        855: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        856: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        857: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        858: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        859: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        797: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        798: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        799: {
            1: fa_t1,
            2: fa_s6,
            3: fa_u6,
            4: fa_y1
        },
        851: {
            1: fa_t1,
            2: fa_s6,
            3: fa_u6,
            4: fa_x1
        },
        852: {
            1: fa_t1,
            2: fa_s6,
            3: fa_u6,
            4: fa_x1
        },
        853: {
            1: fa_t1,
            2: fa_s6,
            3: fa_v6,
            4: fa_x1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        905: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        906: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        907: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        362: {
            1: fa_x1,
            2: fa_y1
        },
        363: {
            1: fa_x1,
            2: fa_y1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_x1,
            2: fa_y1
        },
        359: {
            1: fa_x1,
            2: fa_y1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        891: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        800: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        801: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        802: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        }
    },
    20: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        145: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        189: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        676: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        677: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        678: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        679: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        680: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        860: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        861: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        862: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        863: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        864: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        865: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        866: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        867: {
            1: fa_g7,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_h7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    5: {
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        945: {
            1: fa_l1,
            2: fa_m1
        },
        948: {
            1: fa_i7,
            2: fa_j7,
            3: fa_k7,
            4: fa_l7,
            5: fa_m7
        },
        949: {
            1: fa_n7,
            2: fa_o7,
            3: fa_p7,
            4: fa_q7,
            5: fa_r7,
            6: fa_s7,
            7: fa_t7,
            8: fa_u7,
            9: fa_v7,
            10: fa_w7,
            11: fa_x7,
            12: fa_y7,
            13: fa_j7,
            14: fa_k7,
            15: fa_z7,
            16: fa_a8,
            17: fa_b8,
            18: fa_c8,
            19: fa_d8,
            20: fa_e8,
            21: fa_f8,
            22: fa_g8,
            23: fa_h8,
            24: fa_i8,
            25: fa_j8,
            26: fa_k8,
            27: fa_m7
        }
    },
    40: {
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    37: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    38: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_l8,
            2: fa_m8
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        413: {
            1: fa_h1,
            2: fa_i1
        },
        414: {
            1: fa_h1,
            2: fa_i1
        }
    },
    42: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_n8,
            2: fa_o8
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_l8,
            2: fa_m8
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        413: {
            1: fa_h1,
            2: fa_i1
        },
        414: {
            1: fa_h1,
            2: fa_i1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        698: {
            1: fa_h1,
            2: fa_p8,
            3: fa_i1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        369: {
            1: fa_h1,
            2: fa_i1
        },
        370: {
            1: fa_h1,
            2: fa_i1
        },
        940: {
            1: fa_h1,
            2: fa_i1
        },
        941: {
            1: fa_h1,
            2: fa_i1
        },
        942: {
            1: fa_h1,
            2: fa_i1
        },
        943: {
            1: fa_h1,
            2: fa_i1
        },
        944: {
            1: fa_h1,
            2: fa_i1
        }
    },
    26: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    25: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    16: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    12: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    36: {
        610: {
            1: fa_x1,
            2: fa_y1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    7: {
        425: {
            1: fa_l1,
            2: fa_m1
        },
        534: {
            1: fa_l1,
            2: fa_m1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_l1,
            2: fa_m1
        },
        261: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        803: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        868: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        869: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        870: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        805: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        892: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_l1,
            2: fa_m1
        },
        528: {
            1: fa_l1,
            2: fa_m1
        },
        420: {
            1: fa_l1,
            2: fa_m1
        },
        529: {
            1: fa_l1,
            2: fa_m1
        },
        707: {
            1: fa_q2,
            2: fa_q8,
            3: fa_l5
        },
        708: {
            1: fa_q2,
            2: fa_q8,
            3: fa_l5
        },
        706: {
            1: fa_r8,
            2: fa_s8,
            3: fa_l5
        },
        804: {
            1: fa_t8,
            2: fa_u8,
            3: fa_v8,
            4: fa_w8
        },
        474: {
            1: fa_x8,
            2: fa_y8
        },
        614: {
            1: fa_h1,
            2: fa_i1
        },
        609: {
            1: fa_l1,
            2: fa_m1
        },
        416: {
            1: fa_l1,
            2: fa_m1
        },
        732: {
            1: fa_h1,
            2: fa_z8,
            3: fa_i1
        },
        525: {
            1: fa_l1,
            2: fa_m1
        },
        850: {
            1: fa_a9,
            2: fa_b9,
            3: fa_c9,
            4: fa_d9
        },
        473: {
            1: fa_l1,
            2: fa_m1
        },
        442: {
            1: fa_l1,
            2: fa_m1
        },
        729: {
            1: fa_h1,
            2: fa_l5,
            3: fa_i1
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        542: {
            1: fa_l1,
            2: fa_m1
        },
        730: {
            1: fa_h1,
            2: fa_s2,
            3: fa_i1
        },
        471: {
            1: fa_l1,
            2: fa_m1
        },
        635: {
            1: fa_l1,
            2: fa_m1
        },
        714: {
            1: fa_e9,
            2: fa_s2,
            3: fa_f9
        },
        624: {
            1: fa_h1,
            2: fa_i1
        },
        625: {
            1: fa_h1,
            2: fa_i1
        },
        715: {
            1: fa_g9,
            2: fa_h9,
            3: fa_s2
        },
        650: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        651: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        652: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        653: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        654: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        655: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        634: {
            1: fa_l1,
            2: fa_m1
        },
        626: {
            1: fa_l1,
            2: fa_m1
        },
        733: {
            1: fa_i9,
            2: fa_j9,
            3: fa_k9
        },
        734: {
            1: fa_i9,
            2: fa_j9,
            3: fa_k9
        },
        258: {
            1: fa_d1,
            2: fa_e1
        },
        259: {
            1: fa_d1,
            2: fa_e1
        },
        66: {
            1: fa_b1,
            2: fa_c1
        },
        67: {
            1: fa_b1,
            2: fa_c1
        },
        81: {
            1: fa_b1,
            2: fa_c1
        },
        68: {
            1: fa_b1,
            2: fa_c1
        },
        689: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        690: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        699: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        691: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        723: {
            1: fa_h1,
            2: fa_l9,
            3: fa_i1
        },
        633: {
            1: fa_m1,
            2: fa_l1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_m9,
            2: fa_n9,
            3: fa_o9,
            4: fa_p9,
            5: fa_g6,
            6: fa_q9,
            7: fa_r9,
            8: fa_s9,
            9: fa_t9
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_u9,
            8: fa_x2,
            9: fa_y2,
            10: fa_p1,
            11: fa_q1,
            12: fa_z2,
            13: fa_a3,
            14: fa_v9,
            15: fa_r1,
            16: fa_s1,
            17: fa_b3,
            18: fa_t1,
            19: fa_c3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_i3,
            25: fa_j3,
            26: fa_k3,
            27: fa_n3,
            28: fa_o3,
            29: fa_w9,
            30: fa_x9,
            31: fa_r3
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_y9,
            2: fa_z9,
            3: fa_a10
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_e9,
            2: fa_s2,
            3: fa_f9
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_m1,
            2: fa_l1
        },
        526: {
            1: fa_m1,
            2: fa_l1
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_h1,
            2: fa_b10,
            3: fa_i1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        418: {
            1: fa_l1,
            2: fa_m1
        },
        527: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_l1,
            2: fa_m1
        },
        327: {
            1: fa_l1,
            2: fa_m1
        },
        724: {
            1: fa_h9,
            2: fa_c10,
            3: fa_g9
        },
        661: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        664: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        666: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        667: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        669: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        672: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        537: {
            1: fa_l1,
            2: fa_m1
        },
        541: {
            1: fa_l1,
            2: fa_m1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        437: {
            1: fa_l1,
            2: fa_m1
        },
        436: {
            1: fa_l1,
            2: fa_m1
        },
        694: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        71: {
            1: fa_b1,
            2: fa_c1
        },
        271: {
            1: fa_d1,
            2: fa_e1
        },
        268: {
            1: fa_d1,
            2: fa_e1
        },
        265: {
            1: fa_d1,
            2: fa_e1
        },
        267: {
            1: fa_d1,
            2: fa_e1
        },
        270: {
            1: fa_d1,
            2: fa_e1
        },
        272: {
            1: fa_d1,
            2: fa_e1
        },
        269: {
            1: fa_d1,
            2: fa_e1
        },
        266: {
            1: fa_d1,
            2: fa_e1
        },
        264: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        660: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        880: {
            1: fa_d10,
            2: fa_e10,
            3: fa_f10,
            4: fa_g10
        },
        879: {
            1: fa_h10,
            2: fa_i10,
            3: fa_j10,
            4: fa_k10
        },
        429: {
            1: fa_l1,
            2: fa_m1
        },
        433: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        881: {
            1: fa_l10,
            2: fa_m10,
            3: fa_n10,
            4: fa_o10,
            5: fa_p10,
            6: fa_q10
        },
        273: {
            1: fa_d1,
            2: fa_e1
        },
        274: {
            1: fa_d1,
            2: fa_e1
        },
        435: {
            1: fa_l1,
            2: fa_m1
        },
        704: {
            1: fa_g9,
            2: fa_r10,
            3: fa_h9
        },
        432: {
            1: fa_l1,
            2: fa_m1
        },
        428: {
            1: fa_l1,
            2: fa_m1
        },
        434: {
            1: fa_l1,
            2: fa_m1
        },
        439: {
            1: fa_l1,
            2: fa_m1
        },
        440: {
            1: fa_l1,
            2: fa_m1
        },
        441: {
            1: fa_l1,
            2: fa_m1
        },
        438: {
            1: fa_l1,
            2: fa_m1
        },
        623: {
            1: fa_h1,
            2: fa_i1
        },
        180: {
            1: fa_d1,
            2: fa_e1
        },
        146: {
            1: fa_d1,
            2: fa_e1
        },
        659: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        749: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_s10
        },
        69: {
            1: fa_b1,
            2: fa_c1
        },
        262: {
            1: fa_d1,
            2: fa_e1
        },
        692: {
            1: fa_x1,
            2: fa_p8,
            3: fa_y1
        },
        703: {
            1: fa_h1,
            2: fa_b10,
            3: fa_i1
        },
        70: {
            1: fa_b1,
            2: fa_c1
        },
        263: {
            1: fa_d1,
            2: fa_e1
        },
        693: {
            1: fa_t10,
            2: fa_z1,
            3: fa_u10
        },
        72: {
            1: fa_b1,
            2: fa_c1
        },
        277: {
            1: fa_d1,
            2: fa_e1
        },
        695: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        750: {
            1: fa_x2,
            2: fa_r1,
            3: fa_u1,
            4: fa_s1,
            5: fa_v1,
            6: fa_w1,
            7: fa_j3,
            8: fa_k3,
            9: fa_l3,
            10: fa_q3,
            11: fa_v10,
            12: fa_w10,
            13: fa_u2,
            14: fa_n1,
            15: fa_o1,
            16: fa_p1,
            17: fa_q1,
            18: fa_t1,
            19: fa_z2,
            20: fa_c3,
            21: fa_g3,
            22: fa_h3,
            23: fa_x10,
            24: fa_y10
        },
        181: {
            1: fa_d1,
            2: fa_e1
        },
        147: {
            1: fa_d1,
            2: fa_e1
        },
        276: {
            1: fa_d1,
            2: fa_e1
        },
        275: {
            1: fa_d1,
            2: fa_e1
        },
        735: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        736: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        737: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        738: {
            1: fa_h1,
            2: fa_b10,
            3: fa_i1
        },
        739: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        740: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        356: {
            1: fa_d1,
            2: fa_e1
        },
        357: {
            1: fa_d1,
            2: fa_e1
        },
        354: {
            1: fa_d1,
            2: fa_e1
        },
        355: {
            1: fa_d1,
            2: fa_e1
        },
        937: {
            1: fa_z10,
            2: fa_a11,
            3: fa_b11,
            4: fa_c11,
            5: fa_d11,
            6: fa_e11,
            7: fa_f11,
            8: fa_g11,
            9: fa_h11,
            10: fa_b10
        },
        657: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        658: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        412: {
            1: fa_l1,
            2: fa_m1
        }
    },
    14: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    34: {
        425: {
            1: fa_l1,
            2: fa_m1
        },
        534: {
            1: fa_l1,
            2: fa_m1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_l1,
            2: fa_m1
        },
        261: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        803: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_i11
        },
        868: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_i11
        },
        869: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_i11
        },
        870: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_i11
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_l1,
            2: fa_m1
        },
        528: {
            1: fa_l1,
            2: fa_m1
        },
        420: {
            1: fa_l1,
            2: fa_m1
        },
        529: {
            1: fa_l1,
            2: fa_m1
        },
        707: {
            1: fa_q2,
            2: fa_q8,
            3: fa_j11
        },
        708: {
            1: fa_q2,
            2: fa_q8,
            3: fa_j11
        },
        706: {
            1: fa_k11,
            2: fa_s8,
            3: fa_l5
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_l11,
            2: fa_z1,
            3: fa_m11
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_m9,
            2: fa_n9,
            3: fa_o9,
            4: fa_p9,
            5: fa_g6,
            6: fa_q9,
            7: fa_r9,
            8: fa_s9,
            9: fa_r9
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_u9,
            8: fa_x2,
            9: fa_y2,
            10: fa_p1,
            11: fa_q1,
            12: fa_z2,
            13: fa_a3,
            14: fa_v9,
            15: fa_r1,
            16: fa_s1,
            17: fa_b3,
            18: fa_t1,
            19: fa_c3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_i3,
            25: fa_j3,
            26: fa_k3,
            27: fa_n3,
            28: fa_o3,
            29: fa_w9,
            30: fa_x9,
            31: fa_r3
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_y9,
            2: fa_z9,
            3: fa_a10
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_e9,
            2: fa_s2,
            3: fa_f9
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_n11,
            2: fa_k9
        },
        526: {
            1: fa_n11,
            2: fa_k9
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_h1,
            2: fa_b10,
            3: fa_i1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        418: {
            1: fa_l1,
            2: fa_m1
        },
        527: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l9
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_l1,
            2: fa_m1
        },
        327: {
            1: fa_l1,
            2: fa_m1
        },
        724: {
            1: fa_o11,
            2: fa_p11,
            3: fa_q11
        },
        661: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        664: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        666: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        667: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        669: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        672: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        537: {
            1: fa_l1,
            2: fa_m1
        },
        541: {
            1: fa_l1,
            2: fa_m1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    19: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_l11,
            2: fa_z1,
            3: fa_m11
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        886: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        887: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        884: {
            1: fa_r11,
            2: fa_s11,
            3: fa_t11,
            4: fa_u11,
            5: fa_a5
        },
        885: {
            1: fa_r11,
            2: fa_s11,
            3: fa_t11,
            4: fa_u11,
            5: fa_v11
        },
        882: {
            1: fa_r11,
            2: fa_s11,
            3: fa_t11,
            4: fa_u11,
            5: fa_e5
        },
        883: {
            1: fa_r11,
            2: fa_s11,
            3: fa_t11,
            4: fa_u11,
            5: fa_w11
        },
        723: {
            1: fa_h1,
            2: fa_x11,
            3: fa_i1
        },
        673: {
            1: fa_l11,
            2: fa_z1,
            3: fa_m11
        },
        674: {
            1: fa_l11,
            2: fa_z1,
            3: fa_m11
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    30: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        279: {
            1: fa_d1,
            2: fa_e1
        },
        610: {
            1: fa_x1,
            2: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        350: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        745: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        710: {
            1: fa_q2,
            2: fa_y11,
            3: fa_s2
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        706: {
            1: fa_r8,
            2: fa_s8,
            3: fa_l5
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        344: {
            1: fa_d1,
            2: fa_e1
        },
        347: {
            1: fa_d1,
            2: fa_e1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_z11
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_z11
        },
        767: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_z11
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        751: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        889: {
            1: fa_x5,
            2: fa_m2,
            3: fa_n2,
            4: fa_o2,
            5: fa_y5,
            6: fa_z5,
            7: fa_a6,
            8: fa_b6
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        412: {
            1: fa_l1,
            2: fa_m1
        },
        634: {
            1: fa_l1,
            2: fa_m1
        },
        626: {
            1: fa_l1,
            2: fa_m1
        },
        611: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        904: {
            1: fa_c6,
            2: fa_d6,
            3: fa_e6,
            4: fa_f6,
            5: fa_g6,
            6: fa_h6,
            7: fa_i6,
            8: fa_j6,
            9: fa_k6
        },
        449: {
            1: fa_l1,
            2: fa_m1
        },
        446: {
            1: fa_l1,
            2: fa_m1
        },
        451: {
            1: fa_l1,
            2: fa_m1
        },
        711: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12
        },
        712: {
            1: fa_d12,
            2: fa_e12,
            3: fa_f12
        },
        713: {
            1: fa_g12,
            2: fa_h12,
            3: fa_i12
        },
        450: {
            1: fa_l1,
            2: fa_m1
        },
        447: {
            1: fa_l1,
            2: fa_m1
        },
        448: {
            1: fa_l1,
            2: fa_m1
        },
        662: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        663: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        665: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        668: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        670: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        671: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        3: {
            1: fa_b1,
            2: fa_c1
        },
        4: {
            1: fa_b1,
            2: fa_c1
        },
        6: {
            1: fa_b1,
            2: fa_c1
        },
        8: {
            1: fa_b1,
            2: fa_c1
        },
        10: {
            1: fa_b1,
            2: fa_c1
        },
        11: {
            1: fa_b1,
            2: fa_c1
        },
        161: {
            1: fa_d1,
            2: fa_e1
        },
        162: {
            1: fa_d1,
            2: fa_e1
        },
        164: {
            1: fa_d1,
            2: fa_e1
        },
        167: {
            1: fa_d1,
            2: fa_e1
        },
        169: {
            1: fa_d1,
            2: fa_e1
        },
        170: {
            1: fa_d1,
            2: fa_e1
        },
        707: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l5
        },
        708: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l5
        },
        709: {
            1: fa_q2,
            2: fa_r2,
            3: fa_l5
        },
        946: {
            1: fa_l1,
            2: fa_m1
        },
        947: {
            1: fa_l1,
            2: fa_m1
        }
    },
    23: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    13: {
        468: {
            1: fa_f1,
            2: fa_g1
        },
        470: {
            1: fa_f1,
            2: fa_g1
        },
        467: {
            1: fa_f1,
            2: fa_g1
        },
        469: {
            1: fa_f1,
            2: fa_g1
        },
        464: {
            1: fa_l1,
            2: fa_m1
        },
        466: {
            1: fa_l1,
            2: fa_m1
        },
        465: {
            1: fa_l1,
            2: fa_m1
        },
        463: {
            1: fa_l1,
            2: fa_m1
        },
        289: {
            1: fa_d1,
            2: fa_e1
        },
        288: {
            1: fa_d1,
            2: fa_e1
        },
        292: {
            1: fa_d1,
            2: fa_e1
        },
        461: {
            1: fa_l1,
            2: fa_m1
        },
        283: {
            1: fa_d1,
            2: fa_e1
        },
        295: {
            1: fa_d1,
            2: fa_e1
        },
        293: {
            1: fa_d1,
            2: fa_e1
        },
        284: {
            1: fa_d1,
            2: fa_e1
        },
        285: {
            1: fa_d1,
            2: fa_e1
        },
        316: {
            1: fa_d1,
            2: fa_e1
        },
        286: {
            1: fa_d1,
            2: fa_e1
        },
        287: {
            1: fa_d1,
            2: fa_e1
        },
        290: {
            1: fa_d1,
            2: fa_e1
        },
        291: {
            1: fa_d1,
            2: fa_e1
        },
        462: {
            1: fa_l1,
            2: fa_m1
        },
        294: {
            1: fa_d1,
            2: fa_e1
        }
    },
    39: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        950: {
            1: fa_n7,
            2: fa_o7,
            3: fa_p7,
            4: fa_q7,
            5: fa_r7,
            6: fa_j7,
            7: fa_k7,
            8: fa_z7,
            9: fa_a8,
            10: fa_b8,
            11: fa_c8,
            12: fa_d8,
            13: fa_m7
        },
        955: {
            1: fa_l1,
            2: fa_m1
        },
        951: {
            1: fa_j12,
            2: fa_k12
        },
        952: {
            1: fa_j12,
            2: fa_k12
        },
        953: {
            1: fa_j12,
            2: fa_k12
        },
        954: {
            1: fa_j12,
            2: fa_k12
        }
    },
    33: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    24: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    9: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    21: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    29: {
        394: {
            1: fa_x1,
            2: fa_y1
        },
        395: {
            1: fa_x1,
            2: fa_y1
        },
        396: {
            1: fa_x1,
            2: fa_y1
        },
        397: {
            1: fa_x1,
            2: fa_y1
        },
        398: {
            1: fa_x1,
            2: fa_y1
        },
        399: {
            1: fa_x1,
            2: fa_y1
        },
        400: {
            1: fa_x1,
            2: fa_y1
        },
        401: {
            1: fa_x1,
            2: fa_y1
        },
        402: {
            1: fa_x1,
            2: fa_y1
        },
        100: {
            1: fa_f1,
            2: fa_g1
        },
        101: {
            1: fa_f1,
            2: fa_g1
        },
        104: {
            1: fa_f1,
            2: fa_g1
        },
        105: {
            1: fa_f1,
            2: fa_g1
        },
        106: {
            1: fa_f1,
            2: fa_g1
        },
        107: {
            1: fa_f1,
            2: fa_g1
        },
        108: {
            1: fa_f1,
            2: fa_g1
        },
        109: {
            1: fa_f1,
            2: fa_g1
        },
        110: {
            1: fa_f1,
            2: fa_g1
        },
        111: {
            1: fa_f1,
            2: fa_g1
        },
        112: {
            1: fa_f1,
            2: fa_g1
        },
        113: {
            1: fa_f1,
            2: fa_g1
        },
        114: {
            1: fa_f1,
            2: fa_g1
        },
        115: {
            1: fa_f1,
            2: fa_g1
        },
        116: {
            1: fa_f1,
            2: fa_g1
        },
        117: {
            1: fa_f1,
            2: fa_g1
        },
        118: {
            1: fa_f1,
            2: fa_g1
        },
        119: {
            1: fa_f1,
            2: fa_g1
        },
        120: {
            1: fa_f1,
            2: fa_g1
        },
        121: {
            1: fa_f1,
            2: fa_g1
        },
        808: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        809: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        810: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        811: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        812: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        813: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        814: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        815: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        816: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        817: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        818: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        819: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        820: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        821: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        822: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        823: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        824: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        825: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        826: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        827: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        828: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        829: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        830: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        831: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        832: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        833: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        834: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        835: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        836: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        837: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        838: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        839: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        840: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        841: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        842: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        843: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        844: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12,
            4: fa_o12,
            5: fa_p12,
            6: fa_q12
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        371: {
            1: fa_x1,
            2: fa_y1
        },
        372: {
            1: fa_x1,
            2: fa_y1
        },
        373: {
            1: fa_x1,
            2: fa_y1
        },
        374: {
            1: fa_x1,
            2: fa_y1
        },
        375: {
            1: fa_x1,
            2: fa_y1
        },
        376: {
            1: fa_x1,
            2: fa_y1
        },
        377: {
            1: fa_x1,
            2: fa_y1
        },
        378: {
            1: fa_x1,
            2: fa_y1
        },
        379: {
            1: fa_x1,
            2: fa_y1
        },
        380: {
            1: fa_x1,
            2: fa_y1
        },
        381: {
            1: fa_x1,
            2: fa_y1
        },
        382: {
            1: fa_x1,
            2: fa_y1
        },
        383: {
            1: fa_x1,
            2: fa_y1
        },
        384: {
            1: fa_x1,
            2: fa_y1
        },
        385: {
            1: fa_x1,
            2: fa_y1
        },
        386: {
            1: fa_x1,
            2: fa_y1
        },
        387: {
            1: fa_x1,
            2: fa_y1
        },
        388: {
            1: fa_x1,
            2: fa_y1
        },
        389: {
            1: fa_x1,
            2: fa_y1
        },
        390: {
            1: fa_x1,
            2: fa_y1
        },
        391: {
            1: fa_x1,
            2: fa_y1
        },
        392: {
            1: fa_x1,
            2: fa_y1
        },
        393: {
            1: fa_x1,
            2: fa_y1
        },
        481: {
            1: fa_h1,
            2: fa_i1
        },
        482: {
            1: fa_h1,
            2: fa_i1
        },
        483: {
            1: fa_h1,
            2: fa_i1
        },
        484: {
            1: fa_h1,
            2: fa_i1
        },
        485: {
            1: fa_h1,
            2: fa_i1
        },
        486: {
            1: fa_h1,
            2: fa_i1
        },
        487: {
            1: fa_h1,
            2: fa_i1
        },
        488: {
            1: fa_h1,
            2: fa_i1
        },
        489: {
            1: fa_h1,
            2: fa_i1
        },
        490: {
            1: fa_h1,
            2: fa_i1
        },
        491: {
            1: fa_h1,
            2: fa_i1
        },
        492: {
            1: fa_h1,
            2: fa_i1
        },
        493: {
            1: fa_h1,
            2: fa_i1
        },
        494: {
            1: fa_h1,
            2: fa_i1
        },
        495: {
            1: fa_h1,
            2: fa_i1
        },
        496: {
            1: fa_h1,
            2: fa_i1
        },
        497: {
            1: fa_h1,
            2: fa_i1
        },
        498: {
            1: fa_h1,
            2: fa_i1
        },
        499: {
            1: fa_h1,
            2: fa_i1
        },
        500: {
            1: fa_h1,
            2: fa_i1
        },
        501: {
            1: fa_h1,
            2: fa_i1
        },
        502: {
            1: fa_h1,
            2: fa_i1
        },
        503: {
            1: fa_h1,
            2: fa_i1
        },
        504: {
            1: fa_h1,
            2: fa_i1
        },
        505: {
            1: fa_h1,
            2: fa_i1
        },
        506: {
            1: fa_h1,
            2: fa_i1
        },
        507: {
            1: fa_h1,
            2: fa_i1
        },
        508: {
            1: fa_h1,
            2: fa_i1
        },
        509: {
            1: fa_h1,
            2: fa_i1
        },
        510: {
            1: fa_h1,
            2: fa_i1
        },
        511: {
            1: fa_h1,
            2: fa_i1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        571: {
            1: fa_h1,
            2: fa_i1
        },
        572: {
            1: fa_h1,
            2: fa_i1
        },
        573: {
            1: fa_h1,
            2: fa_i1
        },
        574: {
            1: fa_h1,
            2: fa_i1
        },
        575: {
            1: fa_h1,
            2: fa_i1
        },
        576: {
            1: fa_h1,
            2: fa_i1
        },
        577: {
            1: fa_h1,
            2: fa_i1
        },
        578: {
            1: fa_h1,
            2: fa_i1
        },
        579: {
            1: fa_h1,
            2: fa_i1
        },
        580: {
            1: fa_h1,
            2: fa_i1
        },
        581: {
            1: fa_h1,
            2: fa_i1
        },
        582: {
            1: fa_h1,
            2: fa_i1
        },
        583: {
            1: fa_h1,
            2: fa_i1
        },
        584: {
            1: fa_h1,
            2: fa_i1
        },
        585: {
            1: fa_h1,
            2: fa_i1
        },
        586: {
            1: fa_h1,
            2: fa_i1
        },
        587: {
            1: fa_h1,
            2: fa_i1
        },
        588: {
            1: fa_h1,
            2: fa_i1
        },
        589: {
            1: fa_h1,
            2: fa_i1
        },
        590: {
            1: fa_h1,
            2: fa_i1
        },
        591: {
            1: fa_h1,
            2: fa_i1
        },
        592: {
            1: fa_h1,
            2: fa_i1
        },
        593: {
            1: fa_h1,
            2: fa_i1
        },
        594: {
            1: fa_h1,
            2: fa_i1
        },
        595: {
            1: fa_h1,
            2: fa_i1
        },
        596: {
            1: fa_h1,
            2: fa_i1
        },
        597: {
            1: fa_h1,
            2: fa_i1
        },
        598: {
            1: fa_h1,
            2: fa_i1
        },
        599: {
            1: fa_h1,
            2: fa_i1
        },
        600: {
            1: fa_h1,
            2: fa_i1
        },
        601: {
            1: fa_h1,
            2: fa_i1
        },
        602: {
            1: fa_h1,
            2: fa_i1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        89: {
            1: fa_f1,
            2: fa_g1
        },
        90: {
            1: fa_f1,
            2: fa_g1
        },
        91: {
            1: fa_f1,
            2: fa_g1
        },
        92: {
            1: fa_f1,
            2: fa_g1
        },
        93: {
            1: fa_f1,
            2: fa_g1
        },
        94: {
            1: fa_f1,
            2: fa_g1
        },
        95: {
            1: fa_f1,
            2: fa_g1
        },
        96: {
            1: fa_f1,
            2: fa_g1
        },
        97: {
            1: fa_f1,
            2: fa_g1
        },
        98: {
            1: fa_f1,
            2: fa_g1
        },
        99: {
            1: fa_f1,
            2: fa_g1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        254: {
            1: fa_d1,
            2: fa_e1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        29: {
            1: fa_b1,
            2: fa_c1
        },
        30: {
            1: fa_b1,
            2: fa_c1
        },
        31: {
            1: fa_b1,
            2: fa_c1
        },
        32: {
            1: fa_b1,
            2: fa_c1
        },
        33: {
            1: fa_b1,
            2: fa_c1
        },
        34: {
            1: fa_b1,
            2: fa_c1
        },
        35: {
            1: fa_b1,
            2: fa_c1
        },
        36: {
            1: fa_b1,
            2: fa_c1
        },
        37: {
            1: fa_b1,
            2: fa_c1
        },
        38: {
            1: fa_b1,
            2: fa_c1
        },
        39: {
            1: fa_b1,
            2: fa_c1
        },
        40: {
            1: fa_b1,
            2: fa_c1
        },
        41: {
            1: fa_b1,
            2: fa_c1
        },
        42: {
            1: fa_b1,
            2: fa_c1
        },
        43: {
            1: fa_b1,
            2: fa_c1
        },
        44: {
            1: fa_b1,
            2: fa_c1
        },
        45: {
            1: fa_b1,
            2: fa_c1
        },
        46: {
            1: fa_b1,
            2: fa_c1
        },
        47: {
            1: fa_b1,
            2: fa_c1
        },
        48: {
            1: fa_b1,
            2: fa_c1
        },
        49: {
            1: fa_b1,
            2: fa_c1
        },
        50: {
            1: fa_b1,
            2: fa_c1
        },
        51: {
            1: fa_b1,
            2: fa_c1
        },
        52: {
            1: fa_b1,
            2: fa_c1
        },
        53: {
            1: fa_b1,
            2: fa_c1
        },
        54: {
            1: fa_b1,
            2: fa_c1
        },
        55: {
            1: fa_b1,
            2: fa_c1
        },
        56: {
            1: fa_b1,
            2: fa_c1
        },
        57: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        203: {
            1: fa_d1,
            2: fa_e1
        },
        204: {
            1: fa_d1,
            2: fa_e1
        },
        205: {
            1: fa_d1,
            2: fa_e1
        },
        206: {
            1: fa_d1,
            2: fa_e1
        },
        207: {
            1: fa_d1,
            2: fa_e1
        },
        208: {
            1: fa_d1,
            2: fa_e1
        },
        209: {
            1: fa_d1,
            2: fa_e1
        },
        210: {
            1: fa_d1,
            2: fa_e1
        },
        211: {
            1: fa_d1,
            2: fa_e1
        },
        212: {
            1: fa_d1,
            2: fa_e1
        },
        213: {
            1: fa_d1,
            2: fa_e1
        },
        214: {
            1: fa_d1,
            2: fa_e1
        },
        215: {
            1: fa_d1,
            2: fa_e1
        },
        216: {
            1: fa_d1,
            2: fa_e1
        },
        217: {
            1: fa_d1,
            2: fa_e1
        },
        218: {
            1: fa_d1,
            2: fa_e1
        },
        219: {
            1: fa_d1,
            2: fa_e1
        },
        220: {
            1: fa_d1,
            2: fa_e1
        },
        221: {
            1: fa_d1,
            2: fa_e1
        },
        222: {
            1: fa_d1,
            2: fa_e1
        },
        223: {
            1: fa_d1,
            2: fa_e1
        },
        224: {
            1: fa_d1,
            2: fa_e1
        },
        225: {
            1: fa_d1,
            2: fa_e1
        },
        226: {
            1: fa_d1,
            2: fa_e1
        },
        227: {
            1: fa_d1,
            2: fa_e1
        },
        228: {
            1: fa_d1,
            2: fa_e1
        },
        229: {
            1: fa_d1,
            2: fa_e1
        },
        230: {
            1: fa_d1,
            2: fa_e1
        },
        231: {
            1: fa_d1,
            2: fa_e1
        },
        475: {
            1: fa_h1,
            2: fa_i1
        },
        476: {
            1: fa_h1,
            2: fa_i1
        },
        477: {
            1: fa_h1,
            2: fa_i1
        },
        478: {
            1: fa_h1,
            2: fa_i1
        },
        479: {
            1: fa_h1,
            2: fa_i1
        },
        480: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    15: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    2: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        571: {
            1: fa_h1,
            2: fa_i1
        },
        572: {
            1: fa_h1,
            2: fa_i1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        371: {
            1: fa_x1,
            2: fa_y1
        },
        372: {
            1: fa_x1,
            2: fa_y1
        },
        122: {
            1: fa_l1,
            2: fa_m1
        },
        123: {
            1: fa_l1,
            2: fa_m1
        },
        124: {
            1: fa_l1,
            2: fa_m1
        },
        125: {
            1: fa_l1,
            2: fa_m1
        },
        126: {
            1: fa_l1,
            2: fa_m1
        },
        127: {
            1: fa_l1,
            2: fa_m1
        },
        128: {
            1: fa_l1,
            2: fa_m1
        },
        129: {
            1: fa_l1,
            2: fa_m1
        },
        130: {
            1: fa_l1,
            2: fa_m1
        },
        131: {
            1: fa_l1,
            2: fa_m1
        },
        132: {
            1: fa_l1,
            2: fa_m1
        },
        133: {
            1: fa_l1,
            2: fa_m1
        },
        134: {
            1: fa_l1,
            2: fa_m1
        },
        135: {
            1: fa_l1,
            2: fa_m1
        },
        872: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        873: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        874: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        875: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        876: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        877: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        878: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_r12
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        619: {
            1: fa_h1,
            2: fa_i1
        },
        620: {
            1: fa_h1,
            2: fa_i1
        },
        621: {
            1: fa_h1,
            2: fa_i1
        },
        622: {
            1: fa_h1,
            2: fa_i1
        },
        894: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        895: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        896: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        897: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        898: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        899: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        900: {
            1: fa_s12,
            2: fa_t12,
            3: fa_u12,
            4: fa_v12
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        89: {
            1: fa_f1,
            2: fa_g1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        752: {
            1: fa_u1,
            2: fa_v1,
            3: fa_w1,
            4: fa_t1,
            5: fa_q1,
            6: fa_o1
        },
        753: {
            1: fa_i3,
            2: fa_j3,
            3: fa_k3,
            4: fa_l3,
            5: fa_g3,
            6: fa_c3,
            7: fa_z2,
            8: fa_v2
        }
    },
    6: {
        553: {
            1: fa_l1,
            2: fa_m1
        },
        339: {
            1: fa_d1,
            2: fa_e1
        },
        547: {
            1: fa_l1,
            2: fa_m1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        807: {
            1: fa_c6,
            2: fa_e6,
            3: fa_i6,
            4: fa_k6
        },
        636: {
            1: fa_l1,
            2: fa_m1
        },
        334: {
            1: fa_d1,
            2: fa_e1
        },
        335: {
            1: fa_d1,
            2: fa_e1
        },
        336: {
            1: fa_d1,
            2: fa_e1
        },
        337: {
            1: fa_d1,
            2: fa_e1
        },
        906: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        907: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        908: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        909: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        300: {
            1: fa_d1,
            2: fa_e1
        },
        301: {
            1: fa_d1,
            2: fa_e1
        },
        302: {
            1: fa_d1,
            2: fa_e1
        },
        303: {
            1: fa_d1,
            2: fa_e1
        },
        304: {
            1: fa_d1,
            2: fa_e1
        },
        310: {
            1: fa_d1,
            2: fa_e1
        },
        311: {
            1: fa_d1,
            2: fa_e1
        },
        312: {
            1: fa_d1,
            2: fa_e1
        },
        313: {
            1: fa_d1,
            2: fa_e1
        },
        314: {
            1: fa_d1,
            2: fa_e1
        },
        554: {
            1: fa_l1,
            2: fa_m1
        },
        555: {
            1: fa_l1,
            2: fa_m1
        },
        556: {
            1: fa_l1,
            2: fa_m1
        },
        557: {
            1: fa_l1,
            2: fa_m1
        },
        558: {
            1: fa_l1,
            2: fa_m1
        },
        517: {
            1: fa_l1,
            2: fa_m1
        },
        518: {
            1: fa_l1,
            2: fa_m1
        },
        519: {
            1: fa_l1,
            2: fa_m1
        },
        520: {
            1: fa_l1,
            2: fa_m1
        },
        521: {
            1: fa_l1,
            2: fa_m1
        },
        561: {
            1: fa_l1,
            2: fa_m1
        },
        562: {
            1: fa_l1,
            2: fa_m1
        },
        563: {
            1: fa_l1,
            2: fa_m1
        },
        564: {
            1: fa_l1,
            2: fa_m1
        },
        565: {
            1: fa_l1,
            2: fa_m1
        },
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_n1,
            2: fa_o1,
            3: fa_p1,
            4: fa_q1,
            5: fa_r1,
            6: fa_s1,
            7: fa_t1,
            8: fa_u1,
            9: fa_v1,
            10: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        903: {
            1: fa_w12,
            2: fa_x12,
            3: fa_y12,
            4: fa_z12,
            5: fa_a13,
            6: fa_b13,
            7: fa_c13,
            8: fa_d13
        },
        445: {
            1: fa_h1,
            2: fa_i1
        },
        754: {
            1: fa_u9,
            2: fa_v9,
            3: fa_e3,
            4: fa_e13,
            5: fa_s6,
            6: fa_f13,
            7: fa_w9,
            8: fa_x9,
            9: fa_g13,
            10: fa_h13,
            11: fa_i13,
            12: fa_j13,
            13: fa_k13,
            14: fa_l13
        },
        755: {
            1: fa_u9,
            2: fa_v9,
            3: fa_e3,
            4: fa_e13,
            5: fa_s6,
            6: fa_f13,
            7: fa_w9,
            8: fa_x9,
            9: fa_g13,
            10: fa_h13,
            11: fa_i13,
            12: fa_j13,
            13: fa_k13,
            14: fa_l13
        },
        756: {
            1: fa_u9,
            2: fa_v9,
            3: fa_e3,
            4: fa_e13,
            5: fa_s6,
            6: fa_f13,
            7: fa_w9,
            8: fa_x9,
            9: fa_g13,
            10: fa_h13,
            11: fa_i13,
            12: fa_j13,
            13: fa_k13,
            14: fa_l13
        },
        757: {
            1: fa_u9,
            2: fa_v9,
            3: fa_e3,
            4: fa_e13,
            5: fa_s6,
            6: fa_f13,
            7: fa_w9,
            8: fa_x9,
            9: fa_g13,
            10: fa_h13,
            11: fa_i13,
            12: fa_j13,
            13: fa_k13,
            14: fa_l13
        },
        758: {
            1: fa_u9,
            2: fa_v9,
            3: fa_e3,
            4: fa_e13,
            5: fa_s6,
            6: fa_f13,
            7: fa_w9,
            8: fa_x9,
            9: fa_g13,
            10: fa_h13,
            11: fa_i13,
            12: fa_j13,
            13: fa_k13,
            14: fa_l13
        },
        452: {
            1: fa_l1,
            2: fa_m1
        },
        453: {
            1: fa_l1,
            2: fa_m1
        },
        454: {
            1: fa_l1,
            2: fa_m1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        522: {
            1: fa_h1,
            2: fa_i1
        },
        627: {
            1: fa_l1,
            2: fa_m1
        },
        628: {
            1: fa_l1,
            2: fa_m1
        },
        629: {
            1: fa_l1,
            2: fa_m1
        },
        630: {
            1: fa_l1,
            2: fa_m1
        },
        631: {
            1: fa_l1,
            2: fa_m1
        },
        632: {
            1: fa_l1,
            2: fa_m1
        },
        190: {
            1: fa_d1,
            2: fa_e1
        },
        191: {
            1: fa_d1,
            2: fa_e1
        },
        192: {
            1: fa_d1,
            2: fa_e1
        },
        193: {
            1: fa_d1,
            2: fa_e1
        },
        194: {
            1: fa_d1,
            2: fa_e1
        },
        759: {
            1: fa_m13,
            2: fa_n13,
            3: fa_o13,
            4: fa_p13,
            5: fa_q13,
            6: fa_k13,
            7: fa_r13,
            8: fa_s13,
            9: fa_t13,
            10: fa_u13,
            11: fa_v13,
            12: fa_w13,
            13: fa_f13,
            14: fa_x13
        },
        760: {
            1: fa_m13,
            2: fa_n13,
            3: fa_o13,
            4: fa_p13,
            5: fa_q13,
            6: fa_k13,
            7: fa_r13,
            8: fa_s13,
            9: fa_t13,
            10: fa_u13,
            11: fa_v13,
            12: fa_w13,
            13: fa_f13,
            14: fa_x13
        },
        761: {
            1: fa_m13,
            2: fa_n13,
            3: fa_o13,
            4: fa_p13,
            5: fa_q13,
            6: fa_k13,
            7: fa_r13,
            8: fa_s13,
            9: fa_t13,
            10: fa_u13,
            11: fa_v13,
            12: fa_w13,
            13: fa_f13,
            14: fa_x13
        },
        762: {
            1: fa_m13,
            2: fa_n13,
            3: fa_o13,
            4: fa_p13,
            5: fa_q13,
            6: fa_k13,
            7: fa_r13,
            8: fa_s13,
            9: fa_t13,
            10: fa_u13,
            11: fa_v13,
            12: fa_w13,
            13: fa_f13,
            14: fa_x13
        },
        763: {
            1: fa_m13,
            2: fa_n13,
            3: fa_o13,
            4: fa_p13,
            5: fa_q13,
            6: fa_k13,
            7: fa_r13,
            8: fa_s13,
            9: fa_t13,
            10: fa_u13,
            11: fa_v13,
            12: fa_w13,
            13: fa_f13,
            14: fa_x13
        },
        768: {
            1: fa_a6,
            2: fa_y13,
            3: fa_z13,
            4: fa_a14,
            5: fa_b14,
            6: fa_c2,
            7: fa_c14
        },
        769: {
            1: fa_a6,
            2: fa_y13,
            3: fa_z13,
            4: fa_a14,
            5: fa_b14,
            6: fa_c2,
            7: fa_c14
        },
        770: {
            1: fa_a6,
            2: fa_y13,
            3: fa_z13,
            4: fa_a14,
            5: fa_b14,
            6: fa_c2,
            7: fa_c14
        },
        771: {
            1: fa_a6,
            2: fa_y13,
            3: fa_z13,
            4: fa_a14,
            5: fa_b14,
            6: fa_c2,
            7: fa_c14
        },
        772: {
            1: fa_a6,
            2: fa_y13,
            3: fa_z13,
            4: fa_a14,
            5: fa_b14,
            6: fa_c2,
            7: fa_c14
        },
        603: {
            1: fa_h1,
            2: fa_i1
        },
        604: {
            1: fa_h1,
            2: fa_i1
        },
        605: {
            1: fa_h1,
            2: fa_i1
        },
        606: {
            1: fa_h1,
            2: fa_i1
        },
        607: {
            1: fa_h1,
            2: fa_i1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        696: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        333: {
            1: fa_d1,
            2: fa_e1
        },
        341: {
            1: fa_d1,
            2: fa_e1
        },
        427: {
            1: fa_l1,
            2: fa_m1
        },
        536: {
            1: fa_l1,
            2: fa_m1
        },
        905: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        514: {
            1: fa_h1,
            2: fa_i1
        },
        516: {
            1: fa_h1,
            2: fa_i1
        },
        305: {
            1: fa_d1,
            2: fa_e1
        },
        315: {
            1: fa_d1,
            2: fa_e1
        },
        523: {
            1: fa_l1,
            2: fa_m1
        },
        299: {
            1: fa_d1,
            2: fa_e1
        },
        309: {
            1: fa_d1,
            2: fa_e1
        },
        697: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        298: {
            1: fa_d1,
            2: fa_e1
        },
        308: {
            1: fa_d1,
            2: fa_e1
        },
        515: {
            1: fa_h1,
            2: fa_i1
        },
        549: {
            1: fa_l1,
            2: fa_m1
        },
        548: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        550: {
            1: fa_d14,
            2: fa_i1
        },
        551: {
            1: fa_h1,
            2: fa_e14
        },
        455: {
            1: fa_l1,
            2: fa_m1
        },
        456: {
            1: fa_l1,
            2: fa_m1
        },
        457: {
            1: fa_l1,
            2: fa_m1
        },
        458: {
            1: fa_l1,
            2: fa_m1
        },
        459: {
            1: fa_l1,
            2: fa_m1
        },
        460: {
            1: fa_l1,
            2: fa_m1
        },
        512: {
            1: fa_d14,
            2: fa_i1
        },
        513: {
            1: fa_h1,
            2: fa_e14
        },
        901: {
            1: fa_f14,
            2: fa_x12,
            3: fa_y12,
            4: fa_z12,
            5: fa_g14,
            6: fa_b13,
            7: fa_c13,
            8: fa_d13
        },
        902: {
            1: fa_f14,
            2: fa_x12,
            3: fa_y12,
            4: fa_z12,
            5: fa_g14,
            6: fa_b13,
            7: fa_c13,
            8: fa_d13
        },
        340: {
            1: fa_d1,
            2: fa_e1
        },
        328: {
            1: fa_d1,
            2: fa_e1
        },
        329: {
            1: fa_d1,
            2: fa_e1
        },
        342: {
            1: fa_d1,
            2: fa_e1
        },
        330: {
            1: fa_d1,
            2: fa_e1
        },
        331: {
            1: fa_d1,
            2: fa_e1
        },
        722: {
            1: fa_h14,
            2: fa_p11,
            3: fa_i14
        },
        560: {
            1: fa_l1,
            2: fa_m1
        },
        543: {
            1: fa_l1,
            2: fa_m1
        },
        544: {
            1: fa_l1,
            2: fa_m1
        },
        545: {
            1: fa_j14,
            2: fa_k14
        },
        546: {
            1: fa_l1,
            2: fa_m1
        },
        332: {
            1: fa_d1,
            2: fa_e1
        },
        559: {
            1: fa_l1,
            2: fa_m1
        },
        296: {
            1: fa_d1,
            2: fa_e1
        },
        297: {
            1: fa_d1,
            2: fa_e1
        },
        717: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        718: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        719: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        720: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        721: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        552: {
            1: fa_b1,
            2: fa_c1
        },
        76: {
            1: fa_b1,
            2: fa_c1
        },
        77: {
            1: fa_b1,
            2: fa_c1
        },
        78: {
            1: fa_b1,
            2: fa_c1
        },
        79: {
            1: fa_b1,
            2: fa_c1
        },
        80: {
            1: fa_b1,
            2: fa_c1
        },
        647: {
            1: fa_h1,
            2: fa_i1
        },
        741: {
            1: fa_l14,
            2: fa_k7,
            3: fa_m14
        },
        82: {
            1: fa_b1,
            2: fa_c1
        },
        338: {
            1: fa_d1,
            2: fa_e1
        }
    },
    17: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    4: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        764: {
            1: fa_o1,
            2: fa_q1,
            3: fa_t1,
            4: fa_u1,
            5: fa_v1,
            6: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        923: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        924: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        925: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        926: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        927: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        929: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        930: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        931: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        932: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        933: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        845: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        846: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        847: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        848: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        849: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        918: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        919: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        920: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        921: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        922: {
            1: fa_t1,
            2: fa_s6,
            3: fa_t6,
            4: fa_y1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        905: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        906: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        907: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        908: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        909: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        807: {
            1: fa_c6,
            2: fa_e6,
            3: fa_i6,
            4: fa_k6
        },
        319: {
            1: fa_d1,
            2: fa_e1
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        912: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        913: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        914: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        915: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        916: {
            1: fa_a7,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_e7,
            6: fa_f7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        362: {
            1: fa_x1,
            2: fa_y1
        },
        363: {
            1: fa_x1,
            2: fa_y1
        },
        364: {
            1: fa_x1,
            2: fa_y1
        },
        365: {
            1: fa_x1,
            2: fa_y1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        20: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        179: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_x1,
            2: fa_y1
        },
        359: {
            1: fa_x1,
            2: fa_y1
        },
        360: {
            1: fa_x1,
            2: fa_y1
        },
        361: {
            1: fa_x1,
            2: fa_y1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        16: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        175: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        619: {
            1: fa_h1,
            2: fa_i1
        },
        620: {
            1: fa_h1,
            2: fa_i1
        },
        891: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2
        },
        26: {
            1: fa_n14,
            2: fa_o14
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        371: {
            1: fa_x1,
            2: fa_y1
        },
        571: {
            1: fa_h1,
            2: fa_i1
        },
        928: {
            1: fa_s3,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6
        },
        934: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_r6
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        910: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6
        },
        917: {
            1: fa_a7,
            2: fa_b7,
            3: fa_p14,
            4: fa_d7,
            5: fa_e7,
            6: fa_q14
        },
        936: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_y5
        }
    },
    8: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        676: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    27: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    28: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        935: {
            1: fa_w9,
            2: fa_x9,
            3: fa_g13,
            4: fa_h13,
            5: fa_i13,
            6: fa_r14,
            7: fa_u9,
            8: fa_v9,
            9: fa_e3,
            10: fa_e13,
            11: fa_s6,
            12: fa_s14
        },
        612: {
            1: fa_l1,
            2: fa_m1
        },
        613: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    }
};
var periodConfig = {
    2: {
        200: 'Not Started',
        201: 'First Game',
        208: 'End',
        207: 'Seventh Game',
        206: 'Sixth Game',
        205: 'Fifth Game',
        204: 'Fourth Game',
        203: 'Third Game',
        202: 'Second Game'
    },
    3: {
        300: 'Not Started',
        301: 'First Set',
        302: 'Second Set',
        303: 'Third Set',
        304: 'End'
    },
    4: {
        401: 'First Set',
        400: 'Not Started',
        407: 'Golden Set',
        402: 'Second Set',
        406: 'End',
        405: 'Fifth Set',
        404: 'Fourth Set',
        403: 'Third Set'
    },
    5: {
        501: 'First round',
        500: 'Not Started',
        502: 'Second round',
        513: 'Match finished',
        512: 'Twelfth round',
        511: 'Eleventh round',
        510: 'Tenth round',
        509: 'Ninth round',
        508: 'Eighth round',
        507: 'Seventh round',
        506: 'Sixth round',
        505: 'Fifth round',
        504: 'Fourth round',
        503: 'Third round'
    },
    6: {
        602: 'Second Set',
        601: 'First Set',
        600: 'Not Started',
        603: 'Third Set',
        606: 'End',
        605: 'Fifth Set',
        604: 'Fourth Set'
    },
    7: {
        709: 'Shootout',
        708: 'End of Second Extra Time',
        707: 'Second Extra Time',
        706: 'End of First Extra Time',
        705: 'First Extra Time',
        704: 'Full Time',
        703: 'Second Half',
        702: 'Half Time',
        701: 'First Half',
        700: 'Not Started',
        710: 'Match Ended'
    },
    8: {
        800: 'Not Started',
        801: 'First Quarter',
        802: 'Pause',
        803: 'Second Quater',
        804: 'Intermission',
        810: 'End',
        806: 'Pause',
        807: 'Fourth Quater',
        808: 'Pause',
        809: 'Overtime',
        805: 'Third Quarter'
    },
    9: {
        900: 'Not Started',
        901: 'First Half',
        902: 'Half Time',
        903: 'Second Half',
        904: 'End'
    },
    12: {
        1200: 'Not Started',
        1201: 'First Half',
        1202: 'Half Time',
        1203: 'Second Half',
        1204: 'End'
    },
    18: {
        1800: 'Not Started',
        1801: 'First Period',
        1802: 'First Intermission',
        1803: 'Second Period',
        1804: 'Second Intermission',
        1810: 'End',
        1806: 'End of Regulation Time',
        1807: 'Overtime',
        1808: 'End of Overtime',
        1809: 'Shootout',
        1805: 'Third Period'
    },
    19: {
        1900: 'Not Started',
        1901: 'First Half',
        1902: 'Half Time',
        1903: 'Second Half',
        1904: 'Full Time',
        1905: 'End'
    },
    20: {
        2000: 'Not Started',
        2001: 'First',
        2002: 'First Fire Line',
        2003: 'Second Lap',
        2004: 'Second Fire Line',
        2005: 'Third Lap',
        2006: 'Third Fire Line',
        2007: 'Fourth Lap',
        2008: 'Fourth Fire Line',
        2009: 'Fifth Lap',
        2010: 'Fifth Fire Line',
        2011: 'Sixth Lap',
        2012: 'Sixth Fire Line',
        2013: 'Seventh Lap',
        2014: 'Seventh Fire Line',
        2015: 'Eighth Lap',
        2016: 'Eighth Fire Line',
        2017: 'End'
    },
    28: {
        2800: 'Not Started',
        2801: 'Regular Time',
        2802: 'End'
    },
    29: {
        2953: '27th Frame',
        2954: 'Intermission',
        2955: '28th Frame',
        2956: 'Intermission',
        2957: '29th Frame',
        2958: 'Intermission',
        2959: '30th Frame',
        2960: 'Intermission',
        2961: '31st Frame',
        2962: 'Intermission',
        2963: '32nd Frame',
        2964: 'Intermission',
        2965: '33rd Frame',
        2966: 'Intermission',
        2967: '34th Frame',
        2968: 'Intermission',
        2969: '35th Frame',
        2970: 'Intermission',
        2971: '36th Frame',
        2972: 'Intermission',
        2973: '37th Frame',
        2974: 'End',
        2900: 'Not Started',
        2901: '1st Frame',
        2902: 'Intermission',
        2903: '2nd Frame',
        2904: 'Intermission',
        2905: '3rd Frame',
        2906: 'Intermission',
        2907: '4th Frame',
        2908: 'Intermission',
        2909: '5th Frame',
        2910: 'Intermission',
        2911: '6th Frame',
        2912: 'Intermission',
        2913: '7th Frame',
        2914: 'Intermission',
        2915: '8th Frame',
        2916: 'Intermission',
        2917: '9th Frame',
        2918: 'Intermission',
        2919: '10th Frame',
        2920: 'Intermission',
        2921: '11th Frame',
        2922: 'Intermission',
        2923: '12th Frame',
        2924: 'Intermission',
        2925: '13th Frame',
        2926: 'Intermission',
        2927: '14th Frame',
        2928: 'Intermission',
        2929: '15th Frame',
        2930: 'Intermission',
        2931: '16th Frame',
        2932: 'Intermission',
        2933: '17th Frame',
        2934: 'Intermission',
        2935: '18th Frame',
        2936: 'Intermission',
        2937: '19th Frame',
        2938: 'Intermission',
        2939: '20th Frame',
        2940: 'Intermission',
        2941: '21st Frame',
        2942: 'Intermission',
        2943: '22nd Frame',
        2944: 'Intermission',
        2945: '23rd Frame',
        2946: 'Intermission',
        2947: '24th Frame',
        2948: 'Intermission',
        2949: '25th Frame',
        2950: 'Intermission',
        2951: '26th Frame',
        2952: 'Intermission'
    },
    30: {
        3000: 'Not Started',
        3001: 'First Period',
        3002: 'First Intermission',
        3003: 'Second Period',
        3004: 'Second Intermission',
        3010: 'End',
        3006: 'End of Regulation Time',
        3007: 'Overtime',
        3008: 'End of Overtime',
        3009: 'Shootout',
        3005: 'Third Period'
    },
    31: {
        3100: 'Not Started',
        3101: 'First Quarter',
        3102: 'Pause',
        3103: 'Second Quarter',
        3104: 'Intermission',
        3110: 'End',
        3106: 'Pause',
        3107: 'Fourth Quarter',
        3108: 'Pause',
        3109: 'Overtime',
        3105: 'Third Quarter'
    },
    32: {
        3200: 'Not Started',
        3201: 'First Game',
        3202: 'Second Game',
        3203: 'Third Game',
        3204: 'End'
    },
    34: {
        3400: 'Not started',
        3401: 'First Half',
        3402: 'Half Time',
        3403: 'Second Half',
        3404: 'Full Time',
        3409: 'Shootout',
        3405: 'First Extra Time',
        3406: 'End of First Extra Time',
        3407: 'Second Extra Time',
        3408: 'End of Second Extra Time',
        3410: 'Match Ended'
    },
    35: {
        3500: 'Not Started',
        3501: 'First Half',
        3502: 'Half Time',
        3503: 'Second Half',
        3504: 'Full Time'
    },
    36: {
        3609: 'Shootout',
        3608: 'End of Overtime',
        3607: 'Overtime',
        3606: 'End of Regulation Time',
        3605: 'Third Period',
        3604: 'Second Intermission',
        3603: 'Second Period',
        3602: 'First Intermission',
        3601: 'First Period',
        3600: 'Not Started',
        3610: 'End'
    },
    37: {
        3700: 'Not Started',
        3701: 'End'
    },
    38: {
        3800: 'Not Started',
        3801: 'End'
    },
    39: {
        3900: 'Not Started',
        3901: 'End',
        3902: 'First round',
        3903: 'Second round',
        3904: 'Third round',
        3905: 'Fourth round',
        3906: 'Fifth round',
    },
    40: {
        4000: 'Not Started',
        4001: 'End'
    },
    41: {
        4105: 'Overtime',
        4104: 'Second intermission',
        4103: 'Second half',
        4102: 'First intermission',
        4100: 'Not Started',
        4101: 'First half',
        4106: 'End'
    },
    42: {
        4205: 'Fifth map',
        4204: 'Fourth map',
        4203: 'Third map',
        4202: 'Second map',
        4200: 'Not Started',
        4201: 'First map',
        4206: 'End'
    }
};
export function getOutcomeName(sportId, outcome, match) {
    var func;
    if (baseOutcomeConfig !== undefined &&
        baseOutcomeConfig[sportId] !== undefined &&
        baseOutcomeConfig[sportId]) {
        func = baseOutcomeConfig[sportId][outcome.type];
    }
    if (outcomeConfig !== undefined &&
        outcomeConfig[sportId] !== undefined &&
        outcomeConfig[sportId][outcome.type] !== undefined) {
        func = outcomeConfig[sportId][outcome.type];
    }
    if (func === undefined) {
        return undefined;
    }
    return func(match, outcome);
}
export function getRateName(sportId, outcome, factorType, match) {
    var func;
    if (baseFactorNameConfig !== undefined &&
        baseFactorNameConfig[sportId] !== undefined &&
        baseFactorNameConfig[sportId][outcome.type] !== undefined) {
        func = baseFactorNameConfig[sportId][outcome.type][factorType];
    }
    if (func === undefined) {
        return undefined;
    }
    return func(match, outcome);
}
export function getPeriodName(sportId, periodId) {
    if (periodConfig !== undefined && periodConfig[sportId] !== undefined) {
        return periodConfig[sportId][periodId];
    }
    return undefined;
}



// WEBPACK FOOTER //
// ./src/localization/en.js